
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gnpwR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bznit = parcelRequire("bznit");


var $g0fSg = parcelRequire("g0fSg");





var $iFjll = parcelRequire("iFjll");










/* unhandledErrorCard-compiled.tsx generated by @compiled/babel-plugin v3.0.1 */ 



var $hekY6 = parcelRequire("hekY6");


var $lMGh1 = parcelRequire("lMGh1");


var $gjPL4 = parcelRequire("gjPL4");










const $027bbc48ae778b05$export$86b6c8e2cf41b115 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { isHidden: isHidden } = t0;
    const t1 = isHidden ? "none" : "block";
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
            style: {
                display: t1
            }
        }, "We couldn't load this content");
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ isHidden: isHidden })=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text, @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
        style: {
            display: isHidden ? 'none' : 'block'
        }
    }, "We couldn't load this content");


const $b78539ccaa0e3954$var$isPercentage = (value)=>/^\d+(\.\d+)?%$/.test(value);
const $b78539ccaa0e3954$var$shouldShowText = ({ width: width, height: height })=>{
    if ($b78539ccaa0e3954$var$isPercentage(width) || $b78539ccaa0e3954$var$isPercentage(height)) return false;
    return parseInt(width, 10) >= 240 && parseInt(height, 10) >= 90;
};
const $b78539ccaa0e3954$var$normalizeDimension = (value, defaultValue)=>{
    const sValue = value.toString();
    return $b78539ccaa0e3954$var$isPercentage(sValue) ? sValue : isNaN(parseInt(sValue, 10)) ? defaultValue + 'px' : parseInt(sValue, 10) + 'px';
};
const $b78539ccaa0e3954$var$getConvertedDimension = (dimensions)=>{
    const { width: width = (0, $gjPL4.defaultImageCardDimensions).width, height: height = (0, $gjPL4.defaultImageCardDimensions).height } = dimensions;
    return {
        width: $b78539ccaa0e3954$var$normalizeDimension(width, (0, $gjPL4.defaultImageCardDimensions).width),
        height: $b78539ccaa0e3954$var$normalizeDimension(height, (0, $gjPL4.defaultImageCardDimensions).height)
    };
};
const $b78539ccaa0e3954$var$wrapperStyle = null;
class $b78539ccaa0e3954$export$b5dd0a6175f5992c extends (0, $cozmU.Component) {
    render() {
        const { dimensions: dimensions = (0, $gjPL4.defaultImageCardDimensions), onClick: onClick } = this.props;
        const convertedDimensions = $b78539ccaa0e3954$var$getConvertedDimension(dimensions);
        const hideText = !$b78539ccaa0e3954$var$shouldShowText($b78539ccaa0e3954$var$getConvertedDimension(dimensions));
        return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        , {
            style: convertedDimensions,
            onClick: onClick,
            "data-testid": "unhandled-error-card",
            role: "none",
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXruDMqu _1UtDYzZpcK _0NUa3rN91d _1EqgXlN91d _0aFT5vbt8w _3zRROkmnOE _0csg4eDIqT"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            label: "Error",
            color: "var(--ds-icon-warning, #E06C00)",
            spacing: "spacious"
        }), /*#__PURE__*/ $cozmU.createElement((0, $027bbc48ae778b05$export$86b6c8e2cf41b115), {
            isHidden: hideText
        }));
    }
}


const $8b0de58eb17161f1$export$b5dd0a6175f5992c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78539ccaa0e3954$export$b5dd0a6175f5992c), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78539ccaa0e3954$export$b5dd0a6175f5992c), props);



var $lzgC6 = parcelRequire("lzgC6");


var $lvxKi = parcelRequire("lvxKi");

class $84497764a98478b6$var$WrappedMediaCardAnalyticsErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, info) {
        try {
            this.fireOperationalEvent(error, info);
        } catch (e) {}
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        const { dimensions: dimensions, children: children } = this.props;
        if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b0de58eb17161f1$export$b5dd0a6175f5992c), {
            dimensions: dimensions,
            onClick: this.handleOnClick
        });
        return children;
    }
    constructor(props){
        super(props);
        this.fireOperationalEvent = (error, info)=>{
            const { data: data = {}, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const payload = {
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'mediaCardRender',
                attributes: {
                    browserInfo: window?.navigator?.userAgent ? window.navigator.userAgent : 'unknown',
                    error: error,
                    info: info,
                    failReason: 'unexpected-error',
                    ...data
                }
            };
            (0, $lvxKi.fireMediaCardEvent)(payload, createAnalyticsEvent);
        };
        this.handleOnClick = (event)=>{
            try {
                this.props.onClick?.({
                    event: event
                });
            } catch (e) {}
        };
        this.state = {
            hasError: false
        };
    }
}
$84497764a98478b6$var$WrappedMediaCardAnalyticsErrorBoundary.displayName = 'MediaCardAnalyticsErrorBoundary';
const $84497764a98478b6$var$packageName = "platform-pkg";
const $84497764a98478b6$var$packageVersion = "0.0.0-use.local";
// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
const $84497764a98478b6$var$MediaCardAnalyticsErrorBoundary = (0, $iFjll.withMediaAnalyticsContext)({
    packageVersion: $84497764a98478b6$var$packageVersion,
    packageName: $84497764a98478b6$var$packageName,
    componentName: 'mediaCard',
    component: 'mediaCard'
})((0, $lzgC6.default)()($84497764a98478b6$var$WrappedMediaCardAnalyticsErrorBoundary));
var $84497764a98478b6$export$2e2bcd8739ae039 = $84497764a98478b6$var$MediaCardAnalyticsErrorBoundary;


parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");














var $9DHhW = parcelRequire("9DHhW");

const $aa8c518e523cf1f5$export$c933acb7b87e98e6 = '__mediaCardPerfState_asflkajsdflja';


const $d729b52366798f4f$export$70c58d75bd83664 = (newAnalyticsContext)=>{
    if (!window[0, $aa8c518e523cf1f5$export$c933acb7b87e98e6]) window[0, $aa8c518e523cf1f5$export$c933acb7b87e98e6] = {};
    window[0, $aa8c518e523cf1f5$export$c933acb7b87e98e6].mediaCardCreateAnalyticsEvent = newAnalyticsContext;
};



var $8lZ3h = parcelRequire("8lZ3h");


var $iDrrr = parcelRequire("iDrrr");


var $a33Aa = parcelRequire("a33Aa");

const $71b32c9ddbedd60e$export$bfd3887cc5350200 = (entry)=>({
        tcpHandshakeTime: {
            end: entry.connectEnd,
            start: entry.connectStart
        },
        dnsLookupTime: {
            end: entry.domainLookupEnd,
            start: entry.domainLookupStart
        },
        redirectTimeTaken: {
            end: entry.redirectEnd,
            start: entry.redirectStart
        },
        tlsConnectNegotiationTime: {
            end: entry.requestStart,
            start: entry.secureConnectionStart
        },
        timeTakenToFetchWithoutRedirect: {
            end: entry.responseEnd,
            start: entry.fetchStart
        },
        /**
   * `interimRequestTime` represents the entire time the browser took to
   * request the resource from the server. This includes the interim response time
   * (for example, 100 Continue or 103 Early Hints).
   *
   * i.e. It is the time taken for the request to be sent
   * + the waiting time for the server to send a response
   *
   * Please, note that this value
   * is distinctly different from the aforementioned document.
   */ interimRequestTime: {
            end: entry.responseStart,
            start: entry.requestStart
        },
        /**
   * `requestInvocationTime` represents the actual time the browser took to request
   * the resource from the server (i.e. it does not include the interim reponse
   * time).
   * NOTE: it relies on an experimental feature (`firstInterimResponseStart`) that is
   * available in Chrome, but not in FireFox or Safari. This value will be undefined
   * when `firstInterimResponseStart` is unavailable.
   */ requestInvocationTime: entry.firstInterimResponseStart ? {
            end: entry.firstInterimResponseStart,
            start: entry.requestStart
        } : undefined,
        /**
   * `contentDownloadTime` represents the time taken for the browser to receive
   * the resource from the server. This may be cut short if the transport
   * connection is closed.
   */ contentDownloadTime: {
            end: entry.responseEnd,
            start: entry.responseStart
        }
    });


const $0333d52544d187a7$var$getStartedAt = (entry, interactionStartTime)=>entry.startTime - interactionStartTime;
const $0333d52544d187a7$var$calculateCommonDurations = (metrics)=>Object.fromEntries(Object.entries(metrics).map(([key, marks])=>{
        if (!marks) return [
            key,
            undefined
        ];
        const { start: start, end: end } = marks;
        return [
            key,
            end - start
        ];
    }));
const $0333d52544d187a7$export$b22670df0917866e = (entry, interactionStartTime)=>{
    return {
        startedAt: $0333d52544d187a7$var$getStartedAt(entry, interactionStartTime),
        /**
     * Performance resource timing data regarding the loading of an
     * application's resources as described in
     * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
     */ transferSize: entry.transferSize,
        decodedBodySize: entry.decodedBodySize,
        totalDuration: entry.duration,
        initiatorType: entry.initiatorType,
        // value can be 'fetch' or 'img'
        endedAt: entry.responseEnd - interactionStartTime,
        responseEnd: entry.responseEnd,
        browserCacheHit: entry.transferSize === 0,
        nextHopProtocol: entry.nextHopProtocol,
        ...$0333d52544d187a7$var$calculateCommonDurations((0, $71b32c9ddbedd60e$export$bfd3887cc5350200)(entry)),
        /**
     * The user agent string for the current browser
     * Read more: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgent
     */ userAgent: window.navigator.userAgent,
        /**
     * Performance resource timing data sent by the server. This includes:
     *
     * `cdnCacheHit` is a boolean determining whether the CDN cache was hit or missed.
     *
     * `cdnDownstreamFBL` is the 'CDN Downstream First Byte Latency'. It represents
     * how long the it took the CDN to respond to the frontend.
     *
     * `cdnUpstreamFBL` is the 'CDN Upstream First Byte Latency'. It represents the
     * time the Media backend took to respond to the CDN, in the case that the CDN
     * cache was a miss. Notably, this timing is a subset of the `cdnDownstreamFBL` timing.
     */ cdnCacheHit: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-cache-hit';
        }) ? true : false,
        cdnDownstreamFBL: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-downstream-fbl';
        })?.duration,
        cdnUpstreamFBL: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-upstream-fbl';
        })?.duration
    };
};



const $e729f54a827f90bd$var$filterCommonMetrics = (metrics)=>Object.fromEntries(Object.entries(metrics).filter(([, marks])=>!!marks));
const $e729f54a827f90bd$export$45a6f341f1a26a5d = (entry, interactionStartTime)=>{
    // Calculate timing relative to UFO interaction start time
    // For page_load: interactionStartTime = 0 (relative to page navigation)
    // For transitions: interactionStartTime = performance.now() when transition started
    // This ensures metrics work correctly for both initial loads and SPA soft redirects
    const relativeStartTime = entry.startTime - interactionStartTime;
    return {
        resourceTiming: {
            start: relativeStartTime,
            end: entry.responseEnd,
            size: entry.transferSize
        },
        ...$e729f54a827f90bd$var$filterCommonMetrics((0, $71b32c9ddbedd60e$export$bfd3887cc5350200)(entry))
    };
};






const $453299aec8f18e9d$var$mediaLabelStack = [
    {
        name: 'media'
    }
];
const $453299aec8f18e9d$export$be8beb5937d1436e = (ufoDurationMetrics, endpoint)=>{
    const labelStack = [
        ...$453299aec8f18e9d$var$mediaLabelStack,
        {
            name: endpoint
        }
    ];
    Object.entries(ufoDurationMetrics).map(([name, { start: start, end: end, size: size }])=>{
        (0, $a33Aa.addCustomSpans)(name, start, end, size, labelStack);
    });
};


// this should fire around 10% of the time
const $259d2a177a7c7a3c$var$shouldSamplePerfObserver = ()=>Math.random() < 0.1;
const $259d2a177a7c7a3c$var$urlRegex = /(?:https:\/\/(?:media\.(?:dev|staging|prod)\.atl-paas\.net|api\.media\.atlassian\.com|media-cdn(?:\.stg\.|\.)atlassian\.com)\/|media-api\/)file\/([^/]+)\/image.*[?&]source=mediaCard/;
const $259d2a177a7c7a3c$var$clientIdParamRegex = /[?&]clientId=([^&]+)/;
const $259d2a177a7c7a3c$var$ssrParamRegex = /[?&]token=([^&]+)/;
const $259d2a177a7c7a3c$var$createAndGetResourceObserver = ()=>{
    return new PerformanceObserver((list)=>{
        list.getEntries().forEach((baseEntry)=>{
            const entry = baseEntry;
            const matchFileId = entry.name.match($259d2a177a7c7a3c$var$urlRegex);
            const matchClientId = entry.name.match($259d2a177a7c7a3c$var$clientIdParamRegex);
            const matchSSR = entry.name.match($259d2a177a7c7a3c$var$ssrParamRegex);
            const state = window[0, $aa8c518e523cf1f5$export$c933acb7b87e98e6];
            if (matchFileId && state?.mediaCardCreateAnalyticsEvent) {
                const fileId = matchFileId[1];
                const clientId = matchClientId?.[1];
                const ssr = matchSSR ? 'server' : undefined;
                // Get UFO interaction start time for proper timing in SPAs
                // For page_load: start = 0 (relative to page navigation)
                // For transitions: start = performance.now() when transition started
                const interaction = (0, $a33Aa.getActiveInteraction)();
                const interactionStartTime = interaction?.start ?? 0;
                const mediaDurationMetrics = (0, $0333d52544d187a7$export$b22670df0917866e)(entry, interactionStartTime);
                const event = state.mediaCardCreateAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'mediaCardPerfObserver',
                    attributes: {
                        ssr: ssr,
                        fileId: fileId,
                        mediaClientId: clientId,
                        featureFlags: {
                            'media-perf-lazy-loading-optimisation': (0, $iDrrr.fg)('media-perf-lazy-loading-optimisation')
                        },
                        ...mediaDurationMetrics
                    }
                });
                if ($259d2a177a7c7a3c$var$shouldSamplePerfObserver()) event.fire((0, $8lZ3h.ANALYTICS_MEDIA_CHANNEL));
                if ((0, $iDrrr.fg)('platform_media_card_ufo_network_metrics')) {
                    const ufoDurationMetrics = (0, $e729f54a827f90bd$export$45a6f341f1a26a5d)(entry, interactionStartTime);
                    const endpointName = 'image';
                    (0, $453299aec8f18e9d$export$be8beb5937d1436e)(ufoDurationMetrics, endpointName);
                }
            }
        });
    });
};
const $259d2a177a7c7a3c$var$isDefinedPerformanceObserver = ()=>typeof window['PerformanceObserver'] !== 'undefined';
const $259d2a177a7c7a3c$export$8840d7cbe19419a0 = ()=>{
    if (!$259d2a177a7c7a3c$var$isDefinedPerformanceObserver()) return;
    if (window[0, $aa8c518e523cf1f5$export$c933acb7b87e98e6]?.mediaCardPerfObserver) return;
    if (!window[0, $aa8c518e523cf1f5$export$c933acb7b87e98e6]) window[0, $aa8c518e523cf1f5$export$c933acb7b87e98e6] = {};
    window[0, $aa8c518e523cf1f5$export$c933acb7b87e98e6].mediaCardPerfObserver = $259d2a177a7c7a3c$var$createAndGetResourceObserver();
    window[0, $aa8c518e523cf1f5$export$c933acb7b87e98e6].mediaCardPerfObserver.observe({
        type: 'resource',
        buffered: true
    });
};















var $jmmTp = parcelRequire("jmmTp");


var $6H0Pg = parcelRequire("6H0Pg");





var $9kbTQ = parcelRequire("9kbTQ");





var $hfrng = parcelRequire("hfrng");


var $8396x = parcelRequire("8396x");


var $1tBud = parcelRequire("1tBud");

const $f0b215598f82e391$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};



var $lE37M = parcelRequire("lE37M");

class $9e7b33a0432dcdec$export$d0a45ab59b4606b extends (0, $lE37M.MediaCardError) {
    constructor(source){
        super((0, $f0b215598f82e391$export$921ab4548acefaa4)(source));
    }
}





const $38fd8c5619b38c8c$export$48da330df5248c4c = ()=>{
    return (performance.now().toString(36) + Math.random().toString(36)).replace(/\./g, '');
};


/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * Entry Point: @atlaskit/media-card/types
 */ 



var $8b234217acbfa94e$export$2abd8762d023dc4c = /*#__PURE__*/ function(MediaCardCursor) {
    MediaCardCursor["Action"] = "pointer";
    MediaCardCursor["NotReady"] = "wait";
    return MediaCardCursor;
}({});


const $79c9f6957b6516ad$export$c364ca3a4cf16be0 = (useInlinePlayer, useMediaViewer, isErrorStatus, hasCardPreview, mediaType)=>{
    // If error status or no action is requested = NoAction
    if (isErrorStatus || !useInlinePlayer && !useMediaViewer) return;
    if (!mediaType && (useInlinePlayer || useInlinePlayer && useMediaViewer)) return (0, $8b234217acbfa94e$export$2abd8762d023dc4c).NotReady;
    else if (mediaType === 'video' && hasCardPreview && useInlinePlayer) return (0, $8b234217acbfa94e$export$2abd8762d023dc4c).Action;
    if (useMediaViewer) return (0, $8b234217acbfa94e$export$2abd8762d023dc4c).Action;
    return;
};


const $4603370344b0d7ea$export$a133018935bd25fc = (event)=>{
    // Ignore focus moving between elements inside the same element.
    if (event.currentTarget.contains(event.relatedTarget)) return false;
    try {
        if (!event.target.matches(':focus-visible')) return false;
    } catch  {
    // Ignore errors from environments that don't support :focus-visible.
    }
    return true;
};






var $gVALF = parcelRequire("gVALF");

var $cFc8s = parcelRequire("cFc8s");


var $c2smn = parcelRequire("c2smn");


var $l7Nkn = parcelRequire("l7Nkn");





var $fh15z = parcelRequire("fh15z");


var $cNAch = parcelRequire("cNAch");


var $j7Sza = parcelRequire("j7Sza");


var $4MiWC = parcelRequire("4MiWC");





var $5WRnQ = parcelRequire("5WRnQ");


var $1wzQC = parcelRequire("1wzQC");

const $c13d552137c78450$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};


function $cda65197d9d03db0$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}


const $b1777cf9f57cea43$var$packageName = "platform-pkg";
const $b1777cf9f57cea43$var$packageVersion = "0.0.0-use.local";
const $b1777cf9f57cea43$var$SAMPLE_RATE = 0.05;
const $b1777cf9f57cea43$export$b21c64f4f93d10f4 = ()=>Math.random() < $b1777cf9f57cea43$var$SAMPLE_RATE;
/**
 * Gets the UFO interaction start time.
 * For page_load: returns 0 (relative to page navigation)
 * For SPA transitions: returns performance.now() when transition started
 */ const $b1777cf9f57cea43$var$getInteractionStartTime = ()=>{
    const interaction = (0, $a33Aa.getActiveInteraction)();
    return interaction?.start ?? 0;
};
/**
 * Finds a performance resource timing entry by matching a full URI.
 * Searches from the end (most recent) to find the latest matching entry.
 */ const $b1777cf9f57cea43$var$findPerformanceEntryByName = (name)=>{
    if (typeof performance === 'undefined' || !performance.getEntriesByType) return undefined;
    // For data URIs (base64), there won't be a performance entry
    if (name.startsWith('data:')) return undefined;
    const entries = performance.getEntriesByType('resource');
    const ssrPerformanceEntries = (0, $cda65197d9d03db0$export$96a3cfb3a41e9bb2)().performanceEntries ?? [];
    return [
        ...ssrPerformanceEntries,
        ...entries
    ].find((entry)=>name.includes(entry.name));
};
/**
 * Creates timing configuration for the UFO experience based on the performance entry.
 * These timings will be calculated by UFO using the marks we add.
 */ const $b1777cf9f57cea43$var$createTimingsConfig = (prefix)=>[
        {
            key: `${prefix}:resourceTiming`,
            startMark: `${prefix}:resourceTiming:start`,
            endMark: `${prefix}:resourceTiming:end`
        },
        {
            key: `${prefix}:dnsLookup`,
            startMark: `${prefix}:dnsLookup:start`,
            endMark: `${prefix}:dnsLookup:end`
        },
        {
            key: `${prefix}:tcpHandshake`,
            startMark: `${prefix}:tcpHandshake:start`,
            endMark: `${prefix}:tcpHandshake:end`
        },
        {
            key: `${prefix}:tlsNegotiation`,
            startMark: `${prefix}:tlsNegotiation:start`,
            endMark: `${prefix}:tlsNegotiation:end`
        },
        {
            key: `${prefix}:ttfb`,
            startMark: `${prefix}:ttfb:start`,
            endMark: `${prefix}:ttfb:end`
        },
        {
            key: `${prefix}:contentDownload`,
            startMark: `${prefix}:contentDownload:start`,
            endMark: `${prefix}:contentDownload:end`
        },
        {
            key: `${prefix}:redirect`,
            startMark: `${prefix}:redirect:start`,
            endMark: `${prefix}:redirect:end`
        },
        {
            key: `${prefix}:fetchTime`,
            startMark: `${prefix}:fetchTime:start`,
            endMark: `${prefix}:fetchTime:end`
        }
    ];
/**
 * Creates resource timing metadata from a performance entry.
 * Only includes non-timing information (sizes, cache status, protocol, CDN info).
 * Timing durations are captured via marks which feed into the timings config.
 */ const $b1777cf9f57cea43$var$createResourceTimingMetadata = (entry)=>{
    return {
        // Size information
        resourceTransferSize: entry.transferSize,
        resourceDecodedBodySize: entry.decodedBodySize,
        // Request info
        resourceInitiatorType: entry.initiatorType,
        resourceNextHopProtocol: entry.nextHopProtocol,
        // Cache status
        resourceBrowserCacheHit: entry.transferSize === 0,
        // Server timing (CDN metrics)
        resourceCdnCacheHit: entry.serverTiming?.some(({ name: name })=>name === 'cdn-cache-hit') ?? false,
        resourceCdnDownstreamFBL: entry.serverTiming?.find(({ name: name })=>name === 'cdn-downstream-fbl')?.duration,
        resourceCdnUpstreamFBL: entry.serverTiming?.find(({ name: name })=>name === 'cdn-upstream-fbl')?.duration
    };
};
/**
 * Adds timing marks from a performance resource timing entry to the UFO experience.
 */ const $b1777cf9f57cea43$var$addResourceTimingMarks = (experience, entry, interactionStartTime, prefix)=>{
    const addMark = (name, start, end)=>{
        const relativeStart = start - interactionStartTime;
        const relativeEnd = end - interactionStartTime;
        if (relativeEnd > relativeStart && relativeStart >= 0) {
            experience.mark(`${prefix}:${name}:start`, relativeStart);
            experience.mark(`${prefix}:${name}:end`, relativeEnd);
        }
    };
    // Overall resource timing
    addMark('resourceTiming', entry.startTime, entry.responseEnd);
    // DNS lookup
    addMark('dnsLookup', entry.domainLookupStart, entry.domainLookupEnd);
    // TCP handshake
    addMark('tcpHandshake', entry.connectStart, entry.connectEnd);
    // TLS negotiation (only for HTTPS)
    if (entry.secureConnectionStart > 0) addMark('tlsNegotiation', entry.secureConnectionStart, entry.requestStart);
    // Request to first byte (TTFB)
    addMark('ttfb', entry.requestStart, entry.responseStart);
    // Content download
    addMark('contentDownload', entry.responseStart, entry.responseEnd);
    // Redirect time (if any)
    if (entry.redirectStart > 0 && entry.redirectEnd > 0) addMark('redirect', entry.redirectStart, entry.redirectEnd);
    // Total fetch time (without redirect) - from fetchStart to responseEnd
    addMark('fetchTime', entry.fetchStart, entry.responseEnd);
};
const $b1777cf9f57cea43$var$sanitiseFileAttributes = (fileAttributes)=>{
    let sanitisedFileId = 'INVALID_FILE_ID';
    if (fileAttributes.fileId === 'external-image' || (0, $l7Nkn.isValidUuid)(fileAttributes.fileId)) sanitisedFileId = fileAttributes.fileId;
    return {
        ...fileAttributes,
        fileId: sanitisedFileId
    };
};
const $b1777cf9f57cea43$var$getBasePayloadAttributes = ()=>({
        packageName: $b1777cf9f57cea43$var$packageName,
        packageVersion: $b1777cf9f57cea43$var$packageVersion,
        mediaEnvironment: (0, $gVALF.getMediaEnvironment)(),
        mediaRegion: (0, $cFc8s.getMediaRegion)()
    });
/**
 * Creates a new UFO experience instance with the given configuration.
 */ const $b1777cf9f57cea43$var$createExperience = (instanceId, timings = [])=>{
    return new (0, $cNAch.UFOExperience)('media-card-render', {
        platform: {
            component: 'media-card'
        },
        type: (0, $4MiWC.ExperienceTypes).Experience,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
        featureFlags: (0, $c2smn.getFeatureFlagKeysAllProducts)(),
        timings: timings
    }, instanceId);
};
const $b1777cf9f57cea43$export$a42e845f664e6373 = ({ instanceId: instanceId, enabled: enabled })=>{
    // Store the start time when start() is called - experience creation is deferred to complete()
    const startTimeRef = (0, $cozmU.useRef)(undefined);
    const hasStartedRef = (0, $cozmU.useRef)(false);
    // Store the experience so abort() can use it after complete() has run
    const experienceRef = (0, $cozmU.useRef)(null);
    // Reset refs when instanceId changes (new card instance)
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // Note: Don't clear experienceRef here as abort() might still need it
            // The component's cleanup calls abort() which handles final state
            hasStartedRef.current = false;
            startTimeRef.current = undefined;
        };
    }, [
        instanceId
    ]);
    const start = (0, $cozmU.useCallback)((options)=>{
        if (!enabled) return;
        // Store the start time - experience will be created in complete()
        // This allows us to have the correct timings config when creating the experience
        hasStartedRef.current = true;
        startTimeRef.current = options?.useInteractionTime ? $b1777cf9f57cea43$var$getInteractionStartTime() : performance.now();
    }, [
        enabled
    ]);
    const complete = (0, $cozmU.useCallback)((status, fileAttributes, fileStateFlags, ssrReliability, error = new (0, $lE37M.MediaCardError)('missing-error-data'), ssrPreviewInfo)=>{
        // Only complete for terminal statuses - ignore intermediate statuses like 'loading-preview'
        if (![
            'complete',
            'error',
            'failed-processing'
        ].includes(status)) return;
        if (!enabled || !hasStartedRef.current) return;
        const interactionStartTime = $b1777cf9f57cea43$var$getInteractionStartTime();
        // Determine timings config based on SSR status
        let timingsConfig = [];
        let resourceTimingEntry;
        if (ssrPreviewInfo?.wasSSRSuccessful && ssrPreviewInfo.dataUri) {
            resourceTimingEntry = $b1777cf9f57cea43$var$findPerformanceEntryByName(ssrPreviewInfo.srcset ?? ssrPreviewInfo.dataUri);
            if (resourceTimingEntry) timingsConfig = $b1777cf9f57cea43$var$createTimingsConfig('ssr');
        }
        // Create the experience with the correct timings config
        const experience = $b1777cf9f57cea43$var$createExperience(instanceId, timingsConfig);
        experienceRef.current = experience;
        experience.start(startTimeRef.current);
        let endTime = performance.now();
        // Add timing marks and metadata based on strategy
        if (ssrPreviewInfo?.wasSSRSuccessful && ssrPreviewInfo.dataUri) {
            if (resourceTimingEntry) {
                endTime = resourceTimingEntry.responseEnd;
                $b1777cf9f57cea43$var$addResourceTimingMarks(experience, resourceTimingEntry, interactionStartTime, 'ssr');
                experience.addMetadata({
                    ...$b1777cf9f57cea43$var$createResourceTimingMetadata(resourceTimingEntry),
                    timingStrategy: 'ssr-resource-timing'
                });
            } else experience.addMetadata({
                timingStrategy: 'ssr-no-entry-found'
            });
        } else if (ssrPreviewInfo?.wasSSRAttempted) {
            // Strategy 2: SSR was attempted but failed - use interaction start time
            experience.addMetadata({
                timingStrategy: 'ssr-failed',
                interactionStartTime: interactionStartTime
            });
            experience.mark('interactionStart', 0);
        } else // Strategy 3: No SSR - CSR mount-based behavior
        experience.addMetadata({
            timingStrategy: 'csr-mount-based'
        });
        // Complete the experience with appropriate state
        const sanitisedFileAttributes = $b1777cf9f57cea43$var$sanitiseFileAttributes(fileAttributes);
        switch(status){
            case 'complete':
                experience.addMetadata({
                    fileAttributes: sanitisedFileAttributes,
                    ssrReliability: ssrReliability,
                    fileStateFlags: fileStateFlags,
                    ...$b1777cf9f57cea43$var$getBasePayloadAttributes()
                });
                experience.transition((0, $j7Sza.UFOExperienceState).SUCCEEDED, endTime);
                break;
            case 'failed-processing':
                experience.failure({
                    metadata: {
                        fileAttributes: sanitisedFileAttributes,
                        ssrReliability: ssrReliability,
                        fileStateFlags: fileStateFlags,
                        failReason: 'failed-processing',
                        ...$b1777cf9f57cea43$var$getBasePayloadAttributes()
                    }
                });
                break;
            case 'error':
                experience.failure({
                    metadata: {
                        fileAttributes: sanitisedFileAttributes,
                        ssrReliability: ssrReliability,
                        fileStateFlags: fileStateFlags,
                        ...(0, $5WRnQ.extractErrorInfo)(error),
                        request: (0, $c13d552137c78450$export$1a2ec9b4a3a99d5e)(error),
                        ...$b1777cf9f57cea43$var$getBasePayloadAttributes()
                    }
                });
                break;
        }
        // Reset state after completion
        hasStartedRef.current = false;
        startTimeRef.current = undefined;
    }, [
        enabled,
        instanceId
    ]);
    const abort = (0, $cozmU.useCallback)((properties)=>{
        if (!enabled) return;
        // Use existing experience if available (created by complete()),
        // otherwise create new one if experience was started but not completed
        let experience_0 = experienceRef.current;
        if (!experience_0) {
            if (!hasStartedRef.current) return;
            experience_0 = $b1777cf9f57cea43$var$createExperience(instanceId);
            experienceRef.current = experience_0;
            experience_0.start(startTimeRef.current);
        }
        const metadata = {
            ...$b1777cf9f57cea43$var$getBasePayloadAttributes()
        };
        if (properties?.fileAttributes) metadata.fileAttributes = $b1777cf9f57cea43$var$sanitiseFileAttributes(properties.fileAttributes);
        if (properties?.fileStateFlags) metadata.fileStateFlags = properties.fileStateFlags;
        if (properties?.ssrReliability) metadata.ssrReliability = properties.ssrReliability;
        // UFO will ignore abort if experience is already in final state
        experience_0.abort({
            metadata: metadata
        });
        // Reset state after abort
        hasStartedRef.current = false;
        startTimeRef.current = undefined;
    }, [
        enabled,
        instanceId
    ]);
    return (0, $cozmU.useMemo)(()=>({
            start: start,
            complete: complete,
            abort: abort
        }), [
        start,
        complete,
        abort
    ]);
};
// ============================================================================
// Legacy exports for backwards compatibility
// These will be removed once all consumers are migrated to the hook
// ============================================================================
let $b1777cf9f57cea43$var$concurrentExperience;
const $b1777cf9f57cea43$var$getExperience = (id)=>{
    if (!$b1777cf9f57cea43$var$concurrentExperience) {
        const inlineExperience = {
            platform: {
                component: 'media-card'
            },
            type: (0, $4MiWC.ExperienceTypes).Experience,
            performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
            featureFlags: (0, $c2smn.getFeatureFlagKeysAllProducts)()
        };
        $b1777cf9f57cea43$var$concurrentExperience = new (0, $fh15z.ConcurrentExperience)('media-card-render', inlineExperience);
    }
    return $b1777cf9f57cea43$var$concurrentExperience.getInstance(id);
};
const $b1777cf9f57cea43$export$5e9287b6a10f8075 = (id, startTime)=>{
    $b1777cf9f57cea43$var$getExperience(id).start(startTime);
};
const $b1777cf9f57cea43$export$9d46b54f7b0bb11a = (id, status, fileAttributes, fileStateFlags, ssrReliability, error = new (0, $lE37M.MediaCardError)('missing-error-data'), ssrPreviewInfo)=>{
    // Only complete for terminal statuses - ignore intermediate statuses like 'loading-preview'
    if (![
        'complete',
        'error',
        'failed-processing'
    ].includes(status)) return;
    const experience = $b1777cf9f57cea43$var$getExperience(id);
    const interactionStartTime = $b1777cf9f57cea43$var$getInteractionStartTime();
    // Determine timing strategy based on SSR status
    if (ssrPreviewInfo?.wasSSRSuccessful && ssrPreviewInfo.dataUri) {
        const entry = $b1777cf9f57cea43$var$findPerformanceEntryByName(ssrPreviewInfo.srcset ?? ssrPreviewInfo.dataUri);
        if (entry) {
            $b1777cf9f57cea43$var$addResourceTimingMarks(experience, entry, interactionStartTime, 'ssr');
            experience.addMetadata({
                ...$b1777cf9f57cea43$var$createResourceTimingMetadata(entry),
                timingStrategy: 'ssr-resource-timing'
            });
        } else experience.addMetadata({
            timingStrategy: 'ssr-no-entry-found'
        });
    } else if (ssrPreviewInfo?.wasSSRAttempted) {
        experience.addMetadata({
            timingStrategy: 'ssr-failed',
            interactionStartTime: interactionStartTime
        });
        experience.mark('interactionStart', 0);
    } else experience.addMetadata({
        timingStrategy: 'csr-mount-based'
    });
    const sanitisedFileAttributes = $b1777cf9f57cea43$var$sanitiseFileAttributes(fileAttributes);
    switch(status){
        case 'complete':
            experience.success({
                metadata: {
                    fileAttributes: sanitisedFileAttributes,
                    ssrReliability: ssrReliability,
                    fileStateFlags: fileStateFlags,
                    ...$b1777cf9f57cea43$var$getBasePayloadAttributes()
                }
            });
            break;
        case 'failed-processing':
            experience.failure({
                metadata: {
                    fileAttributes: sanitisedFileAttributes,
                    ssrReliability: ssrReliability,
                    fileStateFlags: fileStateFlags,
                    failReason: 'failed-processing',
                    ...$b1777cf9f57cea43$var$getBasePayloadAttributes()
                }
            });
            break;
        case 'error':
            experience.failure({
                metadata: {
                    fileAttributes: sanitisedFileAttributes,
                    ssrReliability: ssrReliability,
                    fileStateFlags: fileStateFlags,
                    ...(0, $5WRnQ.extractErrorInfo)(error),
                    request: (0, $c13d552137c78450$export$1a2ec9b4a3a99d5e)(error),
                    ...$b1777cf9f57cea43$var$getBasePayloadAttributes()
                }
            });
            break;
    }
};
const $b1777cf9f57cea43$export$b1021040eb94cdca = (id, properties)=>{
    const metadata = {
        ...$b1777cf9f57cea43$var$getBasePayloadAttributes()
    };
    if (properties?.fileAttributes) metadata.fileAttributes = $b1777cf9f57cea43$var$sanitiseFileAttributes(properties.fileAttributes);
    if (properties?.fileStateFlags) metadata.fileStateFlags = properties.fileStateFlags;
    if (properties?.ssrReliability) metadata.ssrReliability = properties.ssrReliability;
    $b1777cf9f57cea43$var$getExperience(id).abort({
        metadata: metadata
    });
};





function $5442f05c22e04adc$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}





function $5912457c5c879fd6$export$5cae361ad82dce8b(value) {
    const ref = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}















var $2VwyL = parcelRequire("2VwyL");








var $fA65V = parcelRequire("fA65V");


var $6xGZY = parcelRequire("6xGZY");





var $lfoFx = parcelRequire("lfoFx");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");

const $401e23545d820d5c$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';



var $2iGHk = parcelRequire("2iGHk");




var $2rEyz = parcelRequire("2rEyz");

const $2cb47daccc3b7ffc$export$4d33ada3618f7626 = (payload)=>{
    return (0, $2iGHk.default)((0, $8lZ3h.ANALYTICS_MEDIA_CHANNEL))((0, $2rEyz.sanitiseAnalyticsPayload)(payload));
};





function $4138ebdf60975a3f$export$476aa014e2fd89d5(error) {
    if (!error) return false;
    const { secondaryError: secondaryError } = error;
    // Check if secondaryError is directly a TypeError (fetch API throws TypeError for network errors)
    if (secondaryError instanceof TypeError) return true;
    // Check if secondaryError is a CommonMediaClientError with nested TypeError in innerError
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError) && secondaryError.innerError instanceof TypeError) return true;
    return false;
}















const $41681b111635fa1d$var$overlayStyles = null;
const $41681b111635fa1d$var$backgroundStyles = {
    blanket: "_0KLXruA5lS",
    sunken: "_0KLXrunmFW"
};
const $41681b111635fa1d$var$progressBarTrackStyles = null;
const $41681b111635fa1d$var$RAINBOW_TRAIN_COLORS = [
    "var(--ds-chart-categorical-4, #F68909)",
    // orange
    "var(--ds-chart-categorical-2, #82B536)",
    // green
    "var(--ds-chart-categorical-1, #357DE8)",
    // blue
    "var(--ds-chart-categorical-3, #BF63F3)" // purple
];
const $41681b111635fa1d$var$slideKeyframes = null;
const $41681b111635fa1d$var$trainStyles = null;
const $41681b111635fa1d$var$trainBlockStyles = null;
const $41681b111635fa1d$export$dadfe5b5cfcd2b0e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AIGeneratingOverlay(t0) {
    const $ = (0, $bDgLe.c)(10);
    const { label: label, testId: testId, isOpaque: isOpaque } = t0;
    const t1 = testId ?? "ai-generating-overlay";
    const t2 = $41681b111635fa1d$var$backgroundStyles[isOpaque ? "sunken" : "blanket"];
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLz9WS _37wbyuDIqT _0xmtko8HPE _1pp6NdIZbP _42Yu6BcFV1",
            t2
        ]);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _39xV02wOVE _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu"
        ]);
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "ai-generating-overlay-train",
            className: (0, $hekY6.default)([
                "_2fBhtebLMY _3iDTPbQ4SZ _1mT5xdWVPG _2IhTondnbC _0jFU0VN91d"
            ])
        }, $41681b111635fa1d$var$RAINBOW_TRAIN_COLORS.map($41681b111635fa1d$var$_temp));
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== label) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "progressbar",
            "aria-label": label,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "data-testid": "ai-generating-overlay-progress-bar",
            className: t4
        }, t5);
        $[4] = label;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t1 || $[7] !== t3 || $[8] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": t1,
            role: "presentation",
            className: t3
        }, t6);
        $[6] = t1;
        $[7] = t3;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    return t7;
} : function AIGeneratingOverlay({ label: label, testId: testId, isOpaque: isOpaque }) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId ?? 'ai-generating-overlay',
        role: "presentation",
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLz9WS _37wbyuDIqT _0xmtko8HPE _1pp6NdIZbP _42Yu6BcFV1",
            $41681b111635fa1d$var$backgroundStyles[isOpaque ? 'sunken' : 'blanket']
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        role: "progressbar",
        "aria-label": label,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "data-testid": "ai-generating-overlay-progress-bar",
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _39xV02wOVE _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "ai-generating-overlay-train",
        className: (0, $hekY6.default)([
            "_2fBhtebLMY _3iDTPbQ4SZ _1mT5xdWVPG _2IhTondnbC _0jFU0VN91d"
        ])
    }, $41681b111635fa1d$var$RAINBOW_TRAIN_COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: color,
            "data-testid": "ai-generating-overlay-train-block",
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
            ])
        })))));
};
function $41681b111635fa1d$var$_temp(color) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        key: color,
        "data-testid": "ai-generating-overlay-train-block",
        style: {
            backgroundColor: color
        },
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
        ])
    });
}



var $cOUnF = parcelRequire("cOUnF");


























var $7va5E = parcelRequire("7va5E");


var $gZ5vW = parcelRequire("gZ5vW");




const $80932b01d7b6e721$export$56f32e61c4316384 = (imgElement, parentElement, resizeMode)=>{
    const { naturalWidth: naturalWidth, width: width, naturalHeight: naturalHeight, height: height } = imgElement;
    // Firefox & Safari can't always read the "natural" dimensions correctly.
    // When these are undefined or zero, we replace them with the rendered values
    const imgWidth = naturalWidth || width;
    const imgHeight = naturalHeight || height;
    const { width: parentWidth, height: parentHeight } = parentElement.getBoundingClientRect();
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `min(100%, ${imgWidth}px)`,
        maxHeight: `min(100%, ${imgHeight}px)`
    };
    const imgRatio = imgWidth / imgHeight;
    const cardRatio = parentWidth / parentHeight;
    const isImageLandscapier = imgRatio > cardRatio;
    if (resizeMode === 'stretchy-fit') {
        if (isImageLandscapier) return {
            width: '100%',
            maxHeight: '100%'
        };
        else return {
            height: '100%',
            maxWidth: '100%'
        };
    }
    if (resizeMode === 'crop') {
        if (isImageLandscapier) return {
            height: imgHeight,
            maxHeight: '100%'
        };
        else return {
            width: imgWidth,
            maxWidth: '100%'
        };
    }
    return {};
};


const $f988d92ee1d2ecf2$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $f988d92ee1d2ecf2$var$svgRendererBaseStyles = null;
const $f988d92ee1d2ecf2$var$svgRendererWhiteBgStyles = null;
const $f988d92ee1d2ecf2$var$svgRendererMaxDimensionStyles = null;
const $f988d92ee1d2ecf2$export$cf98b60e5f1e2515 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt, backgroundColor: backgroundColor } = t0;
    const [didSvgRender, setDidSvgRender] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [svgDimensions, setSvgDimensions] = (0, $cozmU.useState)(t1);
    const imgRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[1] !== resizeMode || $[2] !== wrapperRef) {
        t2 = (targetImgElem)=>{
            if (!wrapperRef.current || !targetImgElem) return;
            setSvgDimensions((0, $80932b01d7b6e721$export$56f32e61c4316384)(targetImgElem, wrapperRef.current, resizeMode));
        };
        $[1] = resizeMode;
        $[2] = wrapperRef;
        $[3] = t2;
    } else t2 = $[3];
    const calculateDimensions = t2;
    let t3;
    if ($[4] !== calculateDimensions || $[5] !== onLoad) {
        t3 = (evt)=>{
            calculateDimensions(evt.currentTarget);
            setDidSvgRender(true);
            onLoad?.();
        };
        $[4] = calculateDimensions;
        $[5] = onLoad;
        $[6] = t3;
    } else t3 = $[6];
    const onSvgLoad = t3;
    let t4;
    if ($[7] !== onError) {
        t4 = (err)=>{
            const error = new (0, $lE37M.MediaCardError)($f988d92ee1d2ecf2$var$getErrorReason(err.primaryReason), err.secondaryError);
            onError?.(error);
        };
        $[7] = onError;
        $[8] = t4;
    } else t4 = $[8];
    const onSvgError = t4;
    let t5;
    let t6;
    if ($[9] !== calculateDimensions) {
        t5 = ()=>{
            if (imgRef.current) calculateDimensions(imgRef.current);
        };
        t6 = [
            imgRef,
            calculateDimensions
        ];
        $[9] = calculateDimensions;
        $[10] = t5;
        $[11] = t6;
    } else {
        t5 = $[10];
        t6 = $[11];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const { svgUrl: svgUrl, source: source } = (0, $gZ5vW.useResolveSvg)(identifier, onSvgError);
    const { width: width, height: height } = svgDimensions;
    let t7;
    if ($[12] !== alt || $[13] !== backgroundColor || $[14] !== didSvgRender || $[15] !== height || $[16] !== identifier || $[17] !== onSvgError || $[18] !== onSvgLoad || $[19] !== source || $[20] !== svgDimensions || $[21] !== svgUrl || $[22] !== width) {
        t7 = svgUrl && source ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            "data-testid": "media-card-svg",
            "data-fileid": identifier.id,
            "data-filecollection": identifier.collectionName,
            "data-source": source,
            src: svgUrl,
            alt: alt,
            style: {
                backgroundColor: backgroundColor,
                visibility: didSvgRender ? "visible" : "hidden",
                ...svgDimensions
            },
            onLoad: onSvgLoad,
            onError: ()=>{
                onSvgError(new (0, $7va5E.MediaSVGError)("img-error"));
            },
            ref: imgRef,
            className: (0, $hekY6.default)([
                "_00EA0egIor",
                !backgroundColor && "_0KLXrut28M",
                !width && !height && "_1EqgXlN91d _0NUa3rN91d"
            ])
        }) : null;
        $[12] = alt;
        $[13] = backgroundColor;
        $[14] = didSvgRender;
        $[15] = height;
        $[16] = identifier;
        $[17] = onSvgError;
        $[18] = onSvgLoad;
        $[19] = source;
        $[20] = svgDimensions;
        $[21] = svgUrl;
        $[22] = width;
        $[23] = t7;
    } else t7 = $[23];
    return t7;
} : ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt, backgroundColor: backgroundColor })=>{
    const [didSvgRender, setDidSvgRender] = (0, $cozmU.useState)(false);
    const [svgDimensions, setSvgDimensions] = (0, $cozmU.useState)({});
    const imgRef = (0, $cozmU.useRef)(null);
    const calculateDimensions = (0, $cozmU.useCallback)((targetImgElem)=>{
        if (!wrapperRef.current || !targetImgElem) return;
        setSvgDimensions((0, $80932b01d7b6e721$export$56f32e61c4316384)(targetImgElem, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    const onSvgLoad = (evt)=>{
        calculateDimensions(evt.currentTarget);
        setDidSvgRender(true);
        onLoad?.();
    };
    const onSvgError = (err)=>{
        const error = new (0, $lE37M.MediaCardError)($f988d92ee1d2ecf2$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    (0, $cozmU.useEffect)(()=>{
        if (imgRef.current) calculateDimensions(imgRef.current);
    }, [
        imgRef,
        calculateDimensions
    ]);
    const { svgUrl: svgUrl, source: source } = (0, $gZ5vW.useResolveSvg)(identifier, onSvgError);
    const { width: width, height: height } = svgDimensions;
    return svgUrl && source ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        "data-testid": 'media-card-svg',
        "data-fileid": identifier.id,
        "data-filecollection": identifier.collectionName,
        "data-source": source,
        src: svgUrl,
        alt: alt,
        style: {
            backgroundColor: backgroundColor,
            visibility: didSvgRender ? 'visible' : 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...svgDimensions
        },
        onLoad: onSvgLoad,
        onError: ()=>{
            onSvgError(new (0, $7va5E.MediaSVGError)('img-error'));
        },
        ref: imgRef,
        className: (0, $hekY6.default)([
            "_00EA0egIor",
            !backgroundColor && "_0KLXrut28M",
            !width && !height && "_1EqgXlN91d _0NUa3rN91d"
        ])
    }) : null;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");





























var $3PNw6 = parcelRequire("3PNw6");


var $dUAp3 = parcelRequire("dUAp3");





const $1d606127b0c07789$export$9f2e0be6d89cdfc7 = {
    maxWidth: '100%'
};


const $c96bba3f6889e650$export$d0cba065e468974f = {
    width: '100%',
    maxHeight: '100%'
};


const $926e438288c0639b$var$roundedRatio = (ratio)=>{
    return Math.round(ratio * 100) / 100;
};
const $926e438288c0639b$export$da67e68efa508cf6 = (imgElement, parentElement, resizeMode)=>{
    const { naturalWidth: naturalWidth, width: width, naturalHeight: naturalHeight, height: height } = imgElement;
    // Firefox & Safari can't always read the "natural" dimensions correctly.
    // When these are undefined or zero, we replace them with the rendered values
    const imgWidth = naturalWidth || width;
    const imgHeight = naturalHeight || height;
    const { width: parentWidth, height: parentHeight } = parentElement.getBoundingClientRect();
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `min(100%, ${imgWidth}px)`,
        maxHeight: `min(100%, ${imgHeight}px)`
    };
    const imgRatio = imgWidth / imgHeight;
    const cardRatio = parentWidth / parentHeight;
    if ((0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) {
        const isSameRatio = (0, $iDrrr.fg)('media-perf-ratio-calc-fix') ? Math.abs(imgWidth / parentWidth - imgHeight / parentHeight) < 0.1 : $926e438288c0639b$var$roundedRatio(imgWidth / parentWidth) === $926e438288c0639b$var$roundedRatio(imgHeight / parentHeight);
        if (isSameRatio) {
            if (resizeMode === 'stretchy-fit') return 0, $c96bba3f6889e650$export$d0cba065e468974f;
            return 0, $1d606127b0c07789$export$9f2e0be6d89cdfc7;
        }
    }
    const isImageLandscapier = imgRatio > cardRatio;
    if (resizeMode === 'stretchy-fit') {
        if (isImageLandscapier) return {
            width: '100%',
            maxHeight: '100%'
        };
        else return {
            height: '100%',
            maxWidth: '100%'
        };
    }
    if (resizeMode === 'crop') {
        if (isImageLandscapier) return {
            height: imgHeight,
            maxHeight: '100%'
        };
        else return {
            width: imgWidth,
            maxWidth: '100%'
        };
    }
    return {};
};







const $c6bc3ab4b18e4b84$export$6e6f68a4ed3ceffe = (resizeMode)=>{
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `100%`,
        maxHeight: `100%`
    };
    if (resizeMode === 'stretchy-fit') // assume the image is landscape
    return 0, $c96bba3f6889e650$export$d0cba065e468974f;
    // resizeMode === 'crop'
    // assume the image is landscape
    return (0, $iDrrr.fg)('media-perf-uplift-mutation-fix') ? (0, $1d606127b0c07789$export$9f2e0be6d89cdfc7) : {
        width: '100%'
    };
};














const $fbf23e5eaad1d1d5$var$wrapperStyles = null;
const $fbf23e5eaad1d1d5$export$e2adeb4aa5a3be1d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "ImageRendererWrapper",
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "ImageRendererWrapper",
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT"
        ])
    }, children);


const $afbf05c3e74476c8$var$baseStyles = null;
const $afbf05c3e74476c8$var$backgroundStyles = null;
const $afbf05c3e74476c8$export$a8e6523ab063becd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { cardPreview: cardPreview, alt: t1, resizeMode: t2, onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, identifier: identifier, wrapperRef: wrapperRef, useWhiteBackground: useWhiteBackground, backgroundColor: backgroundColor, testId: testId } = t0;
    const alt = t1 === undefined ? "" : t1;
    const resizeMode = t2 === undefined ? "crop" : t2;
    const onDisplayImageRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(onDisplayImage);
    const ufoContext = (0, $dUAp3.useInteractionContext)();
    let t3;
    let t4;
    if ($[0] !== mediaType || $[1] !== onDisplayImageRef) {
        t3 = ()=>{
            if (mediaType === "image") onDisplayImageRef.current?.();
        };
        t4 = [
            mediaType,
            onDisplayImageRef
        ];
        $[0] = mediaType;
        $[1] = onDisplayImageRef;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const [didRender, setDidRender] = (0, $cozmU.useState)(false);
    let t5;
    if ($[4] !== resizeMode) {
        t5 = (0, $c6bc3ab4b18e4b84$export$6e6f68a4ed3ceffe)(resizeMode);
        $[4] = resizeMode;
        $[5] = t5;
    } else t5 = $[5];
    const [resolvedDimensions, setResolvedDimensions] = (0, $cozmU.useState)(t5);
    let t6;
    let t7;
    if ($[6] !== cardPreview || $[7] !== didRender || $[8] !== ufoContext) {
        t6 = ()=>{
            if (!didRender) {
                if (!cardPreview) return;
                return ufoContext?.hold("img-loading");
            }
        };
        t7 = [
            didRender,
            cardPreview,
            ufoContext
        ];
        $[6] = cardPreview;
        $[7] = didRender;
        $[8] = ufoContext;
        $[9] = t6;
        $[10] = t7;
    } else {
        t6 = $[9];
        t7 = $[10];
    }
    (0, $cozmU.useLayoutEffect)(t6, t7);
    const imgRef = (0, $cozmU.useRef)(null);
    let t8;
    if ($[11] !== cardPreview || $[12] !== onImageLoad || $[13] !== resizeMode || $[14] !== wrapperRef) {
        t8 = (evt)=>{
            wrapperRef.current && setResolvedDimensions((0, $926e438288c0639b$export$da67e68efa508cf6)(evt.currentTarget, wrapperRef.current, resizeMode));
            setDidRender(true);
            cardPreview && onImageLoad?.(cardPreview);
        };
        $[11] = cardPreview;
        $[12] = onImageLoad;
        $[13] = resizeMode;
        $[14] = wrapperRef;
        $[15] = t8;
    } else t8 = $[15];
    const onLoad = t8;
    let t9;
    if ($[16] !== cardPreview || $[17] !== onImageError) {
        t9 = ()=>{
            setDidRender(true);
            onImageError && cardPreview && onImageError(cardPreview);
        };
        $[16] = cardPreview;
        $[17] = onImageError;
        $[18] = t9;
    } else t9 = $[18];
    const onError = t9;
    let t10;
    let t11;
    if ($[19] !== resizeMode || $[20] !== wrapperRef) {
        t10 = ()=>{
            if (imgRef.current && wrapperRef.current && imgRef.current) setResolvedDimensions((0, $926e438288c0639b$export$da67e68efa508cf6)(imgRef.current, wrapperRef.current, resizeMode));
        };
        t11 = [
            resizeMode,
            wrapperRef
        ];
        $[19] = resizeMode;
        $[20] = wrapperRef;
        $[21] = t10;
        $[22] = t11;
    } else {
        t10 = $[21];
        t11 = $[22];
    }
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== alt || $[24] !== backgroundColor || $[25] !== cardPreview || $[26] !== didRender || $[27] !== forceSyncDisplay || $[28] !== identifier || $[29] !== nativeLazyLoad || $[30] !== onError || $[31] !== onLoad || $[32] !== resizeMode || $[33] !== resolvedDimensions || $[34] !== testId || $[35] !== useWhiteBackground) {
        t12 = cardPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbf23e5eaad1d1d5$export$e2adeb4aa5a3be1d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                hasMediaComponent: true
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            ref: (ref)=>{
                if ((0, $iDrrr.fg)("media-perf-uplift-mutation-fix")) {
                    if (!imgRef.current && ref?.complete) {
                        imgRef.current = ref;
                        onLoad({
                            currentTarget: ref
                        });
                    }
                } else imgRef.current = ref;
            },
            "data-testid": testId,
            "data-fileid": (0, $jmmTp.isFileIdentifier)(identifier) ? identifier.id : null,
            "data-filecollection": (0, $jmmTp.isFileIdentifier)(identifier) ? identifier.collectionName : null,
            "data-resizemode": resizeMode,
            "data-source": cardPreview.source,
            src: cardPreview.dataURI,
            srcSet: cardPreview.srcSet,
            alt: alt,
            onLoad: onLoad,
            onError: onError,
            loading: nativeLazyLoad ? "lazy" : undefined,
            style: {
                backgroundColor: backgroundColor,
                visibility: didRender || forceSyncDisplay ? "visible" : "hidden",
                ...resolvedDimensions
            },
            className: (0, $hekY6.default)([
                "_00EA0egIor",
                useWhiteBackground && "_0KLXrut28M"
            ])
        })) : null;
        $[23] = alt;
        $[24] = backgroundColor;
        $[25] = cardPreview;
        $[26] = didRender;
        $[27] = forceSyncDisplay;
        $[28] = identifier;
        $[29] = nativeLazyLoad;
        $[30] = onError;
        $[31] = onLoad;
        $[32] = resizeMode;
        $[33] = resolvedDimensions;
        $[34] = testId;
        $[35] = useWhiteBackground;
        $[36] = t12;
    } else t12 = $[36];
    return t12;
} : ({ cardPreview: cardPreview, alt: alt = '', resizeMode: resizeMode = 'crop', onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, identifier: identifier, wrapperRef: wrapperRef, useWhiteBackground: useWhiteBackground, backgroundColor: backgroundColor, testId: testId })=>{
    const onDisplayImageRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(onDisplayImage);
    const ufoContext = (0, $dUAp3.useInteractionContext)();
    (0, $cozmU.useEffect)(()=>{
        if (mediaType === 'image') onDisplayImageRef.current?.();
    }, [
        mediaType,
        onDisplayImageRef
    ]);
    const [didRender, setDidRender] = (0, $cozmU.useState)(false);
    const [resolvedDimensions, setResolvedDimensions] = (0, $cozmU.useState)((0, $c6bc3ab4b18e4b84$export$6e6f68a4ed3ceffe)(resizeMode));
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!didRender) {
            if (!cardPreview) return;
            return ufoContext?.hold('img-loading');
        }
    }, [
        didRender,
        cardPreview,
        ufoContext
    ]);
    const imgRef = (0, $cozmU.useRef)(null);
    const onLoad = (evt)=>{
        wrapperRef.current && setResolvedDimensions((0, $926e438288c0639b$export$da67e68efa508cf6)(evt.currentTarget, wrapperRef.current, resizeMode));
        setDidRender(true);
        cardPreview && onImageLoad?.(cardPreview);
    };
    const onError = ()=>{
        setDidRender(true);
        onImageError && cardPreview && onImageError(cardPreview);
    };
    (0, $cozmU.useEffect)(()=>{
        if (imgRef.current && wrapperRef.current && imgRef.current) setResolvedDimensions((0, $926e438288c0639b$export$da67e68efa508cf6)(imgRef.current, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    return cardPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbf23e5eaad1d1d5$export$e2adeb4aa5a3be1d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            hasMediaComponent: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        ref: (ref)=>{
            if ((0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) {
                if (!imgRef.current && ref?.complete) {
                    // we need to set the imgRef before calling onLoad to avoid recursive rendering
                    imgRef.current = ref;
                    onLoad({
                        currentTarget: ref
                    });
                }
            } else imgRef.current = ref;
        },
        "data-testid": testId,
        "data-fileid": (0, $jmmTp.isFileIdentifier)(identifier) ? identifier.id : null,
        "data-filecollection": (0, $jmmTp.isFileIdentifier)(identifier) ? identifier.collectionName : null,
        "data-resizemode": resizeMode,
        "data-source": cardPreview.source,
        src: cardPreview.dataURI,
        srcSet: cardPreview.srcSet,
        alt: alt,
        onLoad: onLoad,
        onError: onError,
        loading: nativeLazyLoad ? 'lazy' : undefined,
        style: {
            backgroundColor: backgroundColor,
            visibility: didRender || forceSyncDisplay ? 'visible' : 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...resolvedDimensions
        },
        className: (0, $hekY6.default)([
            "_00EA0egIor",
            useWhiteBackground && "_0KLXrut28M"
        ])
    })) : null;
};


const $2d50f45ceda19313$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $2d50f45ceda19313$export$cf98b60e5f1e2515 = ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt, backgroundColor: backgroundColor })=>{
    const onSvgError = (err)=>{
        const error = new (0, $lE37M.MediaCardError)($2d50f45ceda19313$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    const { svgUrl: svgUrl, source: source } = (0, $gZ5vW.useResolveSvg)(identifier, onSvgError);
    const cardPreview = (0, $cozmU.useMemo)(()=>svgUrl && source ? {
            dataURI: svgUrl,
            source: source
        } : undefined, [
        svgUrl,
        source
    ]);
    return cardPreview ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $afbf05c3e74476c8$export$a8e6523ab063becd), {
        testId: "media-card-svg",
        identifier: identifier,
        cardPreview: cardPreview,
        alt: alt,
        resizeMode: resizeMode,
        onImageLoad: onLoad,
        onImageError: ()=>{
            onSvgError(new (0, $7va5E.MediaSVGError)('img-error'));
        },
        wrapperRef: wrapperRef,
        mediaType: "image",
        useWhiteBackground: !backgroundColor,
        backgroundColor: backgroundColor
    }) : null;
};


const $cc53140db039fca1$export$cf98b60e5f1e2515 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("platform_media_card_image_render") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d50f45ceda19313$export$cf98b60e5f1e2515), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f988d92ee1d2ecf2$export$cf98b60e5f1e2515), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $iDrrr.fg)('platform_media_card_image_render') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d50f45ceda19313$export$cf98b60e5f1e2515), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f988d92ee1d2ecf2$export$cf98b60e5f1e2515), props);
};


























// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $b993cd2d6195d3f8$export$4ac0eca47dcd1d94 = '.3s';


const $eeae020406992f6d$export$66bb15e2994e6a26 = (propertyName = 'all')=>`
  transition: ${propertyName} ${0, $b993cd2d6195d3f8$export$4ac0eca47dcd1d94};
`;


const $7ae565c90ad951fe$export$a7a5a7c9a03af11 = 'media-card-actions-bar';
const $7ae565c90ad951fe$export$11387bc0e0bf1d5a = `opacity: 1;`;
const $7ae565c90ad951fe$export$491e6397d7c1480b = (isFixed)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $lOiVq.css)(isFixed ? $7ae565c90ad951fe$export$11387bc0e0bf1d5a : 'opacity: 0;', (0, $eeae020406992f6d$export$66bb15e2994e6a26)(), "position:absolute;top:0;right:0;display:flex;flex-flow:row nowrap;justify-content:right;padding:var(--ds-space-100, 8px);gap:var(--ds-space-100, 8px);");
$7ae565c90ad951fe$export$491e6397d7c1480b.displayName = 'ActionsBarWrapper';


const $2f9faa60ea810669$var$wrapperStyles = null;
const $2f9faa60ea810669$var$fixedActionBarStyle = null;
const $2f9faa60ea810669$export$e9414cbfa812f398 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const t0 = props.isFixed && "_1YKVNs7dHp";
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $hekY6.default)([
            "_23rrnHtu8n _0aFT5v1qpb _3TGfC9LRg7 _2mHwu82ADO _1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _3iDTPbQ4SZ _37wbyu0dzo _0Of8r22ADO _1wydGW2ADO _1Znuxb2ADO _2Zuz6Q2ADO _1YKVNsdnbC",
            t0,
            (0, $7ae565c90ad951fe$export$a7a5a7c9a03af11)
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props.children || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: "actionsBarWrapper",
            "data-testId": "actionsBarWrapper",
            role: "none",
            className: t1,
            onClick: $2f9faa60ea810669$var$_temp
        }, props.children);
        $[2] = props.children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "actionsBarWrapper",
        "data-testId": "actionsBarWrapper",
        role: "none",
        className: (0, $hekY6.default)([
            "_23rrnHtu8n _0aFT5v1qpb _3TGfC9LRg7 _2mHwu82ADO _1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _3iDTPbQ4SZ _37wbyu0dzo _0Of8r22ADO _1wydGW2ADO _1Znuxb2ADO _2Zuz6Q2ADO _1YKVNsdnbC",
            props.isFixed && "_1YKVNs7dHp",
            (0, $7ae565c90ad951fe$export$a7a5a7c9a03af11)
        ]),
        onClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
        }
    }, props.children);
};
$2f9faa60ea810669$export$e9414cbfa812f398.displayName = 'ActionsBarWrapper';
function $2f9faa60ea810669$var$_temp(event) {
    event.stopPropagation();
    event.preventDefault();
}


const $ddab8c4b46f69f86$export$e9414cbfa812f398 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f9faa60ea810669$export$e9414cbfa812f398), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f9faa60ea810669$export$e9414cbfa812f398), props);









































const $7e33e10fedb52134$var$variantStyleMap = {
    filled: "_0KLXruoI2d _1eOmH6hWTW",
    default: "_1eOmH6o126"
};
const $7e33e10fedb52134$var$cardActionButtonStyles = null;
const $7e33e10fedb52134$export$19effabad32bd757 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(11);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $iDrrr.fg)("platform_media_card_action_button_type_fix") ? {
            type: "button"
        } : {};
        $[0] = t0;
    } else t0 = $[0];
    const t1 = props.label;
    const t2 = props.disabled ? "not-allowed" : "default";
    let t3;
    if ($[1] !== props.style || $[2] !== t2) {
        t3 = {
            ...props.style,
            cursor: t2
        };
        $[1] = props.style;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const t4 = props.onClick;
    const t5 = props.onMouseDown;
    const t6 = $7e33e10fedb52134$var$variantStyleMap[props.variant ?? "default"];
    let t7;
    if ($[4] !== t6) {
        t7 = (0, $hekY6.default)([
            "_30huDKYbGa _0bjKvDzXzM _034jHtYbGa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02XjOh _0jFU0VXjOh _1UtDYz8ujp _0ReiIH7zJH",
            t6
        ]);
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== props || $[7] !== ref || $[8] !== t3 || $[9] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("button", {
            ...props,
            ...t0,
            id: "cardActionButton",
            "data-testid": "media-card-primary-action",
            "aria-label": t1,
            style: t3,
            onClick: t4,
            onMouseDown: t5,
            ref: ref,
            className: t7
        }, props.children);
        $[6] = props;
        $[7] = ref;
        $[8] = t3;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    return t8;
} : (props, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement("button", {
        ...props,
        ...(0, $iDrrr.fg)('platform_media_card_action_button_type_fix') ? {
            type: 'button'
        } : {},
        id: "cardActionButton",
        "data-testid": "media-card-primary-action",
        "aria-label": props.label,
        style: {
            ...props.style,
            cursor: props.disabled ? 'not-allowed' : 'default'
        },
        onClick: props.onClick,
        onMouseDown: props.onMouseDown,
        ref: ref,
        className: (0, $hekY6.default)([
            "_30huDKYbGa _0bjKvDzXzM _034jHtYbGa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02XjOh _0jFU0VXjOh _1UtDYz8ujp _0ReiIH7zJH",
            $7e33e10fedb52134$var$variantStyleMap[props.variant ?? 'default']
        ])
    }, props.children);
});


const $e71acc0199def567$export$19effabad32bd757 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7e33e10fedb52134$export$19effabad32bd757), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7e33e10fedb52134$export$19effabad32bd757), {
        ...props,
        ref: ref
    }));








const $1db25788f0c11ee1$export$8cc1a92de7a95c90 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { icon: icon, label: label, filename: filename, triggerColor: triggerColor, onClick: onClick, isPrimary: isPrimary, variant: variant, isDisabled: isDisabled, tooltip: tooltip } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onMouseDown = $1db25788f0c11ee1$var$_temp;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isPrimary || $[2] !== label || $[3] !== onClick) {
        t1 = (e)=>{
            const actionSubjectId = isPrimary ? "mediaCardPrimaryActionButton" : "mediaCardSecondaryActionButton";
            (0, $lvxKi.fireMediaCardEvent)({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: actionSubjectId,
                attributes: {
                    label: label
                }
            }, createAnalyticsEvent);
            onClick?.(e);
        };
        $[0] = createAnalyticsEvent;
        $[1] = isPrimary;
        $[2] = label;
        $[3] = onClick;
        $[4] = t1;
    } else t1 = $[4];
    const handleClick = t1;
    let t2;
    if ($[5] !== triggerColor) {
        t2 = {
            color: triggerColor
        };
        $[5] = triggerColor;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = filename ? `${filename} \u{2014} ${label}` : label;
    let t4;
    if ($[7] !== handleClick || $[8] !== icon || $[9] !== isDisabled || $[10] !== t2 || $[11] !== t3 || $[12] !== variant) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e71acc0199def567$export$19effabad32bd757), {
            onClick: handleClick,
            onMouseDown: onMouseDown,
            style: t2,
            label: t3,
            variant: variant,
            disabled: isDisabled
        }, icon);
        $[7] = handleClick;
        $[8] = icon;
        $[9] = isDisabled;
        $[10] = t2;
        $[11] = t3;
        $[12] = variant;
        $[13] = t4;
    } else t4 = $[13];
    const cardActionButton = t4;
    let t5;
    if ($[14] !== cardActionButton || $[15] !== tooltip) {
        t5 = tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltip,
            position: "bottom",
            tag: "span"
        }, cardActionButton) : cardActionButton;
        $[14] = cardActionButton;
        $[15] = tooltip;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : ({ icon: icon, label: label, filename: filename, triggerColor: triggerColor, onClick: onClick, isPrimary: isPrimary, variant: variant, isDisabled: isDisabled, tooltip: tooltip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // this is to prevent currently focused text to loose cursor on clicking card action
    // this does not prevent onclick behavior
    const onMouseDown = (event)=>{
        event.preventDefault();
    };
    const handleClick = (e)=>{
        const actionSubjectId = isPrimary ? 'mediaCardPrimaryActionButton' : 'mediaCardSecondaryActionButton';
        (0, $lvxKi.fireMediaCardEvent)({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                label: label
            }
        }, createAnalyticsEvent);
        onClick?.(e);
    };
    const cardActionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e71acc0199def567$export$19effabad32bd757), {
        onClick: handleClick,
        onMouseDown: onMouseDown,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: triggerColor
        },
        label: filename ? `${filename} \u{2014} ${label}` : label,
        variant: variant,
        disabled: isDisabled
    }, icon);
    return tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltip,
        position: "bottom",
        tag: "span"
    }, cardActionButton) : cardActionButton;
};
function $1db25788f0c11ee1$var$_temp(event) {
    event.preventDefault();
}















var $6TaGl = parcelRequire("6TaGl");


var $3vgx3 = parcelRequire("3vgx3");


var $9erVg = parcelRequire("9erVg");


var $is1T6 = parcelRequire("is1T6");









const $63215b87151678ef$var$DropdownItemWithProps = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            testId: "media-card-actions-menu-item",
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        testId: "media-card-actions-menu-item",
        ...props
    });
const $63215b87151678ef$var$createDropdownItemWithAnalytics = (action, index)=>{
    const { label: label, handler: handler, isDisabled: isDisabled } = action;
    const DropdownItemWithAnalytics = (0, $lzgC6.default)({
        onClick: (0, $2cb47daccc3b7ffc$export$4d33ada3618f7626)({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'mediaCardDropDownMenuItem',
            attributes: {
                label: label
            }
        })
    })($63215b87151678ef$var$DropdownItemWithProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DropdownItemWithAnalytics, {
        key: index,
        onClick: ()=>handler(),
        isDisabled: isDisabled
    }, label);
};
const $63215b87151678ef$export$2b7a7909eccadfb9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { actions: actions, triggerColor: triggerColor, onOpenChange: onOpenChange, triggerVariant: triggerVariant } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (actions.length > 0) {
        let t1;
        if ($[0] !== createAnalyticsEvent || $[1] !== triggerColor || $[2] !== triggerVariant) {
            t1 = (t2)=>{
                const { triggerRef: triggerRef, isSelected: isSelected, testId: testId, onClick: onClick, ...providedProps } = t2;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e71acc0199def567$export$19effabad32bd757), {
                    variant: triggerVariant,
                    style: {
                        color: triggerColor
                    },
                    ref: triggerRef,
                    onClick: (e)=>{
                        (0, $lvxKi.fireMediaCardEvent)({
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "mediaCardDropDownMenu",
                            attributes: {}
                        }, createAnalyticsEvent);
                        onClick?.(e);
                    },
                    ...providedProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "more"
                }));
            };
            $[0] = createAnalyticsEvent;
            $[1] = triggerColor;
            $[2] = triggerVariant;
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] !== actions) {
            t2 = actions.map($63215b87151678ef$var$createDropdownItemWithAnalytics);
            $[4] = actions;
            $[5] = t2;
        } else t2 = $[5];
        let t3;
        if ($[6] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t2);
            $[6] = t2;
            $[7] = t3;
        } else t3 = $[7];
        let t4;
        if ($[8] !== onOpenChange || $[9] !== t1 || $[10] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
                testId: "media-card-actions-menu",
                onOpenChange: onOpenChange,
                trigger: t1
            }, t3);
            $[8] = onOpenChange;
            $[9] = t1;
            $[10] = t3;
            $[11] = t4;
        } else t4 = $[11];
        return t4;
    } else return null;
} : ({ actions: actions, triggerColor: triggerColor, onOpenChange: onOpenChange, triggerVariant: triggerVariant })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (actions.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        testId: "media-card-actions-menu",
        onOpenChange: onOpenChange,
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, onClick: onClick, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e71acc0199def567$export$19effabad32bd757), {
                variant: triggerVariant,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    color: triggerColor
                },
                ref: triggerRef,
                onClick: (e)=>{
                    (0, $lvxKi.fireMediaCardEvent)({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'mediaCardDropDownMenu',
                        attributes: {}
                    }, createAnalyticsEvent);
                    onClick?.(e);
                },
                ...providedProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                color: "currentColor",
                spacing: "spacious",
                label: "more"
            }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, actions.map($63215b87151678ef$var$createDropdownItemWithAnalytics)));
    else return null;
};


class $0f2261c6b5731b83$export$8b95be1301afd485 extends (0, $cozmU.Component) {
    render() {
        const { actions: actions } = this.props;
        if (!actions.length) return null;
        const primaryAction = actions.find($0f2261c6b5731b83$var$actionWithIcon);
        const otherActions = actions.filter($0f2261c6b5731b83$var$actionNotEqualTo(primaryAction));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, primaryAction ? this.renderActionIconButton(primaryAction, true) : null, this.renderOtherActionButtons(otherActions));
    }
    renderActionIconButton(action, isPrimary) {
        const { triggerColor: triggerColor, filename: filename, variant: variant } = this.props;
        const { icon: icon, handler: handler, label: label, isDisabled: isDisabled, tooltip: tooltip } = action;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1db25788f0c11ee1$export$8cc1a92de7a95c90), {
            icon: icon,
            label: label,
            filename: filename,
            isPrimary: isPrimary,
            triggerColor: triggerColor,
            onClick: ()=>handler(),
            variant: variant,
            isDisabled: isDisabled,
            tooltip: tooltip
        });
    }
    renderOtherActionButtons(actions) {
        if (actions.length === 0) return null;
        else {
            const { triggerColor: triggerColor, onToggle: onToggle, variant: variant } = this.props;
            const firstActionWithIcon = actions.find($0f2261c6b5731b83$var$actionWithIcon);
            const otherActions = actions.filter($0f2261c6b5731b83$var$actionNotEqualTo(firstActionWithIcon));
            if (firstActionWithIcon && otherActions.length === 0) return this.renderActionIconButton(firstActionWithIcon, false);
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63215b87151678ef$export$2b7a7909eccadfb9), {
                actions: actions,
                triggerColor: triggerColor,
                onOpenChange: onToggle,
                triggerVariant: variant
            });
        }
    }
}
function $0f2261c6b5731b83$var$actionWithIcon(action) {
    return !!action.icon;
}
function $0f2261c6b5731b83$var$actionNotEqualTo(otherAction) {
    return (action)=>action !== otherAction;
}


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $9AILw = parcelRequire("9AILw");


var $lPFwW = parcelRequire("lPFwW");

var $3f035d788302a31d$export$1092897f622d4253 = /*#__PURE__*/ function(CardActionIconButtonVariant) {
    CardActionIconButtonVariant["default"] = "default";
    CardActionIconButtonVariant["filled"] = "filled";
    return CardActionIconButtonVariant;
}({});
const $3f035d788302a31d$var$getVariantStyles = (variant)=>{
    return variant === 'filled' ? `
    background-color: ${"var(--ds-surface-overlay, #FFFFFF)"};

    &:hover {
      background-color: ${"var(--ds-surface-overlay-hovered, #F0F1F2)"}
    }
  ` : `
    &:hover {
      background-color: ${"var(--ds-background-neutral-subtle-hovered, #0515240F)"};
    }
  `;
};
const $3f035d788302a31d$export$7554c3d9ed9d9659 = ({ variant: variant })=>/*#__PURE__*/ (0, $lOiVq.css)("appearance:none;border:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.center), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.borderRadius), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $lPFwW.size)(26), "color:var(--ds-icon, #292A2E);&:hover{cursor:pointer;}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $3f035d788302a31d$var$getVariantStyles(variant));


class $457f2c417ecea897$export$8c8e9293b68041de extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { isFixed: isFixed, filename: filename, actions: actions } = this.props;
        if (actions.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddab8c4b46f69f86$export$e9414cbfa812f398), {
            isFixed: isFixed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0f2261c6b5731b83$export$8b95be1301afd485), {
            filename: filename,
            actions: actions,
            variant: (0, $3f035d788302a31d$export$1092897f622d4253).filled
        }));
    }
}























const $0f2212bd32d688b5$export$5a1cb4139dc6683d = 'media-card-blanket';
const $0f2212bd32d688b5$export$3141ecf58e7b3585 = `background-color: ${"var(--ds-blanket, #050C1F75)"};`;
const $0f2212bd32d688b5$var$blanketStyles = null;
const $0f2212bd32d688b5$var$fixedBlanketStyle = null;
const $0f2212bd32d688b5$export$5b927fc1ef8c468b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { isFixed: isFixed } = props;
    const t0 = isFixed && "_0KLXruA5lS";
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $hekY6.default)([
            "_23rrnHtu8n _1mT5xdWVPG _39xV02N91d _0jFU0VN91d _0NUa3rN91d _1EqgXlN91d _3OE6xYdnbC _2IhTondnbC",
            t0,
            $0f2212bd32d688b5$export$5a1cb4139dc6683d
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1,
            "data-testid": "media-card-blanket"
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>{
    const { isFixed: isFixed } = props;
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_23rrnHtu8n _1mT5xdWVPG _39xV02N91d _0jFU0VN91d _0NUa3rN91d _1EqgXlN91d _3OE6xYdnbC _2IhTondnbC",
            isFixed && "_0KLXruA5lS",
            $0f2212bd32d688b5$export$5a1cb4139dc6683d
        ]),
        "data-testid": "media-card-blanket"
    });
};
$0f2212bd32d688b5$export$5b927fc1ef8c468b.displayName = 'Blanket';


const $21d414d99db4a105$export$5b927fc1ef8c468b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0f2212bd32d688b5$export$5b927fc1ef8c468b), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0f2212bd32d688b5$export$5b927fc1ef8c468b), props);















































const $583fc0c9ad680c39$var$breatheAnimation = null;
const $583fc0c9ad680c39$var$animatedStyles = null;
const $583fc0c9ad680c39$var$baseStyles = null;
const $583fc0c9ad680c39$export$e33129280ab99883 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const { animated: animated } = props;
    const t0 = animated && "";
    const t1 = animated && "_1gBibygCWY _0nFVCG7d1W _43vdfTN8t6 _03m2nySHWH";
    let t2;
    if ($[0] !== t0 || $[1] !== t1) {
        t2 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _4c065U1Y8M _2Y7lL42ADO _1YKVNs7dHp _1kk5Tkf7mX _1UtDYzKGUX _2fwxA5DIqT _1DCdHiKduc",
            t0,
            t1
        ]);
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== props.children || $[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: "iconMessageWrapper",
            "data-testid": "icon-message-wrapper",
            className: t2
        }, props.children);
        $[3] = props.children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : (props)=>{
    const { animated: animated } = props;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "iconMessageWrapper",
        "data-testid": "icon-message-wrapper",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _4c065U1Y8M _2Y7lL42ADO _1YKVNs7dHp _1kk5Tkf7mX _1UtDYzKGUX _2fwxA5DIqT _1DCdHiKduc",
            animated && "",
            animated && "_1gBibygCWY _0nFVCG7d1W _43vdfTN8t6 _03m2nySHWH"
        ])
    }, props.children);
};


const $594bae63350c3486$export$e33129280ab99883 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $583fc0c9ad680c39$export$e33129280ab99883), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $583fc0c9ad680c39$export$e33129280ab99883), props);


const $5d65005567ed9d36$export$49a5d8503f8a110a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { messageDescriptor: messageDescriptor, animated: t1 } = t0;
    const animated = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== messageDescriptor) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), messageDescriptor));
        $[0] = messageDescriptor;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== animated || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $594bae63350c3486$export$e33129280ab99883), {
            animated: animated
        }, t2);
        $[2] = animated;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ messageDescriptor: messageDescriptor, animated: animated = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $594bae63350c3486$export$e33129280ab99883), {
        animated: animated
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), messageDescriptor)));
};


const $17ba6bcdea2acebd$export$acb8738584883d89 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
            ...props,
            messageDescriptor: (0, $fA65V.messages).check_internet_connection
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
        ...props,
        messageDescriptor: (0, $fA65V.messages).check_internet_connection
    });















const $fe28e9a23446cea1$export$4a80244213cb4afc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { disableAnimation: disableAnimation } = t0;
    const t1 = !disableAnimation;
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
            messageDescriptor: (0, $fA65V.messages).creating_preview,
            animated: t1
        });
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ disableAnimation: disableAnimation })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
        messageDescriptor: (0, $fA65V.messages).creating_preview,
        animated: !disableAnimation
    });















const $e482048df30fb6af$export$a712c963efa9c728 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
            ...props,
            messageDescriptor: (0, $fA65V.messages).failed_to_load
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
        ...props,
        messageDescriptor: (0, $fA65V.messages).failed_to_load
    });















const $17c2065bc332e889$export$f6b7f98fc8b4c6c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
            ...props,
            messageDescriptor: (0, $fA65V.messages).failed_to_upload
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
        ...props,
        messageDescriptor: (0, $fA65V.messages).failed_to_upload
    });















const $aafda3669d76c197$export$35337070c6dafccf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
            ...props,
            messageDescriptor: (0, $fA65V.messages).preview_unavailable
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d65005567ed9d36$export$49a5d8503f8a110a), {
        ...props,
        messageDescriptor: (0, $fA65V.messages).preview_unavailable
    });
























var $fyYZ5 = parcelRequire("fyYZ5");

function $f1db531ea2cb0ac2$var$titleBoxHeight(hasTitleBox, breakpoint) {
    // there is no titlebox
    if (!hasTitleBox) return `0px`;
     // calculate height of the titlebox
    const marginBottom = (0, $fyYZ5.getTitleBoxHeight)(breakpoint);
    return `${marginBottom}px`;
}
const $f1db531ea2cb0ac2$var$iconWrapperStyles = null;
const $f1db531ea2cb0ac2$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { breakpoint: breakpoint, hasTitleBox: hasTitleBox } = props;
    let t0;
    if ($[0] !== breakpoint || $[1] !== hasTitleBox) {
        t0 = $f1db531ea2cb0ac2$var$titleBoxHeight(hasTitleBox, breakpoint);
        $[0] = breakpoint;
        $[1] = hasTitleBox;
        $[2] = t0;
    } else t0 = $[2];
    const t1 = `calc(100% - ${t0})`;
    let t2;
    if ($[3] !== t1) {
        t2 = {
            height: t1
        };
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT"
        ]);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== props.children || $[7] !== t2) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: "iconWrapper",
            style: t2,
            className: t3
        }, props.children);
        $[6] = props.children;
        $[7] = t2;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : (props)=>{
    const { breakpoint: breakpoint, hasTitleBox: hasTitleBox } = props;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "iconWrapper",
        style: {
            height: `calc(100% - ${$f1db531ea2cb0ac2$var$titleBoxHeight(hasTitleBox, breakpoint)})`
        },
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT"
        ])
    }, props.children);
};
$f1db531ea2cb0ac2$export$be58b4326e23250f.displayName = 'MediaIconWrapper';


const $87f3b9d7cf4b76fc$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1db531ea2cb0ac2$export$be58b4326e23250f), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1db531ea2cb0ac2$export$be58b4326e23250f), props);





















var $bLufD = parcelRequire("bLufD");

function $2c4c33a72dbd8cbf$export$31853d267a6d0b0b(resizeMode) {
    return {
        crop: resizeMode === 'crop',
        stretch: resizeMode === 'stretchy-fit'
    };
}



const $17b7cc4ffa598ef9$export$a8e6523ab063becd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { cardPreview: cardPreview, alt: alt, resizeMode: resizeMode, onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay } = t0;
    const onDisplayImageRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(onDisplayImage);
    let t1;
    let t2;
    if ($[0] !== mediaType || $[1] !== onDisplayImageRef) {
        t1 = ()=>{
            if (mediaType === "image") onDisplayImageRef.current?.();
        };
        t2 = [
            mediaType,
            onDisplayImageRef
        ];
        $[0] = mediaType;
        $[1] = onDisplayImageRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== cardPreview || $[5] !== onImageLoad) {
        t3 = ()=>{
            onImageLoad && cardPreview && onImageLoad(cardPreview);
        };
        $[4] = cardPreview;
        $[5] = onImageLoad;
        $[6] = t3;
    } else t3 = $[6];
    const onLoad = t3;
    let t4;
    if ($[7] !== cardPreview || $[8] !== onImageError) {
        t4 = ()=>{
            onImageError && cardPreview && onImageError(cardPreview);
        };
        $[7] = cardPreview;
        $[8] = onImageError;
        $[9] = t4;
    } else t4 = $[9];
    const onError = t4;
    const t5 = cardPreview?.dataURI;
    const t6 = cardPreview?.orientation;
    const t7 = nativeLazyLoad ? "lazy" : undefined;
    let t8;
    if ($[10] !== resizeMode) {
        t8 = (0, $2c4c33a72dbd8cbf$export$31853d267a6d0b0b)(resizeMode);
        $[10] = resizeMode;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== alt || $[13] !== forceSyncDisplay || $[14] !== onError || $[15] !== onLoad || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bLufD.MediaImage), {
            dataURI: t5,
            alt: alt,
            previewOrientation: t6,
            onImageLoad: onLoad,
            onImageError: onError,
            loading: t7,
            forceSyncDisplay: forceSyncDisplay,
            ...t8
        });
        $[12] = alt;
        $[13] = forceSyncDisplay;
        $[14] = onError;
        $[15] = onLoad;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
} : ({ cardPreview: cardPreview, alt: alt, resizeMode: resizeMode, onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay })=>{
    const onDisplayImageRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(onDisplayImage);
    (0, $cozmU.useEffect)(()=>{
        // TODO: trigger accordingly with the succeeded event. This could be a breaking change
        if (mediaType === 'image') onDisplayImageRef.current?.();
    }, [
        mediaType,
        onDisplayImageRef
    ]);
    const onLoad = ()=>{
        onImageLoad && cardPreview && onImageLoad(cardPreview);
    };
    const onError = ()=>{
        onImageError && cardPreview && onImageError(cardPreview);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bLufD.MediaImage), {
        dataURI: cardPreview?.dataURI,
        alt: alt,
        previewOrientation: cardPreview?.orientation,
        onImageLoad: onLoad,
        onImageError: onError,
        loading: nativeLazyLoad ? 'lazy' : undefined,
        forceSyncDisplay: forceSyncDisplay,
        ...(0, $2c4c33a72dbd8cbf$export$31853d267a6d0b0b)(resizeMode)
    });
};






const $2f8b624677c640c5$export$a8e6523ab063becd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("platform_media_card_image_render") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $afbf05c3e74476c8$export$a8e6523ab063becd), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17b7cc4ffa598ef9$export$a8e6523ab063becd), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return (0, $iDrrr.fg)('platform_media_card_image_render') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $afbf05c3e74476c8$export$a8e6523ab063becd), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17b7cc4ffa598ef9$export$a8e6523ab063becd), props);
};



var $97Pj3 = parcelRequire("97Pj3");




















var $hBYtq = parcelRequire("hBYtq");


var $9GVkD = parcelRequire("9GVkD");

const $00a35784f97edcc7$var$OpenMediaViewerButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    let fileName;
    let innerRef;
    let props;
    if ($[0] !== t0) {
        ({ fileName: fileName, innerRef: innerRef, ...props } = t0);
        $[0] = t0;
        $[1] = fileName;
        $[2] = innerRef;
        $[3] = props;
    } else {
        fileName = $[1];
        innerRef = $[2];
        props = $[3];
    }
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    let t2;
    if ($[4] !== fileName || $[5] !== intl) {
        t1 = (0, $iDrrr.fg)("create_modernization_ga_fixes_drop_2") ? {
            "aria-label": intl.formatMessage((0, $fA65V.messages).open_file_in_viewer_aria_label, {
                name: fileName
            })
        } : {};
        t2 = intl.formatMessage((0, $fA65V.messages).open_file_in_viewer, {
            name: fileName
        });
        $[4] = fileName;
        $[5] = intl;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    let t3;
    if ($[8] !== innerRef || $[9] !== props || $[10] !== t1 || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ref: innerRef,
            ...props,
            ...t1
        }, t2));
        $[8] = innerRef;
        $[9] = props;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ fileName: fileName, innerRef: innerRef, ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ref: innerRef,
        ...props,
        ...(0, $iDrrr.fg)('create_modernization_ga_fixes_drop_2') ? {
            'aria-label': intl.formatMessage((0, $fA65V.messages).open_file_in_viewer_aria_label, {
                name: fileName
            })
        } : {}
    }, intl.formatMessage((0, $fA65V.messages).open_file_in_viewer, {
        name: fileName
    })));
};
const $00a35784f97edcc7$var$OpenMediaViewerButtonWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = props.intl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($00a35784f97edcc7$var$OpenMediaViewerButton, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: "en"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($00a35784f97edcc7$var$OpenMediaViewerButton, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return props.intl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($00a35784f97edcc7$var$OpenMediaViewerButton, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($00a35784f97edcc7$var$OpenMediaViewerButton, props));
};
const $00a35784f97edcc7$var$_default_1 = (0, $kSwu1.injectIntl)($00a35784f97edcc7$var$OpenMediaViewerButtonWrapper, {
    enforceContext: false
});
var $00a35784f97edcc7$export$2e2bcd8739ae039 = $00a35784f97edcc7$var$_default_1;












var $2gkGM = parcelRequire("2gkGM");






















// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



function $0fe69ec78e4098f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0fe69ec78e4098f3$export$2fb57774a6fa9716 = 'media-card-play-button';
const $0fe69ec78e4098f3$export$4199e73dcf70a929 = 'play-icon-background';
const $0fe69ec78e4098f3$var$discSize = 48;
const $0fe69ec78e4098f3$var$discSizeHover = 56;
const $0fe69ec78e4098f3$export$8d26a4dc335bc84b = `
  .${$0fe69ec78e4098f3$export$4199e73dcf70a929} {
    width: ${$0fe69ec78e4098f3$var$discSizeHover}px;
    height: ${$0fe69ec78e4098f3$var$discSizeHover}px;
  }
`;
const $0fe69ec78e4098f3$export$1daeab9e7392037d = {
    name: "1w1g0yf",
    styles: "position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:var(--ds-icon-inverse, #FFFFFF);span{position:absolute;}"
};
const $0fe69ec78e4098f3$export$1e38306701346cd5 = /*#__PURE__*/ (0, $lOiVq.css)({
    transitionProperty: 'width, height',
    transitionDuration: '0.1s',
    position: 'absolute',
    width: `${$0fe69ec78e4098f3$var$discSize}px`,
    height: `${$0fe69ec78e4098f3$var$discSize}px`,
    background: "var(--ds-background-neutral-bold, #292A2E)",
    borderRadius: "var(--ds-radius-full, 9999px)"
});


const $4405c4a4de4bee88$var$playButtonWrapperStyles = null;
const $4405c4a4de4bee88$export$4b5a99ec12fb6a16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1UtDYz6BYM _25VRdPWVPG",
            (0, $0fe69ec78e4098f3$export$2fb57774a6fa9716)
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t0,
            "data-testid": "media-card-play-button-wrapper"
        }, props.children);
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1UtDYz6BYM _25VRdPWVPG",
            (0, $0fe69ec78e4098f3$export$2fb57774a6fa9716)
        ]),
        "data-testid": "media-card-play-button-wrapper"
    }, props.children);
};


const $51f21a870c8fddf9$export$4b5a99ec12fb6a16 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4405c4a4de4bee88$export$4b5a99ec12fb6a16), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4405c4a4de4bee88$export$4b5a99ec12fb6a16), props);


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");





const $ee606f7dd0712815$export$b9f4dfad351e8285 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $0fe69ec78e4098f3$export$1e38306701346cd5),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $0fe69ec78e4098f3$export$4199e73dcf70a929),
        "data-testid": "media-card-play-button-background"
    });
};


const $4e6a176bd5fe3e08$export$fbed5f62d839a0cd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51f21a870c8fddf9$export$4b5a99ec12fb6a16), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee606f7dd0712815$export$b9f4dfad351e8285), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2gkGM))), {
            color: "currentColor",
            label: "play"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51f21a870c8fddf9$export$4b5a99ec12fb6a16), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee606f7dd0712815$export$b9f4dfad351e8285), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2gkGM))), {
        color: "currentColor",
        label: "play"
    }));
};



var $k5Bdp = parcelRequire("k5Bdp");











var $eh6Ml = parcelRequire("eh6Ml");






















const $89c41c3c8147949b$export$9f1541de0780ef27 = 'media-card-tickbox';
const $89c41c3c8147949b$export$5ce7b7639ec5e726 = `
  background-color: ${"var(--ds-background-input, #FFFFFF)"};
  color: ${"var(--ds-icon-subtle, #505258)"};
`;


const $6edd072a5a0fd1f1$var$selectedStyles = null;
const $6edd072a5a0fd1f1$var$wrapperStyles = null;
const $6edd072a5a0fd1f1$export$65704ff0d0294857 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const t0 = props.selected && "_0KLXru6bAP _1UtDYz6BYM";
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $hekY6.default)([
            "_2sNsIgmnOE _0bjKvDkG2W _0hPCNLDIqT _0pI6nMDIqT _23rrnHtu8n _39xV025zaO _0jFU0V5zaO _1mT5xdWVPG _2IhTongVvo _3OE6xYgVvo _1UtDYzjOvk _3iDTPbgBM8 _37mLE4vLZJ",
            t0,
            (0, $89c41c3c8147949b$export$9f1541de0780ef27)
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props.children || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: "tickBoxWrapper",
            "data-testid": "media-card-tickbox",
            className: t1
        }, props.children);
        $[2] = props.children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "tickBoxWrapper",
        "data-testid": "media-card-tickbox",
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _0bjKvDkG2W _0hPCNLDIqT _0pI6nMDIqT _23rrnHtu8n _39xV025zaO _0jFU0V5zaO _1mT5xdWVPG _2IhTongVvo _3OE6xYgVvo _1UtDYzjOvk _3iDTPbgBM8 _37mLE4vLZJ",
            props.selected && "_0KLXru6bAP _1UtDYz6BYM",
            (0, $89c41c3c8147949b$export$9f1541de0780ef27)
        ])
    }, props.children);
};
$6edd072a5a0fd1f1$export$65704ff0d0294857.displayName = 'TickBoxWrapper';


const $ece475bbb085cc6f$export$65704ff0d0294857 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6edd072a5a0fd1f1$export$65704ff0d0294857), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6edd072a5a0fd1f1$export$65704ff0d0294857), props);
$ece475bbb085cc6f$export$65704ff0d0294857.displayName = 'TickBoxWrapper';


const $432e4663fc99cc82$export$58be5bf2cd389559 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { selected: selected } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            color: "currentColor",
            label: "tick",
            size: "small"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== selected) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ece475bbb085cc6f$export$65704ff0d0294857), {
            selected: selected
        }, t1);
        $[1] = selected;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ selected: selected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ece475bbb085cc6f$export$65704ff0d0294857), {
        selected: selected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        color: "currentColor",
        label: "tick",
        size: "small"
    }));












































const $34d9bc2365c92a27$var$hexToRgb = (hex)=>{
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}` : null;
};
const $34d9bc2365c92a27$export$4e46ac54fc82cf3b = (hex, opacity)=>`rgba(${$34d9bc2365c92a27$var$hexToRgb(hex)}, ${opacity})`;


const $d36a9bba13ba6d7d$var$smallLineHeight = 14;
const $d36a9bba13ba6d7d$var$smallVerticalPadding = 4;
const $d36a9bba13ba6d7d$var$smallHorizontalPadding = 8;
const $d36a9bba13ba6d7d$var$largeLineHeight = 22;
const $d36a9bba13ba6d7d$var$largeVerticalPadding = 8;
const $d36a9bba13ba6d7d$var$largeHorizontalPadding = 12;
const $d36a9bba13ba6d7d$var$responsiveStyleMap = {
    small: "_0Of8r2UNDJ _1ZnuxbJg58 _1wydGWUNDJ _2Zuz6QJg58 _0jFU0VnlTt",
    large: "_0Of8r2Jg58 _1ZnuxbxpxF _1wydGWJg58 _2Zuz6QxpxF _0jFU0VfI2J"
};
const $d36a9bba13ba6d7d$var$HEX_REGEX = /^#[0-9A-F]{6}$/i;
const $d36a9bba13ba6d7d$var$titleBoxWrapperStyles = null;
const $d36a9bba13ba6d7d$export$213c428ce4ec143c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(11);
    const { breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, hidden: hidden } = props;
    let t0;
    if ($[0] !== titleBoxBgColor) {
        t0 = titleBoxBgColor && (0, $34d9bc2365c92a27$export$4e46ac54fc82cf3b)($d36a9bba13ba6d7d$var$HEX_REGEX.test(titleBoxBgColor) ? titleBoxBgColor : "#FFFFFF", 1);
        $[0] = titleBoxBgColor;
        $[1] = t0;
    } else t0 = $[1];
    const color = t0;
    const t1 = hidden ? "none" : undefined;
    let t2;
    if ($[2] !== color || $[3] !== t1) {
        t2 = {
            backgroundColor: color,
            display: t1
        };
        $[2] = color;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = $d36a9bba13ba6d7d$var$responsiveStyleMap[breakpoint];
    let t4;
    if ($[5] !== t3) {
        t4 = (0, $hekY6.default)([
            "_1mT5xdWVPG _0Bm75GdnbC _39xV02N91d _0KLXrulfZc _1UtDYzy7kJ _0wOv4QOLYo _1pp6NdYbGa _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT",
            t3
        ]);
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== props.children || $[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: "titleBoxWrapper",
            "data-testid": "media-title-box",
            style: t2,
            className: t4
        }, props.children);
        $[7] = props.children;
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : (props)=>{
    const { breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, hidden: hidden } = props;
    const color = titleBoxBgColor && (0, $34d9bc2365c92a27$export$4e46ac54fc82cf3b)($d36a9bba13ba6d7d$var$HEX_REGEX.test(titleBoxBgColor) ? titleBoxBgColor : '#FFFFFF', 1);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "titleBoxWrapper",
        "data-testid": "media-title-box",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: color,
            display: hidden ? 'none' : undefined
        },
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _0Bm75GdnbC _39xV02N91d _0KLXrulfZc _1UtDYzy7kJ _0wOv4QOLYo _1pp6NdYbGa _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT",
            $d36a9bba13ba6d7d$var$responsiveStyleMap[breakpoint]
        ])
    }, props.children);
};
$d36a9bba13ba6d7d$export$213c428ce4ec143c.displayName = 'TitleBoxWrapper';
const $d36a9bba13ba6d7d$var$infoStyles = null;
const $d36a9bba13ba6d7d$var$iconOverlapStyle = null;
const $d36a9bba13ba6d7d$var$titleBoxHeaderStyles = null; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- Retain shared module-local Compiled styles across title-box components.
const $d36a9bba13ba6d7d$export$43970d913b015380 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { hasIconOverlap: hasIconOverlap } = props;
    const t0 = hasIconOverlap && "_1ZnuxbuFDC";
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $hekY6.default)([
            "_1kk5Tk7GSX",
            "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7",
            t0
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props.children || $[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: "titleBoxHeader",
            "data-testid": "title-box-header",
            className: t1
        }, props.children);
        $[2] = props.children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "titleBoxHeader",
        "data-testid": "title-box-header",
        className: (0, $hekY6.default)([
            "_1kk5Tk7GSX",
            "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7",
            hasIconOverlap && "_1ZnuxbuFDC"
        ])
    }, props.children);
};
$d36a9bba13ba6d7d$export$43970d913b015380.displayName = 'FailedTitleBoxHeader';
const $d36a9bba13ba6d7d$var$titleBoxFooterStyles = null; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- Retain shared module-local Compiled styles across title-box components.
const $d36a9bba13ba6d7d$export$1004da4fc5583975 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const { hasIconOverlap: hasIconOverlap, suppressHydrationWarning: suppressHydrationWarning } = props;
    const t0 = hasIconOverlap && "_1ZnuxbuFDC";
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $hekY6.default)([
            "_39HuIbz8Lp",
            "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7",
            t0
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props.children || $[3] !== suppressHydrationWarning || $[4] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: "titleBoxFooter",
            suppressHydrationWarning: suppressHydrationWarning,
            "data-testid": "title-box-footer",
            className: t1
        }, props.children);
        $[2] = props.children;
        $[3] = suppressHydrationWarning;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : (props)=>{
    const { hasIconOverlap: hasIconOverlap, suppressHydrationWarning: suppressHydrationWarning } = props;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "titleBoxFooter",
        suppressHydrationWarning: suppressHydrationWarning,
        "data-testid": "title-box-footer",
        className: (0, $hekY6.default)([
            "_39HuIbz8Lp",
            "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7",
            hasIconOverlap && "_1ZnuxbuFDC"
        ])
    }, props.children);
};
$d36a9bba13ba6d7d$export$1004da4fc5583975.displayName = 'TitleBoxFooter';
const $d36a9bba13ba6d7d$var$titleBoxIconStyles = null; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- Retain shared module-local Compiled styles across title-box components.
const $d36a9bba13ba6d7d$export$70e996312f72d22d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1mT5xdWVPG _4ApkO21Y8M _0Bm75G1Y8M"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: "titleBoxIcon",
            "data-testid": "title-box-icon",
            className: t0
        }, props.children);
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "titleBoxIcon",
        "data-testid": "title-box-icon",
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _4ApkO21Y8M _0Bm75G1Y8M"
        ])
    }, props.children);
};
const $d36a9bba13ba6d7d$var$errorMessageWrapperStyles = null; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- Retain shared module-local Compiled styles across title-box components.
const $d36a9bba13ba6d7d$export$9e874bb1adc98a55 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_2mHwu8FQfX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuchRC _0LQT5EFQfX"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t0
        }, props.children);
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu8FQfX _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuchRC _0LQT5EFQfX"
        ])
    }, props.children);
};


const $2f877661b604520e$export$9e874bb1adc98a55 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$9e874bb1adc98a55), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$9e874bb1adc98a55), props);












const $b156b8c71a93a037$export$213c428ce4ec143c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$213c428ce4ec143c), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$213c428ce4ec143c), props);


const $f0ca38055ced1477$var$errorMessageWrapperStyles = null;
const $f0ca38055ced1477$export$9b3b0baef32e2e39 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { breakpoint: breakpoint, customMessage: t1 } = t0;
    const customMessage = t1 === undefined ? (0, $fA65V.messages).failed_to_load : t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            label: "Warning",
            color: "var(--ds-text-danger, #AE2E24)",
            size: "small"
        });
        t3 = (0, $hekY6.default)([
            "_1RrJLit2nV _2XsHFM1Y8M _0adFHs1Y8M"
        ]);
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    let t4;
    if ($[2] !== customMessage) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f877661b604520e$export$9e874bb1adc98a55), null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t3
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), customMessage)));
        $[2] = customMessage;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== breakpoint || $[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b156b8c71a93a037$export$213c428ce4ec143c), {
            breakpoint: breakpoint
        }, t4);
        $[4] = breakpoint;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ breakpoint: breakpoint, customMessage: customMessage = (0, $fA65V.messages).failed_to_load })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b156b8c71a93a037$export$213c428ce4ec143c), {
        breakpoint: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f877661b604520e$export$9e874bb1adc98a55), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: 'Warning',
        color: "var(--ds-text-danger, #AE2E24)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_1RrJLit2nV _2XsHFM1Y8M _0adFHs1Y8M"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), customMessage))));
};









var $4efpo = parcelRequire("4efpo");


var $7cjAT = parcelRequire("7cjAT");



















const $c879ea104c39ca69$export$76bc6de55c805afb = (text, startFixedChars, endFixedChars)=>{
    const minAllowedLength = endFixedChars + startFixedChars;
    if (text.length <= minAllowedLength) // if no truncation return same value for left and right
    return {
        left: text,
        right: text
    };
    const splitAt = text.length - endFixedChars;
    const left = text.substr(0, splitAt);
    const right = text.substr(splitAt);
    return {
        left: left,
        right: right
    };
};














// requires style values to be defined in the same file that uses them.
const $0f8ef43b3b7c5820$var$fontFaceScaleFactor = (fontSizePX)=>fontSizePX / 11 * 0.46; /* factor for fontSize of 11px */ 
const $0f8ef43b3b7c5820$var$truncateCommonStyles = null;
const $0f8ef43b3b7c5820$var$truncateLeftStyles = null;
const $0f8ef43b3b7c5820$export$79559b74b73162c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    let children;
    let endFixedChars;
    let fontSizePX;
    let props;
    let startFixedChars;
    if ($[0] !== t0) {
        ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = endFixedChars;
        $[3] = fontSizePX;
        $[4] = props;
        $[5] = startFixedChars;
    } else {
        children = $[1];
        endFixedChars = $[2];
        fontSizePX = $[3];
        props = $[4];
        startFixedChars = $[5];
    }
    const t1 = `calc(
		100% -
			${$0f8ef43b3b7c5820$var$fontFaceScaleFactor(fontSizePX) * endFixedChars + 1}em
	)`;
    const t2 = $0f8ef43b3b7c5820$var$fontFaceScaleFactor(fontSizePX) * startFixedChars;
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = {
            maxWidth: t1,
            minWidth: t2
        };
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvbI6 _1RrJLiUWqv _1ANEUSLRg7",
            "_39HuIbz8Lp"
        ]);
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== children || $[11] !== props || $[12] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: t3,
            "data-testid": "truncate-left",
            ...props,
            className: t4
        }, children);
        $[10] = children;
        $[11] = props;
        $[12] = t3;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            maxWidth: `calc(
		100% -
			${$0f8ef43b3b7c5820$var$fontFaceScaleFactor(fontSizePX) * endFixedChars + 1}em
	)`,
            minWidth: $0f8ef43b3b7c5820$var$fontFaceScaleFactor(fontSizePX) * startFixedChars
        },
        "data-testid": "truncate-left",
        ...props,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvbI6 _1RrJLiUWqv _1ANEUSLRg7",
            "_39HuIbz8Lp"
        ])
    }, children);














// requires style values to be defined in the same file that uses them.
const $c3340ab5f190f006$var$fontFaceScaleFactor = (fontSizePX)=>fontSizePX / 11 * 0.46; /* factor for fontSize of 11px */ 
const $c3340ab5f190f006$var$truncateCommonStyles = null;
const $c3340ab5f190f006$var$truncateRightStyles = null;
const $c3340ab5f190f006$export$59f20ffe54d328be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        const { fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: t1, ...t2 } = t0;
        children = t1;
        props = t2;
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            maxWidth: `calc(
				100% -
					${$c3340ab5f190f006$var$_temp}
			)`
        };
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvbI6 _1RrJLiUWqv _1ANEUSLRg7",
            "_1mT5xdRAKS"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== props) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: t1,
            "data-testid": "truncate-right",
            ...props,
            className: t2
        }, children);
        $[5] = children;
        $[6] = props;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            maxWidth: `calc(
				100% -
					${({ fontSizePX: fontSizePX_0, startFixedChars: startFixedChars_0 })=>$c3340ab5f190f006$var$fontFaceScaleFactor(fontSizePX_0) * startFixedChars_0}
			)`
        },
        "data-testid": "truncate-right",
        ...props,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvbI6 _1RrJLiUWqv _1ANEUSLRg7",
            "_1mT5xdRAKS"
        ])
    }, children);
function $c3340ab5f190f006$var$_temp(t0) {
    const { fontSizePX: fontSizePX_0, startFixedChars: startFixedChars_0 } = t0;
    return $c3340ab5f190f006$var$fontFaceScaleFactor(fontSizePX_0) * startFixedChars_0;
}


const $c996d2e8c114c99f$var$placeholder = ' ';
const $c996d2e8c114c99f$export$cf4c160b6f7612df = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { text: text, fontSizePX: t1, startFixedChars: t2, endFixedChars: t3 } = t0;
    const fontSizePX = t1 === undefined ? 11 : t1;
    const startFixedChars = t2 === undefined ? 4 : t2;
    const endFixedChars = t3 === undefined ? 7 : t3;
    let t4;
    if ($[0] !== endFixedChars || $[1] !== startFixedChars || $[2] !== text) {
        t4 = (0, $c879ea104c39ca69$export$76bc6de55c805afb)(text, startFixedChars, endFixedChars);
        $[0] = endFixedChars;
        $[1] = startFixedChars;
        $[2] = text;
        $[3] = t4;
    } else t4 = $[3];
    const { left: leftStr, right: rightStr } = t4;
    let t5;
    if ($[4] !== endFixedChars || $[5] !== fontSizePX || $[6] !== leftStr || $[7] !== startFixedChars) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0f8ef43b3b7c5820$export$79559b74b73162c4), {
            fontSizePX: fontSizePX,
            startFixedChars: startFixedChars,
            endFixedChars: endFixedChars
        }, leftStr);
        $[4] = endFixedChars;
        $[5] = fontSizePX;
        $[6] = leftStr;
        $[7] = startFixedChars;
        $[8] = t5;
    } else t5 = $[8];
    const t6 = leftStr === rightStr ? $c996d2e8c114c99f$var$placeholder : rightStr;
    let t7;
    if ($[9] !== endFixedChars || $[10] !== fontSizePX || $[11] !== startFixedChars || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3340ab5f190f006$export$59f20ffe54d328be), {
            fontSizePX: fontSizePX,
            startFixedChars: startFixedChars,
            endFixedChars: endFixedChars
        }, t6);
        $[9] = endFixedChars;
        $[10] = fontSizePX;
        $[11] = startFixedChars;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t5 || $[15] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t5, t7);
        $[14] = t5;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    return t8;
} : ({ text: text, fontSizePX: fontSizePX = 11, startFixedChars: // Must be calibrated with fontSize
startFixedChars = 4, endFixedChars: // 1 char + 3 dots
endFixedChars = 7 // file extension 3/4 chars + a fraction of the name
 })=>{
    const { left: leftStr, right: rightStr } = (0, $c879ea104c39ca69$export$76bc6de55c805afb)(text, startFixedChars, endFixedChars);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0f8ef43b3b7c5820$export$79559b74b73162c4), {
        fontSizePX: fontSizePX,
        startFixedChars: startFixedChars,
        endFixedChars: endFixedChars
    }, leftStr), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3340ab5f190f006$export$59f20ffe54d328be), {
        fontSizePX: fontSizePX,
        startFixedChars: startFixedChars,
        endFixedChars: endFixedChars
    }, leftStr === rightStr ? $c996d2e8c114c99f$var$placeholder : rightStr));
};


const $9f3343b95aeb47b2$export$cf4c160b6f7612df = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c996d2e8c114c99f$export$cf4c160b6f7612df), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c996d2e8c114c99f$export$cf4c160b6f7612df), props);












const $929280f6698e06a3$export$1004da4fc5583975 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$1004da4fc5583975), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$1004da4fc5583975), props);












const $74431ae49f2934b9$export$43970d913b015380 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$43970d913b015380), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$43970d913b015380), props);












const $9818c9a49d9edc1a$export$70e996312f72d22d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$70e996312f72d22d), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d36a9bba13ba6d7d$export$70e996312f72d22d), props);



const $a2015ff08cec1784$var$placeholderText = ' ';
const $a2015ff08cec1784$var$isValidTimestamp = (timeStamp)=>new Date(timeStamp).getTime() > 0;
const $a2015ff08cec1784$export$e3ce443f3b72c291 = (0, $kSwu1.injectIntl)(({ name: name, createdAt: createdAt, breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, hidden: _hidden, intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b156b8c71a93a037$export$213c428ce4ec143c), {
        breakpoint: breakpoint,
        titleBoxBgColor: titleBoxBgColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74431ae49f2934b9$export$43970d913b015380), {
        hasIconOverlap: !!titleBoxIcon && !createdAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f3343b95aeb47b2$export$cf4c160b6f7612df), {
        text: name ?? $a2015ff08cec1784$var$placeholderText
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $929280f6698e06a3$export$1004da4fc5583975), {
        hasIconOverlap: !!titleBoxIcon,
        // Suppressing it here because of a timezone mismatch in the createdAt text
        // that can cause a late mutation in the attachments strip view
        suppressHydrationWarning: true
    }, createdAt !== undefined && $a2015ff08cec1784$var$isValidTimestamp(createdAt) ? (0, $7cjAT.formatDate)(createdAt, intl?.locale ?? 'en') : $a2015ff08cec1784$var$placeholderText), titleBoxIcon === 'LockFilledIcon' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9818c9a49d9edc1a$export$70e996312f72d22d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        color: "currentColor",
        label: "",
        size: "small"
    }))), {
    enforceContext: false
});


























const $6932299af23d8e2b$var$imageContainerStyles = null;
const $6932299af23d8e2b$var$imageContainerCenterStyles = null;
const $6932299af23d8e2b$export$94026ee33dbabc26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, mediaName: mediaName, status: status, progress: progress, selected: selected, source: source, centerElements: centerElements, mediaCardCursor: mediaCardCursor } = t0;
    const t1 = centerElements && "_0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD4OpY _3iDTPbQ4SZ _1mT5xdRAKS _1EqgXlN91d _39xV02N91d _0jFU0VN91d _0NUa3rN91d",
            t1,
            (0, $cOUnF.fileCardImageViewSelector)
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== mediaCardCursor || $[4] !== mediaName || $[5] !== progress || $[6] !== selected || $[7] !== source || $[8] !== status || $[9] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": (0, $cOUnF.fileCardImageViewSelector),
            className: t2,
            "data-test-media-name": mediaName,
            "data-test-status": status,
            "data-test-progress": progress,
            "data-test-selected": selected,
            "data-test-source": source,
            "data-cursor": mediaCardCursor
        }, children);
        $[2] = children;
        $[3] = mediaCardCursor;
        $[4] = mediaName;
        $[5] = progress;
        $[6] = selected;
        $[7] = source;
        $[8] = status;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, mediaName: mediaName, status: status, progress: progress, selected: selected, source: source, centerElements: centerElements, mediaCardCursor: mediaCardCursor })=>/*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": (0, $cOUnF.fileCardImageViewSelector),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD4OpY _3iDTPbQ4SZ _1mT5xdRAKS _1EqgXlN91d _39xV02N91d _0jFU0VN91d _0NUa3rN91d",
            centerElements && "_0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT",
            (0, $cOUnF.fileCardImageViewSelector)
        ]),
        "data-test-media-name": mediaName,
        "data-test-status": status,
        "data-test-progress": progress,
        "data-test-selected": selected,
        "data-test-source": source,
        "data-cursor": mediaCardCursor
    }, children);


const $7830061118cc5b5a$export$94026ee33dbabc26 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6932299af23d8e2b$export$94026ee33dbabc26), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6932299af23d8e2b$export$94026ee33dbabc26), props);
























var $ls1Uk = parcelRequire("ls1Uk");


var $5o4s6 = parcelRequire("5o4s6");




function $db6888c0e741c2bb$export$c42371b64d1354a0(value) {
    return typeof value === 'string' ? value : `${value}px`;
}





const $d1ee9b73a670aaa3$export$368b9072d13ed840 = '--media-wrapper-width';
const $d1ee9b73a670aaa3$export$838fbe44d5770647 = '--media-wrapper-height';
const $d1ee9b73a670aaa3$var$wrapperStyles = {
    default: "_0bjKvD4OpY _24h04i2Njc _1mT5xdRAKS _0WKd3G4z3T _1EqgXlN91d _0NUa3rN91d _39xV02hncN _0jFU0VITTj _3xl6b4fNHp _4cQZo72Njc _0X7HnuA5lS _1vpuEl7dHp _3WOM967dHp"
};
const $d1ee9b73a670aaa3$var$backgroundStyle = null;
const $d1ee9b73a670aaa3$var$shadowStyleMap = {
    withOverlay: "_2OUyjtzwhj",
    selected: "_2OUyjt2o41",
    selectedWithOverlay: "_2OUyjt7AgL"
};
const $d1ee9b73a670aaa3$var$getShadowKey = (disableOverlay, selected)=>{
    if (!disableOverlay && selected) return 'selectedWithOverlay';
    if (!disableOverlay) return 'withOverlay';
    if (selected) return 'selected';
    return '';
};
const $d1ee9b73a670aaa3$var$hideNativeBrowserTextSelectionStyles = null;
const $d1ee9b73a670aaa3$var$clickableButtonPlayButtonStyles = null;
const $d1ee9b73a670aaa3$var$selectableTickboxStyle = null;
const $d1ee9b73a670aaa3$var$tooltipStyle = null; // These styles target data attributes to enable the exclusion from TTVC metric calculation.
const $d1ee9b73a670aaa3$var$cursorStyle = null;
const $d1ee9b73a670aaa3$var$getResponsiveStyles = (breakpoint)=>{
    // dynamically setting the properties to avoid ratcheting build errors. These need to be removed however for the compiled transformation.
    return breakpoint === 'small' ? {
        ['fontSize']: '11px',
        ['lineHeight']: '14px'
    } : {
        ['fontSize']: '14px',
        ['lineHeight']: '22px'
    };
};
const $d1ee9b73a670aaa3$export$e6dfd72ab29f8598 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(31);
    const { testId: testId, dimensions: dimensions, appearance: appearance, onClick: onClick, onMouseEnter: onMouseEnter, onFocus: onFocus, innerRef: innerRef, breakpoint: breakpoint, disableOverlay: disableOverlay, selected: selected, displayBackground: displayBackground, isPlayButtonClickable: isPlayButtonClickable, isTickBoxSelectable: isTickBoxSelectable, shouldDisplayTooltip: shouldDisplayTooltip } = props;
    let t0;
    if ($[0] !== appearance) {
        t0 = (0, $gjPL4.getDefaultCardDimensions)(appearance);
        $[0] = appearance;
        $[1] = t0;
    } else t0 = $[1];
    const defaultImageCardDimensions = t0;
    const t1 = dimensions?.width || defaultImageCardDimensions.width;
    let t2;
    if ($[2] !== t1) {
        t2 = (0, $db6888c0e741c2bb$export$c42371b64d1354a0)(t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const width = t2;
    const t3 = dimensions?.height || defaultImageCardDimensions.height;
    let t4;
    if ($[4] !== t3) {
        t4 = (0, $db6888c0e741c2bb$export$c42371b64d1354a0)(t3);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const height = t4;
    let t5;
    let t6;
    if ($[6] !== disableOverlay || $[7] !== displayBackground || $[8] !== isPlayButtonClickable || $[9] !== isTickBoxSelectable || $[10] !== selected || $[11] !== shouldDisplayTooltip) {
        const wrapperShadowKey = $d1ee9b73a670aaa3$var$getShadowKey(disableOverlay, selected);
        t5 = "newFileExperienceWrapper";
        t6 = (0, $hekY6.default)([
            $d1ee9b73a670aaa3$var$wrapperStyles.default,
            "_2gUfE77zJH _0nG2F6RaMg",
            displayBackground && "_0KLXrunmFW",
            wrapperShadowKey && $d1ee9b73a670aaa3$var$shadowStyleMap[wrapperShadowKey],
            selected && "_41Q9JKjOvk _4c6mrZjOvk _2GL08AjOvk _3WhCh6jOvk",
            isPlayButtonClickable && "_4DnTNvmdCj _32ekkymdCj",
            isTickBoxSelectable && "_4EbbA07Cj1 _4BdgFb4YkS",
            shouldDisplayTooltip && "_1pNvAKN91d _07FvaKN91d",
            (0, $ls1Uk.newFileExperienceClassName)
        ]);
        $[6] = disableOverlay;
        $[7] = displayBackground;
        $[8] = isPlayButtonClickable;
        $[9] = isTickBoxSelectable;
        $[10] = selected;
        $[11] = shouldDisplayTooltip;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    let t7;
    if ($[14] !== breakpoint) {
        t7 = $d1ee9b73a670aaa3$var$getResponsiveStyles(breakpoint);
        $[14] = breakpoint;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== height || $[17] !== t7 || $[18] !== width) {
        t8 = {
            [$d1ee9b73a670aaa3$export$368b9072d13ed840]: width,
            [$d1ee9b73a670aaa3$export$838fbe44d5770647]: height,
            ...t7
        };
        $[16] = height;
        $[17] = t7;
        $[18] = width;
        $[19] = t8;
    } else t8 = $[19];
    const t9 = t8;
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
            data: {
                hasMediaComponent: true
            }
        });
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== innerRef || $[22] !== onClick || $[23] !== onFocus || $[24] !== onMouseEnter || $[25] !== props.children || $[26] !== t5 || $[27] !== t6 || $[28] !== t9 || $[29] !== testId) {
        t11 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: t5,
            className: t6,
            "data-testid": testId,
            style: t9,
            ref: innerRef,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onFocus: onFocus,
            ...(0, $5o4s6.VcMediaWrapperProps),
            role: "none"
        }, t10, props.children);
        $[21] = innerRef;
        $[22] = onClick;
        $[23] = onFocus;
        $[24] = onMouseEnter;
        $[25] = props.children;
        $[26] = t5;
        $[27] = t6;
        $[28] = t9;
        $[29] = testId;
        $[30] = t11;
    } else t11 = $[30];
    return t11;
} : (props)=>{
    const { testId: testId, dimensions: dimensions, appearance: appearance, onClick: onClick, onMouseEnter: onMouseEnter, onFocus: onFocus, innerRef: innerRef, breakpoint: breakpoint, disableOverlay: disableOverlay, selected: selected, displayBackground: displayBackground, isPlayButtonClickable: isPlayButtonClickable, isTickBoxSelectable: isTickBoxSelectable, shouldDisplayTooltip: shouldDisplayTooltip } = props;
    const defaultImageCardDimensions = (0, $gjPL4.getDefaultCardDimensions)(appearance);
    const width = (0, $db6888c0e741c2bb$export$c42371b64d1354a0)(dimensions?.width || defaultImageCardDimensions.width);
    const height = (0, $db6888c0e741c2bb$export$c42371b64d1354a0)(dimensions?.height || defaultImageCardDimensions.height);
    const wrapperShadowKey = $d1ee9b73a670aaa3$var$getShadowKey(disableOverlay, selected);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "newFileExperienceWrapper",
        className: (0, $hekY6.default)([
            $d1ee9b73a670aaa3$var$wrapperStyles.default,
            "_2gUfE77zJH _0nG2F6RaMg",
            displayBackground && "_0KLXrunmFW",
            wrapperShadowKey && $d1ee9b73a670aaa3$var$shadowStyleMap[wrapperShadowKey],
            selected && "_41Q9JKjOvk _4c6mrZjOvk _2GL08AjOvk _3WhCh6jOvk",
            isPlayButtonClickable && "_4DnTNvmdCj _32ekkymdCj",
            isTickBoxSelectable && "_4EbbA07Cj1 _4BdgFb4YkS",
            shouldDisplayTooltip && "_1pNvAKN91d _07FvaKN91d",
            (0, $ls1Uk.newFileExperienceClassName)
        ]),
        "data-testid": testId,
        style: {
            [$d1ee9b73a670aaa3$export$368b9072d13ed840]: width,
            [$d1ee9b73a670aaa3$export$838fbe44d5770647]: height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...$d1ee9b73a670aaa3$var$getResponsiveStyles(breakpoint)
        },
        ref: innerRef,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        ...(0, $5o4s6.VcMediaWrapperProps),
        role: "none"
    }, /*#__PURE__*/ $cozmU.createElement((0, $3PNw6.default), {
        data: {
            hasMediaComponent: true
        }
    }), props.children);
};
$d1ee9b73a670aaa3$export$e6dfd72ab29f8598.displayName = 'NewFileExperienceWrapper';


const $ef6324d61d97f0a3$export$e6dfd72ab29f8598 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d1ee9b73a670aaa3$export$e6dfd72ab29f8598), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d1ee9b73a670aaa3$export$e6dfd72ab29f8598), props);



var $4eMGH = parcelRequire("4eMGH");

const $4fd3933024dfee84$var$i18n = (0, $kSwu1.defineMessages)({
    traceIdTooltip: {
        id: "fabric.media.trace_id_tooltip",
        defaultMessage: "Use Trace ID {traceId} when reaching out to support."
    },
    aiGeneratingImage: {
        id: "fabric.media.ai_generating_image",
        defaultMessage: "AI generating image"
    }
});
const $4fd3933024dfee84$export$fe522702db3259fa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(162);
    const { identifier: identifier, innerRef: t1, onImageLoad: onImageLoad, onImageError: onImageError, dimensions: dimensions, onClick: onClick, onMouseEnter: onMouseEnter, onFocus: onFocus, testId: testId, metadata: metadata, status: status, selected: selected, selectable: selectable, cardPreview: cardPreview, mediaCardCursor: mediaCardCursor, shouldHideTooltip: shouldHideTooltip, progress: progress, alt: alt, resizeMode: resizeMode, onDisplayImage: onDisplayImage, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, actions: actions, disableOverlay: disableOverlay, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, error: error, disableAnimation: disableAnimation, openMediaViewerButtonRef: t2, shouldOpenMediaViewer: shouldOpenMediaViewer, overriddenCreationDate: overriddenCreationDate, onSvgError: onSvgError, onSvgLoad: onSvgLoad, traceId: traceId, isAIGenerating: isAIGenerating, isCWR: isCWR, backgroundColor: backgroundColor } = t0;
    const innerRef = t1 === undefined ? null : t1;
    const openMediaViewerButtonRef = t2 === undefined ? null : t2;
    const intl = (0, $kSwu1.useIntl)();
    const [didSvgRender, setDidSvgRender] = (0, $cozmU.useState)(false);
    const [didImageRender, setDidImageRender] = (0, $cozmU.useState)(false);
    const divRef = (0, $cozmU.useRef)(null);
    const prevCardPreviewRef = (0, $cozmU.useRef)();
    const breakpoint = (0, $4eMGH.useBreakpoint)(dimensions?.width, divRef);
    let t3;
    let t4;
    if ($[0] !== cardPreview) {
        t3 = ()=>{
            if (prevCardPreviewRef.current && !cardPreview) setDidImageRender(false);
            prevCardPreviewRef.current = cardPreview;
        };
        t4 = [
            cardPreview
        ];
        $[0] = cardPreview;
        $[1] = t3;
        $[2] = t4;
    } else {
        t3 = $[1];
        t4 = $[2];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[3] !== cardPreview || $[4] !== onImageLoad) {
        t5 = (prevCardPreview)=>{
            if (prevCardPreview.dataURI !== cardPreview?.dataURI) return;
            setDidImageRender(true);
            onImageLoad?.(cardPreview);
        };
        $[3] = cardPreview;
        $[4] = onImageLoad;
        $[5] = t5;
    } else t5 = $[5];
    const handleOnImageLoad = t5;
    let t6;
    if ($[6] !== cardPreview || $[7] !== onImageError) {
        t6 = (prevCardPreview_0)=>{
            if (prevCardPreview_0.dataURI !== cardPreview?.dataURI) return;
            setDidImageRender(false);
            onImageError?.(cardPreview);
        };
        $[6] = cardPreview;
        $[7] = onImageError;
        $[8] = t6;
    } else t6 = $[8];
    const handleOnImageError = t6;
    let t7;
    if ($[9] !== cardPreview || $[10] !== metadata) {
        t7 = ()=>{
            const { mediaType: mediaType } = metadata || {};
            if (mediaType !== "video" || !cardPreview) return false;
            return true;
        };
        $[9] = cardPreview;
        $[10] = metadata;
        $[11] = t7;
    } else t7 = $[11];
    const shouldRenderPlayButton = t7;
    let t8;
    if ($[12] !== innerRef) {
        t8 = [
            divRef,
            innerRef
        ];
        $[12] = innerRef;
        $[13] = t8;
    } else t8 = $[13];
    const mergedRef = (0, $2VwyL.useMergeRefs)(t8);
    let t9;
    if ($[14] !== cardPreview || $[15] !== didImageRender || $[16] !== didSvgRender || $[17] !== disableAnimation || $[18] !== disableOverlay || $[19] !== error || $[20] !== isAIGenerating || $[21] !== metadata || $[22] !== selectable || $[23] !== status) {
        const getRenderConfigByStatus = ()=>{
            const { name: name, mediaType: mediaType_0, mimeType: mimeType } = metadata || {};
            const isZeroSize = metadata && metadata.size === 0;
            const defaultConfig = {
                renderTypeIcon: !didImageRender && !didSvgRender,
                renderImageRenderer: !didSvgRender,
                renderSvgView: mimeType === "image/svg+xml",
                renderPlayButton: !!cardPreview && mediaType_0 === "video",
                renderBlanket: !disableOverlay,
                renderTitleBox: !disableOverlay,
                renderTickBox: !disableOverlay && !!selectable
            };
            const loadingConfig = {
                ...defaultConfig,
                renderPlayButton: false,
                renderTypeIcon: false,
                renderSpinner: !didImageRender && !didSvgRender
            };
            switch(status){
                case "uploading":
                    return {
                        ...defaultConfig,
                        renderBlanket: !disableOverlay || mediaType_0 !== "video",
                        isFixedBlanket: true,
                        renderProgressBar: !isAIGenerating
                    };
                case "processing":
                    return {
                        ...defaultConfig,
                        iconMessage: !didImageRender && !isZeroSize ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe28e9a23446cea1$export$4a80244213cb4afc), {
                            disableAnimation: disableAnimation
                        }) : undefined
                    };
                case "complete":
                    return defaultConfig;
                case "error":
                case "failed-processing":
                    {
                        if (status === "failed-processing" && mimeType === "image/svg+xml") return loadingConfig;
                        const baseErrorConfig = {
                            ...defaultConfig,
                            renderTypeIcon: true,
                            renderImageRenderer: false,
                            renderSvgView: false,
                            renderTitleBox: false,
                            renderPlayButton: false
                        };
                        let iconMessage;
                        let customTitleMessage;
                        let traceTooltipVariant;
                        if ((0, $401e23545d820d5c$export$11f9f5835c5b9a04)(error)) {
                            iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17c2065bc332e889$export$f6b7f98fc8b4c6c7), null);
                            customTitleMessage = (0, $fA65V.messages).failed_to_upload;
                        } else {
                            if ((0, $4138ebdf60975a3f$export$476aa014e2fd89d5)(error) && (0, $iDrrr.fg)("media_card_failed_messaging_ui_revamp")) {
                                iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17ba6bcdea2acebd$export$acb8738584883d89), null);
                                customTitleMessage = (0, $fA65V.messages).check_internet_connection;
                            } else if (!metadata) {
                                iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e482048df30fb6af$export$a712c963efa9c728), null);
                                traceTooltipVariant = "failed-to-load";
                            } else {
                                iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aafda3669d76c197$export$35337070c6dafccf), null);
                                traceTooltipVariant = "preview-unavailable";
                            }
                        }
                        if (!disableOverlay) {
                            const renderFailedTitleBox = !name || !!customTitleMessage;
                            return {
                                ...baseErrorConfig,
                                renderTitleBox: !!name && !customTitleMessage,
                                renderFailedTitleBox: renderFailedTitleBox,
                                iconMessage: !renderFailedTitleBox ? iconMessage : undefined,
                                customTitleMessage: customTitleMessage,
                                traceTooltipVariant: traceTooltipVariant
                            };
                        }
                        return {
                            ...baseErrorConfig,
                            iconMessage: iconMessage,
                            traceTooltipVariant: traceTooltipVariant
                        };
                    }
                case "loading-preview":
                case "loading":
                default:
                    return loadingConfig;
            }
        };
        t9 = getRenderConfigByStatus();
        $[14] = cardPreview;
        $[15] = didImageRender;
        $[16] = didSvgRender;
        $[17] = disableAnimation;
        $[18] = disableOverlay;
        $[19] = error;
        $[20] = isAIGenerating;
        $[21] = metadata;
        $[22] = selectable;
        $[23] = status;
        $[24] = t9;
    } else t9 = $[24];
    const { renderTypeIcon: renderTypeIcon, iconMessage: iconMessage_0, renderImageRenderer: renderImageRenderer, renderSvgView: renderSvgView, renderSpinner: renderSpinner, renderPlayButton: renderPlayButton, renderBlanket: renderBlanket, renderProgressBar: renderProgressBar, renderTitleBox: renderTitleBox, renderFailedTitleBox: renderFailedTitleBox_0, renderTickBox: renderTickBox, isFixedBlanket: isFixedBlanket, customTitleMessage: customTitleMessage_0, traceTooltipVariant: traceTooltipVariant_0 } = t9;
    let t10;
    if ($[25] !== isAIGenerating) {
        t10 = !!isAIGenerating && (0, $iDrrr.fg)("cc-maui-phase-2") && (0, $ieeJu.expValEquals)("cc-maui-experiment", "isEnabled", true);
        $[25] = isAIGenerating;
        $[26] = t10;
    } else t10 = $[26];
    const renderAIBorderOverride = t10;
    const shouldDisplayBackground = !cardPreview || !disableOverlay || status === "error" || status === "failed-processing";
    const isPlayButtonClickable = shouldRenderPlayButton() && !!disableOverlay;
    const isTickBoxSelectable = !disableOverlay && !!selectable && !selected;
    let t11;
    if ($[27] !== metadata) {
        t11 = metadata || {};
        $[27] = metadata;
        $[28] = t11;
    } else t11 = $[28];
    const { mediaType: mediaType_1, mimeType: mimeType_0, name: name_0, createdAt: createdAt } = t11;
    const shouldShowTraceIdTooltip = !!traceTooltipVariant_0 && !!traceId;
    let t12;
    if ($[29] !== intl || $[30] !== name_0 || $[31] !== shouldShowTraceIdTooltip || $[32] !== traceId) {
        t12 = shouldShowTraceIdTooltip ? intl.formatMessage($4fd3933024dfee84$var$i18n.traceIdTooltip, {
            traceId: traceId
        }) : name_0;
        $[29] = intl;
        $[30] = name_0;
        $[31] = shouldShowTraceIdTooltip;
        $[32] = traceId;
        $[33] = t12;
    } else t12 = $[33];
    const tooltipContent = t12;
    const shouldDisplayTooltip = !disableOverlay && !shouldHideTooltip;
    const isTitleBoxVisible = renderTitleBox && name_0;
    const hasVisibleTitleBox = !!(isTitleBoxVisible || renderFailedTitleBox_0);
    const metadataRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(metadata);
    let t13;
    bb0: {
        if (!actions) {
            let t14;
            if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
                t14 = [];
                $[34] = t14;
            } else t14 = $[34];
            t13 = t14;
            break bb0;
        }
        let t14;
        if ($[35] !== actions || $[36] !== metadataRef) {
            t14 = actions.map((action)=>({
                    ...action,
                    handler: ()=>{
                        if (!metadataRef.current) action.handler();
                        else action.handler({
                            type: "file",
                            details: metadataRef.current
                        });
                    }
                }));
            $[35] = actions;
            $[36] = metadataRef;
            $[37] = t14;
        } else t14 = $[37];
        t13 = t14;
    }
    const actionsWithDetails = t13;
    let t14;
    if ($[38] !== onSvgLoad) {
        t14 = ()=>{
            setDidSvgRender(true);
            onSvgLoad?.();
        };
        $[38] = onSvgLoad;
        $[39] = t14;
    } else t14 = $[39];
    const onSvgLoadBase = t14;
    let t15;
    if ($[40] !== didSvgRender) {
        t15 = didSvgRender && !(0, $iDrrr.fg)("platform_media_card_image_render");
        $[40] = didSvgRender;
        $[41] = t15;
    } else t15 = $[41];
    const t16 = cardPreview?.source;
    let t17;
    if ($[42] !== breakpoint || $[43] !== hasVisibleTitleBox || $[44] !== iconMessage_0 || $[45] !== mediaType_1 || $[46] !== mimeType_0 || $[47] !== name_0 || $[48] !== renderTypeIcon) {
        t17 = renderTypeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87f3b9d7cf4b76fc$export$be58b4326e23250f), {
            breakpoint: breakpoint,
            hasTitleBox: hasVisibleTitleBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6xGZY.MimeTypeIcon), {
            testId: "media-card-file-type-icon",
            mediaType: mediaType_1,
            mimeType: mimeType_0,
            name: name_0
        }), iconMessage_0);
        $[42] = breakpoint;
        $[43] = hasVisibleTitleBox;
        $[44] = iconMessage_0;
        $[45] = mediaType_1;
        $[46] = mimeType_0;
        $[47] = name_0;
        $[48] = renderTypeIcon;
        $[49] = t17;
    } else t17 = $[49];
    let t18;
    if ($[50] !== breakpoint || $[51] !== disableAnimation || $[52] !== hasVisibleTitleBox || $[53] !== renderSpinner) {
        t18 = renderSpinner && ((0, $ieeJu.expValEquals)("cc-maui-ai-edit-loading-experiment", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
            animationDisabled: disableAnimation,
            testId: "media-card-loading",
            interactionName: "media-card-loading"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87f3b9d7cf4b76fc$export$be58b4326e23250f), {
            breakpoint: breakpoint,
            hasTitleBox: hasVisibleTitleBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            testId: "media-card-loading",
            interactionName: "media-card-loading"
        })));
        $[50] = breakpoint;
        $[51] = disableAnimation;
        $[52] = hasVisibleTitleBox;
        $[53] = renderSpinner;
        $[54] = t18;
    } else t18 = $[54];
    let t19;
    if ($[55] !== backgroundColor || $[56] !== identifier || $[57] !== onSvgError || $[58] !== onSvgLoadBase || $[59] !== renderSvgView || $[60] !== resizeMode) {
        t19 = renderSvgView && identifier && (0, $jmmTp.isFileIdentifier)(identifier) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cc53140db039fca1$export$cf98b60e5f1e2515), {
            identifier: identifier,
            resizeMode: resizeMode || "crop",
            onError: onSvgError,
            onLoad: onSvgLoadBase,
            wrapperRef: divRef,
            backgroundColor: backgroundColor
        });
        $[55] = backgroundColor;
        $[56] = identifier;
        $[57] = onSvgError;
        $[58] = onSvgLoadBase;
        $[59] = renderSvgView;
        $[60] = resizeMode;
        $[61] = t19;
    } else t19 = $[61];
    let t20;
    if ($[62] !== alt || $[63] !== backgroundColor || $[64] !== cardPreview || $[65] !== forceSyncDisplay || $[66] !== handleOnImageError || $[67] !== handleOnImageLoad || $[68] !== identifier || $[69] !== metadata?.mediaType || $[70] !== name_0 || $[71] !== nativeLazyLoad || $[72] !== onDisplayImage || $[73] !== renderImageRenderer || $[74] !== resizeMode) {
        t20 = renderImageRenderer && identifier && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f8b624677c640c5$export$a8e6523ab063becd), {
            cardPreview: cardPreview,
            mediaType: metadata?.mediaType || "unknown",
            alt: alt ?? name_0,
            resizeMode: resizeMode,
            onDisplayImage: onDisplayImage,
            onImageLoad: handleOnImageLoad,
            onImageError: handleOnImageError,
            nativeLazyLoad: nativeLazyLoad,
            forceSyncDisplay: forceSyncDisplay,
            identifier: identifier,
            wrapperRef: divRef,
            backgroundColor: backgroundColor
        });
        $[62] = alt;
        $[63] = backgroundColor;
        $[64] = cardPreview;
        $[65] = forceSyncDisplay;
        $[66] = handleOnImageError;
        $[67] = handleOnImageLoad;
        $[68] = identifier;
        $[69] = metadata?.mediaType;
        $[70] = name_0;
        $[71] = nativeLazyLoad;
        $[72] = onDisplayImage;
        $[73] = renderImageRenderer;
        $[74] = resizeMode;
        $[75] = t20;
    } else t20 = $[75];
    let t21;
    if ($[76] !== breakpoint || $[77] !== hasVisibleTitleBox || $[78] !== renderPlayButton) {
        t21 = renderPlayButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87f3b9d7cf4b76fc$export$be58b4326e23250f), {
            breakpoint: breakpoint,
            hasTitleBox: hasVisibleTitleBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e6a176bd5fe3e08$export$fbed5f62d839a0cd), null));
        $[76] = breakpoint;
        $[77] = hasVisibleTitleBox;
        $[78] = renderPlayButton;
        $[79] = t21;
    } else t21 = $[79];
    let t22;
    if ($[80] !== intl || $[81] !== isCWR || $[82] !== isFixedBlanket || $[83] !== renderAIBorderOverride || $[84] !== renderBlanket) {
        t22 = renderAIBorderOverride ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $41681b111635fa1d$export$dadfe5b5cfcd2b0e), {
            label: intl.formatMessage($4fd3933024dfee84$var$i18n.aiGeneratingImage),
            testId: "media-card-ai-generating-overlay",
            isOpaque: isCWR
        }) : renderBlanket && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21d414d99db4a105$export$5b927fc1ef8c468b), {
            isFixed: isFixedBlanket
        });
        $[80] = intl;
        $[81] = isCWR;
        $[82] = isFixedBlanket;
        $[83] = renderAIBorderOverride;
        $[84] = renderBlanket;
        $[85] = t22;
    } else t22 = $[85];
    let t23;
    if ($[86] !== breakpoint || $[87] !== createdAt || $[88] !== isTitleBoxVisible || $[89] !== name_0 || $[90] !== overriddenCreationDate || $[91] !== renderTitleBox || $[92] !== titleBoxBgColor || $[93] !== titleBoxIcon) {
        t23 = renderTitleBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2015ff08cec1784$export$e3ce443f3b72c291), {
            name: name_0,
            createdAt: overriddenCreationDate ?? createdAt,
            breakpoint: breakpoint,
            titleBoxIcon: titleBoxIcon,
            titleBoxBgColor: titleBoxBgColor,
            hidden: !isTitleBoxVisible
        });
        $[86] = breakpoint;
        $[87] = createdAt;
        $[88] = isTitleBoxVisible;
        $[89] = name_0;
        $[90] = overriddenCreationDate;
        $[91] = renderTitleBox;
        $[92] = titleBoxBgColor;
        $[93] = titleBoxIcon;
        $[94] = t23;
    } else t23 = $[94];
    let t24;
    if ($[95] !== breakpoint || $[96] !== customTitleMessage_0 || $[97] !== renderFailedTitleBox_0) {
        t24 = renderFailedTitleBox_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0ca38055ced1477$export$9b3b0baef32e2e39), {
            breakpoint: breakpoint,
            customMessage: customTitleMessage_0
        });
        $[95] = breakpoint;
        $[96] = customTitleMessage_0;
        $[97] = renderFailedTitleBox_0;
        $[98] = t24;
    } else t24 = $[98];
    let t25;
    if ($[99] !== breakpoint || $[100] !== hasVisibleTitleBox || $[101] !== progress || $[102] !== renderProgressBar) {
        t25 = renderProgressBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k5Bdp.ProgressBar), {
            progress: progress,
            breakpoint: breakpoint,
            positionBottom: !hasVisibleTitleBox
        });
        $[99] = breakpoint;
        $[100] = hasVisibleTitleBox;
        $[101] = progress;
        $[102] = renderProgressBar;
        $[103] = t25;
    } else t25 = $[103];
    let t26;
    if ($[104] !== renderTickBox || $[105] !== selected) {
        t26 = renderTickBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $432e4663fc99cc82$export$58be5bf2cd389559), {
            selected: selected
        });
        $[104] = renderTickBox;
        $[105] = selected;
        $[106] = t26;
    } else t26 = $[106];
    let t27;
    if ($[107] !== mediaCardCursor || $[108] !== name_0 || $[109] !== progress || $[110] !== selected || $[111] !== status || $[112] !== t15 || $[113] !== t16 || $[114] !== t17 || $[115] !== t18 || $[116] !== t19 || $[117] !== t20 || $[118] !== t21 || $[119] !== t22 || $[120] !== t23 || $[121] !== t24 || $[122] !== t25 || $[123] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7830061118cc5b5a$export$94026ee33dbabc26), {
            centerElements: t15,
            testId: (0, $cOUnF.fileCardImageViewSelector),
            mediaName: name_0,
            status: status,
            progress: progress,
            mediaCardCursor: mediaCardCursor,
            selected: selected,
            source: t16
        }, t17, t18, t19, t20, t21, t22, t23, t24, t25, t26);
        $[107] = mediaCardCursor;
        $[108] = name_0;
        $[109] = progress;
        $[110] = selected;
        $[111] = status;
        $[112] = t15;
        $[113] = t16;
        $[114] = t17;
        $[115] = t18;
        $[116] = t19;
        $[117] = t20;
        $[118] = t21;
        $[119] = t22;
        $[120] = t23;
        $[121] = t24;
        $[122] = t25;
        $[123] = t26;
        $[124] = t27;
    } else t27 = $[124];
    let t28;
    if ($[125] !== actions || $[126] !== actionsWithDetails || $[127] !== disableOverlay || $[128] !== name_0) {
        t28 = disableOverlay || !actions || actions.length === 0 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $457f2c417ecea897$export$8c8e9293b68041de), {
            filename: name_0,
            actions: actionsWithDetails
        });
        $[125] = actions;
        $[126] = actionsWithDetails;
        $[127] = disableOverlay;
        $[128] = name_0;
        $[129] = t28;
    } else t28 = $[129];
    let t29;
    if ($[130] !== t27 || $[131] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t27, t28);
        $[130] = t27;
        $[131] = t28;
        $[132] = t29;
    } else t29 = $[132];
    const contents = t29;
    let t30;
    if ($[133] !== name_0 || $[134] !== onClick || $[135] !== openMediaViewerButtonRef || $[136] !== shouldOpenMediaViewer) {
        t30 = shouldOpenMediaViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $00a35784f97edcc7$export$2e2bcd8739ae039), {
            fileName: name_0 ?? "",
            innerRef: openMediaViewerButtonRef,
            onClick: onClick
        });
        $[133] = name_0;
        $[134] = onClick;
        $[135] = openMediaViewerButtonRef;
        $[136] = shouldOpenMediaViewer;
        $[137] = t30;
    } else t30 = $[137];
    const t31 = testId || "media-card-view";
    const t32 = name_0 || "Media Card";
    const t33 = !!disableOverlay;
    const t34 = !!selected;
    let t35;
    if ($[138] !== contents || $[139] !== shouldDisplayTooltip || $[140] !== tooltipContent) {
        t35 = shouldDisplayTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipContent,
            position: "bottom",
            tag: "div"
        }, contents) : contents;
        $[138] = contents;
        $[139] = shouldDisplayTooltip;
        $[140] = tooltipContent;
        $[141] = t35;
    } else t35 = $[141];
    let t36;
    if ($[142] !== breakpoint || $[143] !== dimensions || $[144] !== isPlayButtonClickable || $[145] !== isTickBoxSelectable || $[146] !== mediaCardCursor || $[147] !== mergedRef || $[148] !== onClick || $[149] !== onFocus || $[150] !== onMouseEnter || $[151] !== shouldDisplayBackground || $[152] !== shouldDisplayTooltip || $[153] !== t31 || $[154] !== t32 || $[155] !== t33 || $[156] !== t34 || $[157] !== t35) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ef6324d61d97f0a3$export$e6dfd72ab29f8598), {
            testId: t31,
            dimensions: dimensions,
            onClick: onClick,
            ariaLabel: t32,
            onMouseEnter: onMouseEnter,
            onFocus: onFocus,
            innerRef: mergedRef,
            breakpoint: breakpoint,
            mediaCardCursor: mediaCardCursor,
            disableOverlay: t33,
            selected: t34,
            displayBackground: shouldDisplayBackground,
            isPlayButtonClickable: isPlayButtonClickable,
            isTickBoxSelectable: isTickBoxSelectable,
            shouldDisplayTooltip: shouldDisplayTooltip
        }, t35);
        $[142] = breakpoint;
        $[143] = dimensions;
        $[144] = isPlayButtonClickable;
        $[145] = isTickBoxSelectable;
        $[146] = mediaCardCursor;
        $[147] = mergedRef;
        $[148] = onClick;
        $[149] = onFocus;
        $[150] = onMouseEnter;
        $[151] = shouldDisplayBackground;
        $[152] = shouldDisplayTooltip;
        $[153] = t31;
        $[154] = t32;
        $[155] = t33;
        $[156] = t34;
        $[157] = t35;
        $[158] = t36;
    } else t36 = $[158];
    let t37;
    if ($[159] !== t30 || $[160] !== t36) {
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t30, t36);
        $[159] = t30;
        $[160] = t36;
        $[161] = t37;
    } else t37 = $[161];
    return t37;
} : ({ identifier: identifier, innerRef: innerRef = null, onImageLoad: onImageLoad, onImageError: onImageError, dimensions: dimensions, onClick: onClick, onMouseEnter: onMouseEnter, onFocus: onFocus, testId: testId, metadata: metadata, status: status, selected: selected, selectable: selectable, cardPreview: cardPreview, mediaCardCursor: mediaCardCursor, shouldHideTooltip: shouldHideTooltip, progress: progress, alt: alt, resizeMode: resizeMode, onDisplayImage: onDisplayImage, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, actions: actions, disableOverlay: disableOverlay, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, error: error, disableAnimation: disableAnimation, openMediaViewerButtonRef: openMediaViewerButtonRef = null, shouldOpenMediaViewer: shouldOpenMediaViewer, overriddenCreationDate: overriddenCreationDate, onSvgError: onSvgError, onSvgLoad: onSvgLoad, traceId: traceId, isAIGenerating: isAIGenerating, isCWR: isCWR, backgroundColor: backgroundColor })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [didSvgRender, setDidSvgRender] = (0, $cozmU.useState)(false);
    const [didImageRender, setDidImageRender] = (0, $cozmU.useState)(false);
    const divRef = (0, $cozmU.useRef)(null);
    const prevCardPreviewRef = (0, $cozmU.useRef)();
    const breakpoint = (0, $4eMGH.useBreakpoint)(dimensions?.width, divRef);
    (0, $cozmU.useEffect)(()=>{
        // We should only switch didImageRender to false when cardPreview goes undefined, not when it is changed. as this method could be triggered after onImageLoad callback, falling on a race condition
        if (prevCardPreviewRef.current && !cardPreview) setDidImageRender(false);
        prevCardPreviewRef.current = cardPreview;
    }, [
        cardPreview
    ]);
    const handleOnImageLoad = (prevCardPreview)=>{
        if (prevCardPreview.dataURI !== cardPreview?.dataURI) return;
        /*
        We render the icon & icon message always, even if there is cardPreview available.
        If the image fails to load/render, the icon will remain, i.e. the user won't see a change until the root card decides to chage status to error.
        If the image renders successfully, we switch this variable to hide the icon & icon message behind the thumbnail in case the image has transparency.
        It is less likely that root component replaces a suceeded cardPreview for a failed one than the opposite case. Therefore we prefer to hide the icon instead show when the image fails, for a smoother transition
      */ setDidImageRender(true);
        onImageLoad?.(cardPreview);
    };
    const handleOnImageError = (prevCardPreview_0)=>{
        if (prevCardPreview_0.dataURI !== cardPreview?.dataURI) return;
        setDidImageRender(false);
        onImageError?.(cardPreview);
    };
    const shouldRenderPlayButton = ()=>{
        const { mediaType: mediaType } = metadata || {};
        if (mediaType !== 'video' || !cardPreview) return false;
        return true;
    };
    const mergedRef = (0, $2VwyL.useMergeRefs)([
        divRef,
        innerRef
    ]);
    const getRenderConfigByStatus = ()=>{
        const { name: name, mediaType: mediaType_0, mimeType: mimeType } = metadata || {};
        const isZeroSize = metadata && metadata.size === 0;
        const defaultConfig = {
            renderTypeIcon: !didImageRender && !didSvgRender,
            renderImageRenderer: !didSvgRender,
            renderSvgView: mimeType === 'image/svg+xml',
            renderPlayButton: !!cardPreview && mediaType_0 === 'video',
            renderBlanket: !disableOverlay,
            renderTitleBox: !disableOverlay,
            renderTickBox: !disableOverlay && !!selectable
        };
        const loadingConfig = {
            ...defaultConfig,
            renderPlayButton: false,
            renderTypeIcon: false,
            renderSpinner: !didImageRender && !didSvgRender
        };
        switch(status){
            case 'uploading':
                return {
                    ...defaultConfig,
                    renderBlanket: !disableOverlay || mediaType_0 !== 'video',
                    isFixedBlanket: true,
                    renderProgressBar: !isAIGenerating
                };
            case 'processing':
                return {
                    ...defaultConfig,
                    iconMessage: !didImageRender && !isZeroSize ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe28e9a23446cea1$export$4a80244213cb4afc), {
                        disableAnimation: disableAnimation
                    }) : undefined
                };
            case 'complete':
                return defaultConfig;
            case 'error':
            case 'failed-processing':
                if (status === 'failed-processing' && mimeType === 'image/svg+xml') return loadingConfig;
                const baseErrorConfig = {
                    ...defaultConfig,
                    renderTypeIcon: true,
                    renderImageRenderer: false,
                    renderSvgView: false,
                    renderTitleBox: false,
                    renderPlayButton: false
                };
                let iconMessage;
                let customTitleMessage;
                let traceTooltipVariant;
                if ((0, $401e23545d820d5c$export$11f9f5835c5b9a04)(error)) {
                    iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17c2065bc332e889$export$f6b7f98fc8b4c6c7), null);
                    customTitleMessage = (0, $fA65V.messages).failed_to_upload;
                } else if ((0, $4138ebdf60975a3f$export$476aa014e2fd89d5)(error) && (0, $iDrrr.fg)('media_card_failed_messaging_ui_revamp')) {
                    iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17ba6bcdea2acebd$export$acb8738584883d89), null);
                    customTitleMessage = (0, $fA65V.messages).check_internet_connection;
                } else if (!metadata) {
                    iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e482048df30fb6af$export$a712c963efa9c728), null);
                    traceTooltipVariant = 'failed-to-load';
                } else {
                    iconMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aafda3669d76c197$export$35337070c6dafccf), null);
                    traceTooltipVariant = 'preview-unavailable';
                }
                if (!disableOverlay) {
                    const renderFailedTitleBox = !name || !!customTitleMessage;
                    return {
                        ...baseErrorConfig,
                        renderTitleBox: !!name && !customTitleMessage,
                        renderFailedTitleBox: renderFailedTitleBox,
                        iconMessage: !renderFailedTitleBox ? iconMessage : undefined,
                        customTitleMessage: customTitleMessage,
                        traceTooltipVariant: traceTooltipVariant
                    };
                }
                return {
                    ...baseErrorConfig,
                    iconMessage: iconMessage,
                    traceTooltipVariant: traceTooltipVariant
                };
            case 'loading-preview':
            case 'loading':
            default:
                return loadingConfig;
        }
    };
    const { renderTypeIcon: renderTypeIcon, iconMessage: iconMessage_0, renderImageRenderer: renderImageRenderer, renderSvgView: renderSvgView, renderSpinner: renderSpinner, renderPlayButton: renderPlayButton, renderBlanket: renderBlanket, renderProgressBar: renderProgressBar, renderTitleBox: renderTitleBox, renderFailedTitleBox: renderFailedTitleBox_0, renderTickBox: renderTickBox, isFixedBlanket: isFixedBlanket, customTitleMessage: customTitleMessage_0, traceTooltipVariant: traceTooltipVariant_0 } = getRenderConfigByStatus();
    // AI border shown while generating; cleared by the decoration on upload completion.
    /* eslint-disable @atlaskit/platform/no-preconditioning -- loading-specific gate (cc-maui-phase-2) layered on the MAUI experiment cohort during phased rollout; preconditioning is intentional and will be removed when the existing gates are cleaned up */ const renderAIBorderOverride = !!isAIGenerating && (0, $iDrrr.fg)('cc-maui-phase-2') && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
    /* eslint-enable @atlaskit/platform/no-preconditioning */ const shouldDisplayBackground = !cardPreview || !disableOverlay || status === 'error' || status === 'failed-processing';
    const isPlayButtonClickable = shouldRenderPlayButton() && !!disableOverlay;
    const isTickBoxSelectable = !disableOverlay && !!selectable && !selected;
    const { mediaType: mediaType_1, mimeType: mimeType_0, name: name_0, createdAt: createdAt } = metadata || {};
    const shouldShowTraceIdTooltip = !!traceTooltipVariant_0 && !!traceId;
    const tooltipContent = shouldShowTraceIdTooltip ? intl.formatMessage($4fd3933024dfee84$var$i18n.traceIdTooltip, {
        traceId: traceId
    }) : name_0;
    // Disable tooltip for Media Single
    const shouldDisplayTooltip = !disableOverlay && !shouldHideTooltip;
    const isTitleBoxVisible = renderTitleBox && name_0;
    const hasVisibleTitleBox = !!(isTitleBoxVisible || renderFailedTitleBox_0);
    const metadataRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(metadata);
    const actionsWithDetails = (0, $cozmU.useMemo)(()=>{
        if (!actions) return [];
        return actions.map((action)=>({
                ...action,
                handler: ()=>{
                    if (!metadataRef.current) action.handler();
                    else action.handler({
                        type: 'file',
                        details: metadataRef.current
                    });
                }
            }));
    }, [
        actions,
        metadataRef
    ]);
    const onSvgLoadBase = ()=>{
        setDidSvgRender(true);
        onSvgLoad?.();
    };
    const contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7830061118cc5b5a$export$94026ee33dbabc26), {
        centerElements: didSvgRender && !(0, $iDrrr.fg)('platform_media_card_image_render'),
        testId: (0, $cOUnF.fileCardImageViewSelector),
        mediaName: name_0,
        status: status,
        progress: progress,
        mediaCardCursor: mediaCardCursor,
        selected: selected,
        source: cardPreview?.source
    }, renderTypeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87f3b9d7cf4b76fc$export$be58b4326e23250f), {
        breakpoint: breakpoint,
        hasTitleBox: hasVisibleTitleBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6xGZY.MimeTypeIcon), {
        testId: "media-card-file-type-icon",
        mediaType: mediaType_1,
        mimeType: mimeType_0,
        name: name_0
    }), iconMessage_0), renderSpinner && ((0, $ieeJu.expValEquals)('cc-maui-ai-edit-loading-experiment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
        animationDisabled: disableAnimation,
        testId: "media-card-loading",
        interactionName: "media-card-loading"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87f3b9d7cf4b76fc$export$be58b4326e23250f), {
        breakpoint: breakpoint,
        hasTitleBox: hasVisibleTitleBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        testId: "media-card-loading",
        interactionName: "media-card-loading"
    }))), renderSvgView && identifier && (0, $jmmTp.isFileIdentifier)(identifier) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cc53140db039fca1$export$cf98b60e5f1e2515), {
        identifier: identifier,
        resizeMode: resizeMode || 'crop',
        onError: onSvgError,
        onLoad: onSvgLoadBase,
        wrapperRef: divRef,
        backgroundColor: backgroundColor
    }), renderImageRenderer && identifier && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f8b624677c640c5$export$a8e6523ab063becd), {
        cardPreview: cardPreview,
        mediaType: metadata?.mediaType || 'unknown',
        alt: alt ?? name_0,
        resizeMode: resizeMode,
        onDisplayImage: onDisplayImage,
        onImageLoad: handleOnImageLoad,
        onImageError: handleOnImageError,
        nativeLazyLoad: nativeLazyLoad,
        forceSyncDisplay: forceSyncDisplay,
        identifier: identifier,
        wrapperRef: divRef,
        backgroundColor: backgroundColor
    }), renderPlayButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87f3b9d7cf4b76fc$export$be58b4326e23250f), {
        breakpoint: breakpoint,
        hasTitleBox: hasVisibleTitleBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e6a176bd5fe3e08$export$fbed5f62d839a0cd), null)), renderAIBorderOverride ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $41681b111635fa1d$export$dadfe5b5cfcd2b0e), {
        label: intl.formatMessage($4fd3933024dfee84$var$i18n.aiGeneratingImage),
        testId: "media-card-ai-generating-overlay",
        // CWR renders the overlay opaque so it also masks the generic type icon.
        isOpaque: isCWR
    }) : renderBlanket && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21d414d99db4a105$export$5b927fc1ef8c468b), {
        isFixed: isFixedBlanket
    }), renderTitleBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2015ff08cec1784$export$e3ce443f3b72c291), {
        name: name_0,
        createdAt: overriddenCreationDate ?? createdAt,
        breakpoint: breakpoint,
        titleBoxIcon: titleBoxIcon,
        titleBoxBgColor: titleBoxBgColor,
        hidden: !isTitleBoxVisible
    }), renderFailedTitleBox_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0ca38055ced1477$export$9b3b0baef32e2e39), {
        breakpoint: breakpoint,
        customMessage: customTitleMessage_0
    }), renderProgressBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k5Bdp.ProgressBar), {
        progress: progress,
        breakpoint: breakpoint,
        positionBottom: !hasVisibleTitleBox
    }), renderTickBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $432e4663fc99cc82$export$58be5bf2cd389559), {
        selected: selected
    })), disableOverlay || !actions || actions.length === 0 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $457f2c417ecea897$export$8c8e9293b68041de), {
        filename: name_0,
        actions: actionsWithDetails
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldOpenMediaViewer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $00a35784f97edcc7$export$2e2bcd8739ae039), {
        fileName: name_0 ?? '',
        innerRef: openMediaViewerButtonRef,
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ef6324d61d97f0a3$export$e6dfd72ab29f8598), {
        testId: testId || 'media-card-view',
        dimensions: dimensions,
        onClick: onClick,
        ariaLabel: name_0 || 'Media Card',
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        innerRef: mergedRef,
        breakpoint: breakpoint,
        mediaCardCursor: mediaCardCursor,
        disableOverlay: !!disableOverlay,
        selected: !!selected,
        displayBackground: shouldDisplayBackground,
        isPlayButtonClickable: isPlayButtonClickable,
        isTickBoxSelectable: isTickBoxSelectable,
        shouldDisplayTooltip: shouldDisplayTooltip
    }, shouldDisplayTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipContent,
        position: "bottom",
        tag: "div"
    }, contents) : contents));
};
const $4fd3933024dfee84$export$7e52c821f7b6f422 = (0, $lzgC6.default)({
    onClick: (0, $2cb47daccc3b7ffc$export$4d33ada3618f7626)({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'mediaCard',
        attributes: {}
    })
})($4fd3933024dfee84$export$fe522702db3259fa);











const $71d67df90921b700$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext, samplingRate)=>{
    const isSamplingEnabled = samplingRate !== undefined && samplingRate < 1;
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext,
            ...isSamplingEnabled && {
                isSamplingEnabled: isSamplingEnabled
            },
            ...samplingRate !== undefined && {
                samplingRate: samplingRate
            }
        }
    };
};






const $0507308a6ec504af$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>{
    const requestMetadata = (0, $c13d552137c78450$export$1a2ec9b4a3a99d5e)(error);
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...(0, $5WRnQ.extractErrorInfo)(error, metadataTraceContext),
            statusCode: requestMetadata?.statusCode,
            request: requestMetadata,
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    };
};


const $7bea2a57a83c6b20$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext, processingFailReason)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            // 'not-available' is used for cases before processingFailReason implementation (backward compatibility)
            processingFailReason: processingFailReason || 'not-available',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });


// Sampling rate for mediaCardRender success events (10%)
const $8e75bfb8f08c73f3$var$MEDIA_CARD_RENDER_SUCCESS_SAMPLE_RATE = 0.1;
const $8e75bfb8f08c73f3$export$a1fb57756f0de62b = (createAnalyticsEvent, status, fileAttributes, performanceAttributes, ssrReliability, error = new (0, $lE37M.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext, processingFailReason)=>{
    const fireEvent = (payload)=>(0, $lvxKi.fireMediaCardEvent)(payload, createAnalyticsEvent);
    switch(status){
        case 'complete':
            // Sample success events at 10% when feature flag is enabled - failures are never sampled
            // If flag is disabled, all success events fire (no sampling)
            const isSamplingEnabled = (0, $iDrrr.fg)('enable_sampling_mediacardrender_succeeded');
            if (!isSamplingEnabled || Math.random() < $8e75bfb8f08c73f3$var$MEDIA_CARD_RENDER_SUCCESS_SAMPLE_RATE) fireEvent((0, $71d67df90921b700$export$4006df18b24ad838)(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext, isSamplingEnabled ? $8e75bfb8f08c73f3$var$MEDIA_CARD_RENDER_SUCCESS_SAMPLE_RATE : undefined));
            break;
        case 'failed-processing':
            // Always emit failed events (no sampling)
            fireEvent((0, $7bea2a57a83c6b20$export$116834b91a04bd49)(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext, processingFailReason));
            break;
        case 'error':
            // Always emit error events (no sampling)
            fireEvent((0, $0507308a6ec504af$export$ea8620de23983ca1)(fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext));
            break;
    }
};


const $3e572fb39a9ad3b7$export$fb4230f160368c88 = ()=>performance.now();


const $b94e7f214bbb485b$export$b7c988f139757a90 = ({ mediaClient: mediaClient, appearance: appearance = 'auto', resizeMode: resizeMode = 'crop', disableOverlay: disableOverlay = false, featureFlags: // Media Feature Flag defaults are defined in @atlaskit/media-common
featureFlags = {}, identifier: identifier, dimensions: dimensions, contextId: contextId, alt: alt, actions: actions, shouldOpenMediaViewer: shouldOpenMediaViewer, selectable: selectable, selected: selected, testId: testId, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, shouldHideTooltip: shouldHideTooltip, mediaViewerItems: mediaViewerItems, onClick: onClick, onMouseEnter: onMouseEnter, onFocus: onFocus })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const cardDimensions = dimensions || (0, $gjPL4.getDefaultCardDimensions)(appearance);
    const internalOccurrenceKey = (0, $cozmU.useMemo)(()=>(0, $38fd8c5619b38c8c$export$48da330df5248c4c)(), []);
    const timeElapsedTillCommenced = (0, $cozmU.useMemo)(()=>(0, $3e572fb39a9ad3b7$export$fb4230f160368c88)(), []);
    // Generate unique traceId for file
    const traceContext = (0, $cozmU.useMemo)(()=>({
            traceId: (0, $8396x.getRandomTelemetryId)()
        }), []);
    const fileStateFlagsRef = (0, $cozmU.useRef)({
        wasStatusUploading: false,
        wasStatusProcessing: false
    });
    const shouldSendPerformanceEvent = (0, $cozmU.useMemo)(()=>(0, $b1777cf9f57cea43$export$b21c64f4f93d10f4)(), []);
    // UFO experience hook - creates a unique experience instance per card
    const ufoExperience = (0, $b1777cf9f57cea43$export$a42e845f664e6373)({
        instanceId: internalOccurrenceKey,
        enabled: shouldSendPerformanceEvent
    });
    const startUfoExperienceRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(()=>{
        ufoExperience.start();
    });
    const [status, setStatus] = (0, $cozmU.useState)('loading-preview');
    const cardPreview = (0, $cozmU.useMemo)(()=>({
            dataURI: identifier.dataURI,
            orientation: 1,
            source: 'external'
        }), [
        identifier.dataURI
    ]);
    const metadata = {
        id: identifier.mediaItemType,
        name: identifier.name || identifier.dataURI,
        mediaType: 'image'
    };
    const fileAttributes = {
        fileMediatype: 'image',
        fileId: metadata.id
    };
    // for analytics
    const ssrReliability = {
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    };
    const [previewDidRender, setPreviewDidRender] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)();
    const [mediaViewerSelectedItem, setMediaViewerSelectedItem] = (0, $cozmU.useState)(null);
    //----------------------------------------------------------------//
    //---------------------- Analytics  ------------------------------//
    //----------------------------------------------------------------//
    const fireOperationalEventRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(()=>{
        const timeElapsedTillEvent = (0, $3e572fb39a9ad3b7$export$fb4230f160368c88)();
        const durationSinceCommenced = timeElapsedTillEvent - timeElapsedTillCommenced;
        const performanceAttributes = {
            overall: {
                durationSincePageStart: timeElapsedTillEvent,
                durationSinceCommenced: durationSinceCommenced
            }
        };
        createAnalyticsEvent && (0, $8e75bfb8f08c73f3$export$a1fb57756f0de62b)(createAnalyticsEvent, status, fileAttributes, performanceAttributes, ssrReliability, error, traceContext, undefined);
        // External images don't use SSR - no ssrPreviewInfo passed
        ufoExperience.complete(status, fileAttributes, fileStateFlagsRef.current, ssrReliability, error, undefined);
    });
    const fireAbortedEventRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(()=>{
        // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
        ufoExperience.abort({
            fileAttributes: fileAttributes,
            fileStateFlags: fileStateFlagsRef?.current,
            ssrReliability: ssrReliability
        });
    });
    //----------------------------------------------------------------//
    //------------------------ useEffects ----------------------------//
    //----------------------------------------------------------------//
    (0, $cozmU.useEffect)(()=>{
        startUfoExperienceRef.current();
    }, [
        startUfoExperienceRef
    ]);
    const prevStatus = (0, $5912457c5c879fd6$export$5cae361ad82dce8b)(status);
    (0, $cozmU.useEffect)(()=>{
        if (prevStatus !== undefined && status !== prevStatus) fireOperationalEventRef.current();
    }, [
        fireOperationalEventRef,
        prevStatus,
        status
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (previewDidRender && status === 'loading-preview') setStatus('complete');
    }, [
        previewDidRender,
        status
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            fireAbortedEventRef.current();
        };
    }, [
        fireAbortedEventRef
    ]);
    //----------------------------------------------------------------//
    //---------------------- Render Functions ------------------------//
    //----------------------------------------------------------------//
    const renderMediaViewer = ()=>{
        if (!mediaViewerSelectedItem) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1tBud.default), {
            collectionName: '',
            items: mediaViewerItems || [],
            mediaClientConfig: mediaClient.config,
            selectedItem: mediaViewerSelectedItem,
            onClose: ()=>{
                setMediaViewerSelectedItem(null);
            },
            contextId: contextId,
            featureFlags: featureFlags
        }), document.body);
    };
    //----------------------------------------------------------------//
    //-------------------------- RENDER ------------------------------//
    //----------------------------------------------------------------//
    const mediaCardCursor = (0, $79c9f6957b6516ad$export$c364ca3a4cf16be0)(false, !!shouldOpenMediaViewer, status === 'error', !!cardPreview, metadata.mediaType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd3933024dfee84$export$7e52c821f7b6f422), {
        identifier: identifier,
        status: status,
        error: error,
        mediaItemType: identifier.mediaItemType,
        metadata: metadata,
        cardPreview: cardPreview,
        alt: alt,
        resizeMode: resizeMode,
        dimensions: cardDimensions,
        actions: actions,
        selectable: selectable,
        selected: selected,
        onClick: (event, analyticsEvent)=>{
            if (onClick) {
                const cardEvent = {
                    event: event,
                    mediaItemDetails: metadata
                };
                onClick(cardEvent, analyticsEvent);
            }
            if (shouldOpenMediaViewer) setMediaViewerSelectedItem({
                mediaItemType: 'external-image',
                dataURI: identifier.dataURI,
                name: identifier.name
            });
        },
        onMouseEnter: (event)=>{
            onMouseEnter?.({
                event: event,
                mediaItemDetails: metadata
            });
        },
        onFocus: (event)=>{
            if (!(0, $4603370344b0d7ea$export$a133018935bd25fc)(event)) return;
            onFocus?.({
                event: event,
                mediaItemDetails: metadata
            });
        },
        disableOverlay: disableOverlay,
        onDisplayImage: ()=>{
            const payloadPart = {
                fileId: identifier.dataURI,
                isUserCollection: false
            };
            (0, $hfrng.globalMediaEventEmitter).emit('media-viewed', {
                viewingLevel: 'minimal',
                ...payloadPart
            });
        },
        testId: testId,
        titleBoxBgColor: titleBoxBgColor,
        titleBoxIcon: titleBoxIcon,
        onImageError: (newCardPreview)=>{
            // If the dataURI has been replaced, we can dismiss this error
            if (newCardPreview?.dataURI !== cardPreview?.dataURI) return;
            const error = new (0, $9e7b33a0432dcdec$export$d0a45ab59b4606b)(newCardPreview?.source);
            setStatus('error');
            setError(error);
        },
        onImageLoad: (newCardPreview)=>{
            // If the dataURI has been replaced, we can dismiss this callback
            if (newCardPreview?.dataURI !== cardPreview?.dataURI) return;
            setPreviewDidRender(true);
        },
        mediaCardCursor: mediaCardCursor,
        shouldHideTooltip: shouldHideTooltip
    }), mediaViewerSelectedItem ? renderMediaViewer() : null);
};
















const $72179768a80dbdc7$export$dc1fb2767ac9a82f = (resizeMode)=>resizeMode === 'stretchy-fit' ? 'full-fit' : resizeMode;


var $5bSLb = parcelRequire("5bSLb");

var $4W5SH = parcelRequire("4W5SH");

var $fkYei = parcelRequire("fkYei");

var $7ZjkB = parcelRequire("7ZjkB");


var $h7nb4 = parcelRequire("h7nb4");


var $lNvN4 = parcelRequire("lNvN4");


var $laLBM = parcelRequire("laLBM");




var $9OT81 = parcelRequire("9OT81");

var $nfEzS = parcelRequire("nfEzS");


var $9vt4W = parcelRequire("9vt4W");


var $aXEmz = parcelRequire("aXEmz");








var $34MZN = parcelRequire("34MZN");


var $1o3CH = parcelRequire("1o3CH");










const $57fb2759e40bf5ec$export$5bc85d7cf4a39f3e = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);


/**
 * Entry Point: @atlaskit/media-card/types
 */ /**
 * Entry Point: @atlaskit/media-card/types
 */ const $c01f46fd73b3a466$export$36aae1afbc0a9661 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'cache-ssr-client'
    ];
    return ssrClientSources.includes(preview.source);
};


/**
 * Entry Point: @atlaskit/media-card/types
 */ const $f914b7474cb507bb$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';


/**
 * Entry Point: @atlaskit/media-card/types
 */ const $5607160c056ed9ef$export$48a298744248dfdd = (preview)=>{
    const ssrClientSources = [
        'ssr-server',
        'cache-ssr-server'
    ];
    return ssrClientSources.includes(preview.source);
};


const $1d730199f4951739$export$dea79d05143ccf4 = (preview)=>(0, $c01f46fd73b3a466$export$36aae1afbc0a9661)(preview) || (0, $5607160c056ed9ef$export$48a298744248dfdd)(preview) || (0, $f914b7474cb507bb$export$f366c2c8a792cce6)(preview);





const $ad8b6ffbc53ad603$export$9a4415707aa9b398 = (authContext)=>{
    if (!authContext) return undefined;
    // Try new access array first
    const collectionAccess = authContext.access?.find((a)=>a.type === 'collection');
    if (collectionAccess && 'name' in collectionAccess) return collectionAccess.name;
    // Fallback to deprecated collectionName
    return authContext.collectionName;
};


const $ad136eeff4726044$export$8ae7a3e1eee1037e = (durationMs, timeoutMs, authContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaAuthProvider',
        attributes: {
            status: 'succeeded',
            durationMs: durationMs,
            timeoutMs: timeoutMs,
            collectionName: (0, $ad8b6ffbc53ad603$export$9a4415707aa9b398)(authContext)
        }
    });






// Similar to extractErrorInfo but works with raw Error (not MediaCardError)
const $c99acdd5d5bcf060$var$extractAuthProviderErrorInfo = (error)=>{
    if ((0, $1wzQC.isCommonMediaClientError)(error)) return {
        failReason: error.reason,
        error: error.reason,
        errorDetail: error.innerError?.message ?? error.message
    };
    return {
        failReason: error.name || 'unknown',
        error: error.name || '',
        errorDetail: error.message
    };
};
const $c99acdd5d5bcf060$export$ad4b9061e2cb7f76 = (durationMs, timeoutMs, error, authContext)=>{
    const errorInfo = $c99acdd5d5bcf060$var$extractAuthProviderErrorInfo(error);
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaAuthProvider',
        attributes: {
            status: 'failed',
            durationMs: durationMs,
            timeoutMs: timeoutMs,
            collectionName: (0, $ad8b6ffbc53ad603$export$9a4415707aa9b398)(authContext),
            ...errorInfo
        }
    };
};













const $78ee54fc22387b2c$var$getProcessingStatusFromFileState = (status)=>{
    switch(status){
        case 'processed':
            return 'succeeded';
        case 'processing':
            return 'running';
        case 'failed-processing':
            return 'failed';
    }
};
const $78ee54fc22387b2c$var$getFileDetailsFromFileState = (state)=>({
        id: state.id,
        name: state.name,
        size: state.size,
        mimeType: state.mimeType,
        createdAt: state.createdAt,
        mediaType: state.mediaType,
        processingStatus: $78ee54fc22387b2c$var$getProcessingStatusFromFileState(state.status),
        failReason: state.status === 'failed-processing' ? state.failReason : undefined
    });
const $78ee54fc22387b2c$export$7e125c11d42de4d1 = (identifier, fileState)=>{
    return (0, $jmmTp.isFileIdentifier)(identifier) ? fileState && !(0, $5bSLb.isErrorFileState)(fileState) ? $78ee54fc22387b2c$var$getFileDetailsFromFileState(fileState) : {
        id: identifier.id
    } : {
        id: identifier.mediaItemType,
        name: identifier.name || identifier.dataURI,
        mediaType: 'image'
    };
};





const $eb874c3d7d725df9$export$9dd9ef980c055cad = (value)=>value.substr(-2) === 'px' && !isNaN(+value.slice(0, -2));



var $igkYX = parcelRequire("igkYX");


var $gG7ZF = parcelRequire("gG7ZF");

const $ccc7beda77754947$export$a94e513ca3122718 = (dimensionName, { dimensions: dimensions, element: element })=>{
    const dimensionValue = dimensions?.[dimensionName] || '';
    if ((0, $gG7ZF.isValidPercentageUnit)(dimensionValue) && element) return (0, $igkYX.getElementDimension)(element, dimensionName);
    if (typeof dimensionValue === 'number') return dimensionValue;
    if ((0, $eb874c3d7d725df9$export$9dd9ef980c055cad)(`${dimensionValue}`)) return parseInt(`${dimensionValue}`, 10);
    return (0, $gjPL4.defaultImageCardDimensions)[dimensionName];
};


const $6f4c39eef0f8938c$export$f187979e6522f007 = (options)=>{
    const width = (0, $ccc7beda77754947$export$a94e513ca3122718)('width', options);
    const height = (0, $ccc7beda77754947$export$a94e513ca3122718)('height', options);
    return {
        width: width,
        height: height
    };
};















var $jb2gB = parcelRequire("jb2gB");

var $4a45701aed968c30$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};


const $242ffb0351fb7355$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP = 900; //px
const $242ffb0351fb7355$var$createIntersectionObserverCallback = (onVisible)=>(entries, observer)=>{
        for (let entry of entries)if (entry.isIntersecting) {
            onVisible();
            observer.disconnect();
            break;
        }
    };
const $242ffb0351fb7355$var$ViewportObserver = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { onVisible: onVisible, cardEl: cardEl, children: children } = t0;
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== onVisible) {
        t1 = ()=>{
            setIsVisible(true);
            onVisible();
        };
        $[0] = onVisible;
        $[1] = t1;
    } else t1 = $[1];
    const onVisibleCallback = t1;
    let t2;
    let t3;
    if ($[2] !== cardEl || $[3] !== onVisibleCallback) {
        t2 = ()=>{
            let intersectionObserver;
            try {
                intersectionObserver = new IntersectionObserver($242ffb0351fb7355$var$createIntersectionObserverCallback(onVisibleCallback), {
                    root: (0, $4a45701aed968c30$export$2e2bcd8739ae039)(),
                    rootMargin: `${$242ffb0351fb7355$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
                });
            } catch (t4) {
                intersectionObserver = new IntersectionObserver($242ffb0351fb7355$var$createIntersectionObserverCallback(onVisibleCallback), {
                    root: null,
                    rootMargin: `${$242ffb0351fb7355$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
                });
            }
            cardEl && intersectionObserver.observe(cardEl);
            return ()=>{
                intersectionObserver.disconnect();
            };
        };
        t3 = [
            cardEl,
            onVisibleCallback
        ];
        $[2] = cardEl;
        $[3] = onVisibleCallback;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = !isVisible;
    let t5;
    if ($[6] !== children || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), {
            ignore: t4
        }, children);
        $[6] = children;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ onVisible: onVisible, cardEl: cardEl, children: children })=>{
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    const onVisibleCallback = (0, $cozmU.useCallback)(()=>{
        setIsVisible(true);
        onVisible();
    }, [
        onVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        let intersectionObserver;
        try {
            intersectionObserver = new IntersectionObserver($242ffb0351fb7355$var$createIntersectionObserverCallback(onVisibleCallback), {
                root: (0, $4a45701aed968c30$export$2e2bcd8739ae039)(),
                rootMargin: `${$242ffb0351fb7355$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
            });
        } catch (error) {
            intersectionObserver = new IntersectionObserver($242ffb0351fb7355$var$createIntersectionObserverCallback(onVisibleCallback), {
                root: null,
                rootMargin: `${$242ffb0351fb7355$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
            });
        }
        cardEl && intersectionObserver.observe(cardEl);
        return ()=>{
            intersectionObserver.disconnect();
        };
    }, [
        cardEl,
        onVisibleCallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), {
        ignore: !isVisible
    }, children);
};
const $242ffb0351fb7355$export$35aa735df177ee7c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { cardEl: cardEl, onVisible: onVisible, children: children } = t0;
    if (typeof IntersectionObserver === "undefined") {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== cardEl || $[3] !== children || $[4] !== onVisible) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($242ffb0351fb7355$var$ViewportObserver, {
            cardEl: cardEl,
            onVisible: onVisible
        }, children);
        $[2] = cardEl;
        $[3] = children;
        $[4] = onVisible;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ cardEl: cardEl, onVisible: onVisible, children: children })=>{
    if (typeof IntersectionObserver === 'undefined') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($242ffb0351fb7355$var$ViewportObserver, {
        cardEl: cardEl,
        onVisible: onVisible
    }, children);
};







var $6Fmj3 = parcelRequire("6Fmj3");







const $8987c014fc265b4d$export$948607b7587fecda = (baseAction, formatMessage)=>{
    const { isDisabled: isDisabled } = baseAction;
    const label = isDisabled ? 'Download Disabled' : 'Download';
    const tooltip = isDisabled ? formatMessage((0, $fA65V.messages).download_disabled_security_policy) : undefined;
    return {
        ...baseAction,
        label: label,
        tooltip: tooltip,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))), {
            color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : 'currentColor',
            spacing: "spacious",
            label: (0, $iDrrr.fg)('platform-a11y-media-card-download-icon-decorative') ? '' : 'Download'
        })
    };
};












const $5a6dc55fbe00ea73$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>{
    const requestMetadata = (0, $c13d552137c78450$export$1a2ec9b4a3a99d5e)(error);
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...(0, $5WRnQ.extractErrorInfo)(error, metadataTraceContext),
            statusCode: requestMetadata?.statusCode,
            request: requestMetadata,
            traceContext: traceContext
        }
    };
};


const $b5b2db596fe4d98c$export$f0368e92a624442a = (createAnalyticsEvent, fileAttributes, error = new (0, $lE37M.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const payload = (0, $5a6dc55fbe00ea73$export$bd721ce2bd18db4c)(fileAttributes, error, traceContext, metadataTraceContext);
    (0, $lvxKi.fireMediaCardEvent)(payload, createAnalyticsEvent);
};





const $90a3a405a3e1fa07$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });


const $d979a62f4316adbb$export$8f39639231268ced = (createAnalyticsEvent, fileAttributes, traceContext, metadataTraceContext)=>{
    const payload = (0, $90a3a405a3e1fa07$export$30f484b360b0efe8)(fileAttributes, traceContext, metadataTraceContext);
    (0, $lvxKi.fireMediaCardEvent)(payload, createAnalyticsEvent);
};












const $acd47167056553eb$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>{
    const requestMetadata = (0, $c13d552137c78450$export$1a2ec9b4a3a99d5e)(error);
    return {
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...(0, $5WRnQ.extractErrorInfo)(error, metadataTraceContext),
            statusCode: requestMetadata?.statusCode,
            request: requestMetadata,
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    };
};


const $ce69b14ba8a22ee4$export$6505e60579e04cbd = (createAnalyticsEvent, cardStatus, fileAttributes, ssrReliability, error = new (0, $lE37M.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const errorPayload = (0, $acd47167056553eb$export$d3944464e6ecd3d4)(cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext);
    (0, $lvxKi.fireMediaCardEvent)(errorPayload, createAnalyticsEvent);
};







const $789ed0202163a4ea$export$c7e2887eae92d53c = /*#__PURE__*/ (0, $cozmU.lazy)(async ()=>{
    const { InlinePlayer: InlinePlayer } = await (parcelRequire("2vxwf"));
    return {
        default: InlinePlayer
    };
});



const $26dcc9ddee9fe0e5$var$traceContextRetriever = ()=>{
    const trace = (0, $34MZN.getActiveTrace)();
    if (trace) return {
        traceId: trace.traceId,
        spanId: trace.spanId
    };
    else return {
        traceId: (0, $8396x.getRandomTelemetryId)()
    };
};
const $26dcc9ddee9fe0e5$export$593fd10f7e6c6505 = ({ appearance: appearance = 'auto', resizeMode: resizeMode = 'crop', isLazy: isLazy = true, disableOverlay: disableOverlay = false, featureFlags: // Media Feature Flag defaults are defined in @atlaskit/media-common
featureFlags = {}, identifier: identifier, ssr: ssr, dimensions: dimensions, originalDimensions: originalDimensions, contextId: contextId, alt: alt, actions: actions, shouldEnableDownloadButton: shouldEnableDownloadButton, useInlinePlayer: useInlinePlayer, shouldOpenMediaViewer: shouldOpenMediaViewer, onFullscreenChange: onFullscreenChange, selectable: selectable, selected: selected, testId: testId, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, backgroundColor: backgroundColor, isAIGenerating: isAIGenerating, isCWR: isCWR, onPreviewRender: onPreviewRender, shouldHideTooltip: shouldHideTooltip, mediaViewerItems: mediaViewerItems, onClick: onClick, onMouseEnter: onMouseEnter, onFocus: onFocus, videoControlsWrapperRef: videoControlsWrapperRef, viewerOptions: viewerOptions, includeHashForDuplicateFiles: includeHashForDuplicateFiles, ssrItemDetails: ssrItemDetails, ssrFileState: ssrFileState, ssrMediaItem: ssrMediaItem, onError: onError, mediaViewerExtensions: mediaViewerExtensions, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isAbuseModalOpen, setIsAbuseModalOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    //----------------------------------------------------------------//
    //------------ State, Refs & Initial Values ----------------------//
    //----------------------------------------------------------------//
    const pressTracing = (0, $1o3CH.default)('click-file-card');
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const [cardElement, setCardElement] = (0, $cozmU.useState)(null);
    // use reference here to avoid excessive calls.
    const onErrorRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(onError);
    const cardDimensions = dimensions || (0, $gjPL4.getDefaultCardDimensions)(appearance);
    // Calculate the preview dimensions if card dimensions are "percentage" based
    const previewDimensions = (0, $cozmU.useMemo)(()=>// resolving dimensions is eventually an expensive operation if the dimensions are a percentage
        // thus needs to be memoized
        (0, $6f4c39eef0f8938c$export$f187979e6522f007)({
            dimensions: cardDimensions,
            element: cardElement
        }), [
        cardDimensions,
        cardElement
    ]);
    const [isCardVisible, setIsCardVisible] = (0, $cozmU.useState)(!isLazy);
    // Note: mapMediaItemToFileState maps the fragment's processingStatus faithfully (including
    // processing/pending). The decision to skip polling is delegated to useFileState —
    // it skips subscription only when status === 'processed'. Do not add status guards here.
    // ssrFileState (Relay / explicit seed) wins over converting ssrMediaItem.
    const initialFileState = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_media_ssr_data_seed') ? ssrFileState ?? (0, $laLBM.mapSsrMediaItemToFileState)(ssrMediaItem) : undefined, [
        ssrFileState,
        ssrMediaItem
    ]);
    const { fileState: fileState } = (0, $h7nb4.useFileState)(identifier.id, {
        skipRemote: !isCardVisible,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey,
        includeHashForDuplicateFiles: includeHashForDuplicateFiles,
        initialFileState: initialFileState
    });
    const [fallbackMediaName, setFallbackMediaName] = (0, $cozmU.useState)();
    const fallbackMediaNameFetchAttempted = (0, $cozmU.useRef)(false);
    const lastFetchedFileId = (0, $cozmU.useRef)();
    const prevFileState = (0, $5912457c5c879fd6$export$5cae361ad82dce8b)(fileState && (0, $5bSLb.isErrorFileState)(fileState) ? undefined : fileState);
    const fileStateValue = (0, $cozmU.useMemo)(()=>{
        if (fileState && !(0, $5bSLb.isErrorFileState)(fileState)) return fileState;
        return prevFileState;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fileState
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Reset fetch state when the file identity changes
        const currentId = fileStateValue?.id;
        if (currentId && currentId !== lastFetchedFileId.current && (0, $ieeJu.expValEquals)('platform_editor_media_name_fallback_viewer_card', 'isEnabled', true)) {
            fallbackMediaNameFetchAttempted.current = false;
            setFallbackMediaName(undefined);
            lastFetchedFileId.current = currentId;
        }
        if (fileStateValue && !fileStateValue.name && fallbackMediaNameFetcher && !fallbackMediaNameFetchAttempted.current && (0, $ieeJu.expValEquals)('platform_editor_media_name_fallback_viewer_card', 'isEnabled', true)) {
            fallbackMediaNameFetchAttempted.current = true;
            fallbackMediaNameFetcher(fileStateValue.id).then((name)=>{
                setFallbackMediaName(name);
            }, ()=>{
            // Silently ignore fetch failures
            });
        }
    }, [
        fileStateValue,
        fallbackMediaNameFetcher
    ]);
    const dateOverrides = (0, $cozmU.useContext)((0, $57fb2759e40bf5ec$export$5bc85d7cf4a39f3e));
    const overridenDate = dateOverrides?.[identifier.id];
    //----------------------------------------------------------------//
    //------------ State, Refs & Initial Values ----------------------//
    //----------------------------------------------------------------//
    const internalOccurrenceKey = (0, $cozmU.useMemo)(()=>(0, $38fd8c5619b38c8c$export$48da330df5248c4c)(), []);
    const timeElapsedTillCommenced = (0, $cozmU.useMemo)(()=>(0, $3e572fb39a9ad3b7$export$fb4230f160368c88)(), []);
    const fileStateFlagsRef = (0, $cozmU.useRef)({
        wasStatusUploading: false,
        wasStatusProcessing: false
    });
    const mediaViewerButtonRef = (0, $cozmU.useRef)(null);
    // Generate unique traceId for file
    const traceContext = (0, $cozmU.useMemo)($26dcc9ddee9fe0e5$var$traceContextRetriever, []);
    const [status, setStatus] = (0, $cozmU.useState)('loading');
    const [isPlayingFile, setIsPlayingFile] = (0, $cozmU.useState)(false);
    const [shouldAutoplay, setShouldAutoplay] = (0, $cozmU.useState)(false);
    const [previewDidRender, setPreviewDidRender] = (0, $cozmU.useState)(false);
    const mediaBlobUrlAttrs = (0, $cozmU.useMemo)(()=>{
        const { id: id, collectionName: collection } = identifier;
        const { mimeType: mimeType, name: name, size: size } = (0, $78ee54fc22387b2c$export$7e125c11d42de4d1)(identifier, fileStateValue);
        return contextId ? {
            id: id,
            collection: collection,
            contextId: contextId,
            mimeType: mimeType,
            name: name,
            size: size,
            ...originalDimensions || previewDimensions,
            alt: alt
        } : undefined;
    }, [
        alt,
        previewDimensions,
        contextId,
        fileStateValue,
        identifier,
        originalDimensions
    ]);
    const { preview: preview, status: previewStatus, error: previewError, nonCriticalError: nonCriticalError, ssrReliability: ssrReliability, onImageError: onImageErrorBase, onImageLoad: onImageLoadBase, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $9vt4W.useFilePreview)({
        initialFileState: initialFileState,
        useSrcSet: true,
        mediaBlobUrlAttrs: mediaBlobUrlAttrs,
        resizeMode: (0, $72179768a80dbdc7$export$dc1fb2767ac9a82f)(resizeMode),
        identifier: identifier,
        ssr: ssr,
        dimensions: previewDimensions,
        traceContext: traceContext,
        skipRemote: !isCardVisible,
        source: 'mediaCard'
    });
    const shouldSendPerformanceEvent = (0, $cozmU.useMemo)(()=>(0, $b1777cf9f57cea43$export$b21c64f4f93d10f4)(), []);
    // UFO experience hook - creates a unique experience instance per card
    const ufoExperience = (0, $b1777cf9f57cea43$export$a42e845f664e6373)({
        instanceId: internalOccurrenceKey,
        enabled: shouldSendPerformanceEvent
    });
    const [error, setError] = (0, $cozmU.useState)();
    // CXP-2723 TODO: TEMPORARY VARIABLES
    const finalError = error || (previewError && previewError.primaryReason !== 'failed-processing' && fileStateValue?.mimeType !== 'image/svg+xml' ? previewError : undefined);
    const finalStatus = finalError ? 'error' : status === 'failed-processing' && fileStateValue?.mimeType === 'image/svg+xml' ? 'loading-preview' : status;
    const [mediaViewerSelectedItem, setMediaViewerSelectedItem] = (0, $cozmU.useState)(null);
    const uploadProgressRef = (0, $cozmU.useRef)();
    // Store latest auth provider event (emit with fireOperationalEventRef)
    const pendingAuthProviderEventRef = (0, $cozmU.useRef)(null);
    const metadata = (0, $cozmU.useMemo)(()=>{
        const getProcessingStatusFromFileState = (status)=>{
            switch(status){
                case 'processed':
                    return 'succeeded';
                case 'processing':
                    return 'running';
                case 'failed-processing':
                    return 'failed';
            }
        };
        const resolvedFallbackName = (0, $ieeJu.expValEquals)('platform_editor_media_name_fallback_viewer_card', 'isEnabled', true) ? fallbackMediaName : undefined;
        if ((0, $iDrrr.fg)('dfo_attachments_late_render_fix')) {
            if (fileStateValue) return {
                id: fileStateValue.id,
                name: fileStateValue.name || resolvedFallbackName || ssrItemDetails && ssrItemDetails.filename,
                size: fileStateValue.size,
                mimeType: fileStateValue.mimeType || ssrItemDetails && ssrItemDetails.mimetype,
                createdAt: fileStateValue.createdAt || ssrItemDetails && ssrItemDetails.createdDate,
                mediaType: fileStateValue.mediaType,
                processingStatus: getProcessingStatusFromFileState(fileStateValue.status),
                failReason: fileStateValue.status === 'failed-processing' ? fileStateValue.failReason : undefined
            };
            else return {
                id: identifier.id,
                name: ssrItemDetails && ssrItemDetails.filename,
                mimeType: ssrItemDetails && ssrItemDetails.mimetype,
                createdAt: ssrItemDetails && ssrItemDetails.createdDate
            };
        } else {
            if (fileStateValue) return {
                id: fileStateValue.id,
                name: fileStateValue.name || resolvedFallbackName,
                size: fileStateValue.size,
                mimeType: fileStateValue.mimeType,
                createdAt: fileStateValue.createdAt,
                mediaType: fileStateValue.mediaType,
                processingStatus: getProcessingStatusFromFileState(fileStateValue.status),
                failReason: fileStateValue.status === 'failed-processing' ? fileStateValue.failReason : undefined
            };
            else return {
                id: identifier.id
            };
        }
    }, [
        fileStateValue,
        identifier.id,
        ssrItemDetails,
        fallbackMediaName
    ]);
    const fileAttributes = (0, $cozmU.useMemo)(()=>{
        return {
            fileMediatype: metadata.mediaType,
            fileMimetype: metadata.mimeType,
            fileId: metadata.id,
            fileSize: metadata.size,
            fileStatus: fileStateValue?.status
        };
    }, [
        fileStateValue?.status,
        metadata.id,
        metadata.mediaType,
        metadata.mimeType,
        metadata.size
    ]);
    const downloadFn = (0, $cozmU.useCallback)(async ()=>{
        try {
            await mediaClient.file.downloadBinary(identifier.id, metadata.name, identifier.collectionName, traceContext);
            (0, $d979a62f4316adbb$export$8f39639231268ced)(createAnalyticsEvent, fileAttributes, traceContext, fileStateValue?.metadataTraceContext);
        } catch (e) {
            const error = new (0, $lE37M.MediaCardError)('download', e);
            (0, $b5b2db596fe4d98c$export$f0368e92a624442a)(createAnalyticsEvent, fileAttributes, error, traceContext, fileStateValue?.metadataTraceContext);
        }
    }, [
        createAnalyticsEvent,
        fileAttributes,
        fileStateValue?.metadataTraceContext,
        identifier.collectionName,
        identifier.id,
        mediaClient.file,
        metadata.name,
        traceContext
    ]);
    const computedActions = (0, $cozmU.useMemo)(()=>{
        if (finalStatus === 'failed-processing' || shouldEnableDownloadButton) {
            const handler = async ()=>{
                if (!!fileStateValue?.abuseClassification) setIsAbuseModalOpen(true);
                else await downloadFn();
            };
            const downloadAction = (0, $8987c014fc265b4d$export$948607b7587fecda)({
                handler: handler,
                isDisabled: mediaClient.config.enforceDataSecurityPolicy
            }, formatMessage);
            return [
                downloadAction,
                ...actions ?? []
            ];
        } else return actions;
    }, [
        actions,
        mediaClient.config.enforceDataSecurityPolicy,
        shouldEnableDownloadButton,
        finalStatus,
        formatMessage,
        fileStateValue?.abuseClassification,
        downloadFn
    ]);
    //----------------------------------------------------------------//
    //---------------------- Analytics  ------------------------------//
    //----------------------------------------------------------------//
    const fireOperationalEventRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(()=>{
        const timeElapsedTillEvent = (0, $3e572fb39a9ad3b7$export$fb4230f160368c88)();
        const durationSinceCommenced = timeElapsedTillEvent - timeElapsedTillCommenced;
        const performanceAttributes = {
            overall: {
                durationSincePageStart: timeElapsedTillEvent,
                durationSinceCommenced: durationSinceCommenced
            }
        };
        createAnalyticsEvent && (0, $8e75bfb8f08c73f3$export$a1fb57756f0de62b)(createAnalyticsEvent, finalStatus, fileAttributes, performanceAttributes, ssrReliability, finalError, traceContext, fileStateValue?.metadataTraceContext, metadata.failReason);
        // Emit stored auth provider events when card reaches final state
        if (createAnalyticsEvent && pendingAuthProviderEventRef.current && [
            'complete',
            'error',
            'failed-processing'
        ].includes(finalStatus) && (0, $iDrrr.fg)('platform_media_auth_provider_analytics')) {
            const authEvent = pendingAuthProviderEventRef.current;
            // Sample auth-provider-succeeded events at 10%
            const shouldSampleAuthProviderSucceeded = ()=>Math.random() < 0.1;
            if (authEvent.type === 'succeeded') // Emit success events when card completes (or errors - auth can succeed even if card fails)
            {
                if (shouldSampleAuthProviderSucceeded()) (0, $lvxKi.fireMediaCardEvent)((0, $ad136eeff4726044$export$8ae7a3e1eee1037e)(authEvent.payload.durationMs, authEvent.payload.timeoutMs, authEvent.payload.authContext), createAnalyticsEvent);
            } else if (authEvent.type === 'failed') // Always emit failed events (no sampling)
            (0, $lvxKi.fireMediaCardEvent)((0, $c99acdd5d5bcf060$export$ad4b9061e2cb7f76)(authEvent.payload.durationMs, authEvent.payload.timeoutMs, authEvent.payload.error, authEvent.payload.authContext), createAnalyticsEvent);
            pendingAuthProviderEventRef.current = null;
        }
        // Determine SSR preview info for UFO timing strategy
        // wasSSRAttempted is only true when SSR was used AND preview exists AND preview is non-lazy
        // because lazy SSR defers loading, so it behaves like CSR for timing purposes
        // We also require preview to exist to avoid false positives when:
        // 1. ssr='client' but no SSR data exists (client-side navigation)
        // 2. Non-previewable files (e.g., zip files) where no preview is generated
        const isSSRNonLazy = !!ssr && !!preview && preview.lazy !== true;
        const wasSSRSuccessful = isSSRNonLazy && (ssrReliability.server?.status === 'success' || ssrReliability.client?.status === 'success');
        const ssrPreviewInfo = {
            dataUri: preview?.dataURI,
            srcset: preview?.srcSet,
            wasSSRAttempted: isSSRNonLazy,
            wasSSRSuccessful: wasSSRSuccessful
        };
        ufoExperience.complete(finalStatus, fileAttributes, fileStateFlagsRef.current, ssrReliability, finalError, ssrPreviewInfo);
    });
    const fireNonCriticalErrorEventRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)((error)=>{
        createAnalyticsEvent && (0, $ce69b14ba8a22ee4$export$6505e60579e04cbd)(createAnalyticsEvent, finalStatus, fileAttributes, ssrReliability, error, traceContext, fileStateValue?.metadataTraceContext);
    });
    (0, $cozmU.useEffect)(()=>{
        if (nonCriticalError) fireNonCriticalErrorEventRef.current(nonCriticalError);
    }, [
        nonCriticalError,
        fireNonCriticalErrorEventRef
    ]);
    const startUfoExperienceRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(()=>{
        // For non-lazy SSR previews, use interaction start time as the experience start time
        // because the image loading started at interaction start, not at mount time
        const isSSRNonLazy = !!ssr && preview?.lazy !== true;
        ufoExperience.start({
            useInteractionTime: isSSRNonLazy
        });
    });
    const fireAbortedEventRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(()=>{
        // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
        ufoExperience.abort({
            fileAttributes: fileAttributes,
            fileStateFlags: fileStateFlagsRef?.current,
            ssrReliability: ssrReliability
        });
    });
    // Listen to auth provider events and store them (don't emit yet)
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('platform_media_auth_provider_analytics')) return;
        const onAuthSuccess = (payload)=>{
            // Store latest auth provider event for later emission when card status changes
            pendingAuthProviderEventRef.current = {
                type: 'succeeded',
                payload: payload
            };
        };
        const onAuthFailed = (payload)=>{
            // Store latest auth provider event for later emission when card status changes
            pendingAuthProviderEventRef.current = {
                type: 'failed',
                payload: payload
            };
        };
        (0, $hfrng.globalMediaEventEmitter).on('auth-provider-succeeded', onAuthSuccess);
        (0, $hfrng.globalMediaEventEmitter).on('auth-provider-failed', onAuthFailed);
        return ()=>{
            (0, $hfrng.globalMediaEventEmitter).off('auth-provider-succeeded', onAuthSuccess);
            (0, $hfrng.globalMediaEventEmitter).off('auth-provider-failed', onAuthFailed);
        };
    }, []);
    //----------------------------------------------------------------//
    //--------------------- Handling Errors---------------------------//
    //----------------------------------------------------------------//
    (0, $cozmU.useEffect)(()=>{
        if (onErrorRef.current && finalError) {
            const errorReason = finalError.primaryReason;
            onErrorRef.current(errorReason);
        }
    }, [
        finalError,
        onErrorRef
    ]);
    //----------------------------------------------------------------//
    //--------------------- Focus on Close Viewer  -------------------//
    //----------------------------------------------------------------//
    const wasViewerPreviouslyOpen = (0, $5912457c5c879fd6$export$5cae361ad82dce8b)(mediaViewerSelectedItem);
    (0, $cozmU.useEffect)(()=>{
        if (wasViewerPreviouslyOpen && !mediaViewerSelectedItem) mediaViewerButtonRef.current?.focus();
    }, [
        wasViewerPreviouslyOpen,
        mediaViewerSelectedItem
    ]);
    //----------------------------------------------------------------//
    //---------------------- Callbacks & Handlers  -------------------//
    //----------------------------------------------------------------//
    const onSvgError = (error)=>{
        setError(error);
        setStatus('error');
    };
    const onImageError = (newCardPreview)=>{
        if (metadata.mimeType === 'image/svg+xml') return;
        onImageErrorBase(newCardPreview);
    };
    const onSvgLoad = ()=>{
        setPreviewDidRender(true);
        onPreviewRender?.(identifier.id);
    };
    const onImageLoad = (newCardPreview)=>{
        if (metadata.mimeType === 'image/svg+xml') return;
        onImageLoadBase(newCardPreview);
        setPreviewDidRender(true);
        onPreviewRender?.(identifier.id);
    };
    const onCardClick = (event, analyticsEvent)=>{
        if (onClick) {
            const cardEvent = {
                event: event,
                mediaItemDetails: metadata
            };
            onClick(cardEvent, analyticsEvent);
        }
    };
    const onCardViewClick = (event, analyticsEvent)=>{
        onCardClick(event, analyticsEvent);
        if (!metadata) return;
        const isVideo = metadata.mediaType === 'video';
        const isBrowserSupported = metadata.mimeType && (0, $9OT81.isMimeTypeSupportedByBrowser)(metadata.mimeType);
        // TODO: this should be handled by Inline Player
        const isPlayable = !!fileState && (fileState.status === 'processed' || isBrowserSupported && [
            'processing',
            'uploading'
        ].includes(fileState.status));
        if (useInlinePlayer && isVideo && isPlayable && finalStatus !== 'error') {
            setIsPlayingFile(true);
            setShouldAutoplay(true);
        } else if (shouldOpenMediaViewer) setMediaViewerSelectedItem({
            id: identifier.id,
            mediaItemType: 'file',
            collectionName: identifier.collectionName,
            occurrenceKey: identifier.occurrenceKey
        });
        // Abort VC when click file card
        pressTracing();
    };
    //----------------------------------------------------------------//
    //----------------- update status flags --------------------------//
    //----------------------------------------------------------------//
    (0, $cozmU.useEffect)(()=>{
        if (fileStateValue?.status === 'processing') fileStateFlagsRef.current.wasStatusProcessing = true;
        else if (fileStateValue?.status === 'uploading') fileStateFlagsRef.current.wasStatusUploading = true;
    }, [
        fileStateValue?.status
    ]);
    //----------------------------------------------------------------//
    //---------------- fetch and resolve card preview ----------------//
    //----------------------------------------------------------------//
    const prevStatus = (0, $5912457c5c879fd6$export$5cae361ad82dce8b)(finalStatus);
    const prevIsCardVisible = (0, $5912457c5c879fd6$export$5cae361ad82dce8b)(isCardVisible);
    (0, $cozmU.useEffect)(()=>{
        if (prevStatus !== undefined && finalStatus !== prevStatus) fireOperationalEventRef.current();
    }, [
        fireOperationalEventRef,
        prevStatus,
        finalStatus
    ]);
    (0, $cozmU.useEffect)(()=>{
        const turnedVisible = !prevIsCardVisible && isCardVisible;
        if (turnedVisible) startUfoExperienceRef.current();
    }, [
        startUfoExperienceRef,
        isCardVisible,
        prevIsCardVisible
    ]);
    //----------------------------------------------------------------//
    //----------------- set isPlayingFile state ----------------------//
    //----------------------------------------------------------------//
    (0, $cozmU.useEffect)(()=>{
        const isVideo = fileAttributes.fileMediatype === 'video';
        const { mimeType: mimeType } = (0, $78ee54fc22387b2c$export$7e125c11d42de4d1)(identifier, fileStateValue);
        const isVideoPlayable = mimeType && (0, $nfEzS.isVideoMimeTypeSupportedByBrowser)(mimeType) || fileStateValue && (0, $4W5SH.isProcessedFileState)(fileStateValue);
        if (/**
     * We need to check that the card is visible before switching to inline player
     * in order to avoid race conditions of the ViewportDector being unmounted before
     * it is able to set isCardVisible to true.
     */ isCardVisible && isVideo && !isPlayingFile && disableOverlay && useInlinePlayer && isVideoPlayable && fileStateValue?.status !== 'failed-processing' && finalStatus !== 'error') setIsPlayingFile(true);
    }, [
        isCardVisible,
        disableOverlay,
        fileAttributes.fileMediatype,
        fileStateValue,
        identifier,
        isPlayingFile,
        finalStatus,
        useInlinePlayer
    ]);
    //----------------------------------------------------------------//
    //----------------- abort UFO experience -------------------------//
    //----------------------------------------------------------------//
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            fireAbortedEventRef.current();
        };
    }, [
        fireAbortedEventRef
    ]);
    //----------------------------------------------------------------//
    // Update Status
    //----------------------------------------------------------------//
    const updateFileStateRef = (0, $5442f05c22e04adc$export$b3e10e1f0fbb71db)(()=>{
        // This effect has race condition with Complete effect. We share the same check to ovid status overrides
        // do not update the card status if the status is final
        if ([
            'complete',
            'error',
            'failed-processing'
        ].includes(finalStatus)) return;
        if (previewDidRender && // We should't complete if status is uploading
        [
            'loading-preview',
            'processing'
        ].includes(finalStatus)) setStatus('complete');
        else if (fileState) {
            if (fileState.status !== 'error') {
                let newStatus;
                switch(fileState.status){
                    case 'uploading':
                    case 'failed-processing':
                    case 'processing':
                        newStatus = fileState.status;
                        break;
                    case 'processed':
                        // Set complete if processing is done and there is no preview
                        if (!preview && previewStatus === 'complete') {
                            newStatus = 'complete';
                            break;
                        }
                        newStatus = 'loading-preview';
                        break;
                    default:
                        newStatus = 'loading';
                }
                const newProgress = newStatus === 'uploading' && fileState.status === 'uploading' ? fileState.progress : 1;
                setStatus(newStatus);
                uploadProgressRef.current = newProgress;
            } else {
                const e = (0, $7ZjkB.toCommonMediaClientError)(fileState);
                const errorReason = finalStatus === 'uploading' ? 'upload' : 'metadata-fetch';
                setError(new (0, $lE37M.MediaCardError)(errorReason, e));
                setStatus('error');
            }
        }
    });
    const mergedRef = (0, $2VwyL.useMergeRefs)([
        setCardElement,
        copyNodeRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        updateFileStateRef.current();
    }, [
        fileState,
        preview,
        previewStatus,
        updateFileStateRef,
        previewDidRender,
        finalStatus
    ]);
    //----------------------------------------------------------------//
    // Shared Card View & SVG View resources
    //----------------------------------------------------------------//
    const mediaCardCursor = (0, $79c9f6957b6516ad$export$c364ca3a4cf16be0)(!!useInlinePlayer, !!shouldOpenMediaViewer, finalStatus === 'error' || finalStatus === 'failed-processing', !!preview, metadata.mediaType);
    const onImageMouseEnter = (event)=>{
        onMouseEnter?.({
            event: event,
            mediaItemDetails: metadata
        });
    };
    const onImageFocus = (event)=>{
        if (!(0, $4603370344b0d7ea$export$a133018935bd25fc)(event)) return;
        onFocus?.({
            event: event,
            mediaItemDetails: metadata
        });
    };
    //----------------------------------------------------------------//
    //---------------------- Render Card Function --------------------//
    //----------------------------------------------------------------//
    const renderCard = (withCallbacks = true, cardStatusOverride, izLazyOverride)=>{
        const { mediaItemType: mediaItemType } = identifier;
        const isLazyWithOverride = izLazyOverride === undefined ? isLazy : izLazyOverride;
        let isLazyPreview = (0, $iDrrr.fg)('media-perf-lazy-loading-optimisation') ? preview?.lazy : true;
        // We should natively lazy load an SSR preview when card is not visible,
        // otherwise we'll fire the metadata fetch from outside the viewport
        // Side note: We should not lazy load if the cardPreview is available from local cache,
        // in order to avoid flickers during re-mount of the component
        // CXP-2723 TODO: Create test cases for the above scenarios
        const nativeLazyLoad = isLazyWithOverride && ((0, $iDrrr.fg)('media-perf-uplift-mutation-fix') || !isCardVisible) && preview && (0, $1d730199f4951739$export$dea79d05143ccf4)(preview) && isLazyPreview;
        // Force Media Image to always display img for SSR
        const forceSyncDisplay = !!ssr;
        const card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd3933024dfee84$export$7e52c821f7b6f422), {
            identifier: identifier,
            status: cardStatusOverride || finalStatus,
            error: finalError,
            mediaItemType: mediaItemType,
            metadata: metadata,
            cardPreview: preview,
            alt: alt,
            resizeMode: resizeMode,
            dimensions: cardDimensions,
            actions: computedActions,
            selectable: selectable,
            selected: selected,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            openMediaViewerButtonRef: mediaViewerButtonRef,
            onClick: withCallbacks ? onCardViewClick : undefined,
            onMouseEnter: withCallbacks ? onImageMouseEnter : undefined,
            onFocus: withCallbacks ? onImageFocus : undefined,
            disableOverlay: disableOverlay,
            progress: uploadProgressRef.current,
            onDisplayImage: withCallbacks ? ()=>{
                const payloadPart = {
                    fileId: identifier.id,
                    isUserCollection: identifier.collectionName === (0, $fkYei.RECENTS_COLLECTION)
                };
                (0, $hfrng.globalMediaEventEmitter).emit('media-viewed', {
                    viewingLevel: 'minimal',
                    ...payloadPart
                });
            } : undefined,
            innerRef: mergedRef,
            testId: testId,
            titleBoxBgColor: titleBoxBgColor,
            titleBoxIcon: titleBoxIcon,
            backgroundColor: backgroundColor,
            onImageError: withCallbacks ? onImageError : undefined,
            onImageLoad: withCallbacks ? onImageLoad : undefined,
            onSvgError: onSvgError,
            onSvgLoad: onSvgLoad,
            nativeLazyLoad: nativeLazyLoad,
            forceSyncDisplay: forceSyncDisplay,
            traceId: traceContext.traceId,
            mediaCardCursor: mediaCardCursor,
            shouldHideTooltip: shouldHideTooltip,
            overriddenCreationDate: overridenDate,
            isAIGenerating: isAIGenerating,
            isCWR: isCWR
        });
        return isLazyWithOverride ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $242ffb0351fb7355$export$35aa735df177ee7c), {
            cardEl: cardElement,
            onVisible: ()=>{
                setIsCardVisible(true);
            }
        }, card) : card;
    };
    //----------------------------------------------------------------//
    //-------------------------- RENDER ------------------------------//
    //----------------------------------------------------------------//
    const inlinePlayerFallback = isPlayingFile ? renderCard(false, 'loading', false) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    const collectionName = identifier.collectionName || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !!fileStateValue?.abuseClassification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXEmz.AbuseModal), {
        isOpen: isAbuseModalOpen,
        onConfirm: downloadFn,
        onClose: ()=>setIsAbuseModalOpen(false)
    }), isPlayingFile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: inlinePlayerFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $789ed0202163a4ea$export$c7e2887eae92d53c), {
        dimensions: cardDimensions,
        originalDimensions: originalDimensions,
        identifier: identifier,
        autoplay: !!shouldAutoplay,
        onFullscreenChange: onFullscreenChange,
        onError: (e)=>{
            setError(new (0, $lE37M.MediaCardError)('error-file-state', e));
            setStatus('error');
            setIsPlayingFile(false);
        },
        onClick: onCardClick,
        selected: selected,
        ref: setCardElement,
        testId: testId,
        cardPreview: preview,
        videoControlsWrapperRef: videoControlsWrapperRef
    })) : renderCard(), mediaViewerSelectedItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1tBud.default), {
        collectionName: collectionName,
        items: mediaViewerItems || [],
        mediaClientConfig: mediaClient.config,
        selectedItem: mediaViewerSelectedItem,
        onClose: ()=>{
            setMediaViewerSelectedItem(null);
        },
        contextId: contextId,
        featureFlags: featureFlags,
        viewerOptions: viewerOptions,
        extensions: mediaViewerExtensions,
        fallbackMediaNameFetcher: fallbackMediaNameFetcher
    }) : null, getSsrScriptProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", getSsrScriptProps()));
};


const $a95d52cf711ba5dd$export$7a6ccaf429ad93a8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let identifier;
    let otherProps;
    if ($[0] !== t0) {
        ({ identifier: identifier, ...otherProps } = t0);
        $[0] = t0;
        $[1] = identifier;
        $[2] = otherProps;
    } else {
        identifier = $[1];
        otherProps = $[2];
    }
    let t1;
    if ($[3] !== identifier || $[4] !== otherProps) {
        t1 = (0, $jmmTp.isFileIdentifier)(identifier) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
            name: "media-card-file-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $26dcc9ddee9fe0e5$export$593fd10f7e6c6505), {
            ...otherProps,
            identifier: identifier,
            key: identifier.id
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
            name: "media-card-external-image"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b94e7f214bbb485b$export$b7c988f139757a90), {
            ...otherProps,
            identifier: identifier,
            key: identifier.dataURI
        }));
        $[3] = identifier;
        $[4] = otherProps;
        $[5] = t1;
    } else t1 = $[5];
    const innerContent = t1;
    let t2;
    if ($[6] !== innerContent || $[7] !== otherProps.intl) {
        t2 = otherProps.intl ? innerContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: "en"
        }, innerContent);
        $[6] = innerContent;
        $[7] = otherProps.intl;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ identifier: identifier, ...otherProps })=>{
    const innerContent = (0, $jmmTp.isFileIdentifier)(identifier) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
        name: "media-card-file-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $26dcc9ddee9fe0e5$export$593fd10f7e6c6505), {
        ...otherProps,
        identifier: identifier,
        key: identifier.id
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
        name: "media-card-external-image"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b94e7f214bbb485b$export$b7c988f139757a90), {
        ...otherProps,
        identifier: identifier,
        key: identifier.dataURI
    }));
    return otherProps.intl ? innerContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: "en"
    }, innerContent);
};


const $e4900001cda6628b$export$ec84c9f4597a734b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useEffect)($e4900001cda6628b$var$_temp, t0);
    let t1;
    let t2;
    if ($[1] !== createAnalyticsEvent) {
        t1 = ()=>{
            (0, $d729b52366798f4f$export$70c58d75bd83664)(createAnalyticsEvent);
        };
        t2 = [
            createAnalyticsEvent
        ];
        $[1] = createAnalyticsEvent;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== props) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a95d52cf711ba5dd$export$7a6ccaf429ad93a8), props);
        $[4] = props;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        (0, $259d2a177a7c7a3c$export$8840d7cbe19419a0)();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        (0, $d729b52366798f4f$export$70c58d75bd83664)(createAnalyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a95d52cf711ba5dd$export$7a6ccaf429ad93a8), props);
};
function $e4900001cda6628b$var$_temp() {
    (0, $259d2a177a7c7a3c$export$8840d7cbe19419a0)();
}


const $b2f5ca4bd75a8f6d$var$packageName = "platform-pkg";
const $b2f5ca4bd75a8f6d$var$packageVersion = "0.0.0-use.local";
const $b2f5ca4bd75a8f6d$export$60332b2344f7fe41 = (0, $iFjll.withMediaAnalyticsContext)({
    packageVersion: $b2f5ca4bd75a8f6d$var$packageVersion,
    packageName: $b2f5ca4bd75a8f6d$var$packageName,
    componentName: 'mediaCard',
    component: 'mediaCard'
})((0, $kSwu1.injectIntl)((0, $e4900001cda6628b$export$ec84c9f4597a734b), {
    enforceContext: false
}));





const $769e9ad3f214a29a$export$91b1a6414631318a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const { dimensions: dimensions, onClick: onClick } = props;
    let t0;
    bb0: {
        if ((0, $iDrrr.fg)("platform_media_video_captions")) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = (0, $bznit.withMediaClientAndSettings)((0, $b2f5ca4bd75a8f6d$export$60332b2344f7fe41));
                $[0] = t1;
            } else t1 = $[0];
            t0 = t1;
            break bb0;
        }
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $g0fSg.withMediaClient)((0, $b2f5ca4bd75a8f6d$export$60332b2344f7fe41));
            $[1] = t1;
        } else t1 = $[1];
        t0 = t1;
    }
    const Card = t0;
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Card, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== dimensions || $[5] !== onClick || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $84497764a98478b6$export$2e2bcd8739ae039), {
            dimensions: dimensions,
            onClick: onClick
        }, t1);
        $[4] = dimensions;
        $[5] = onClick;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (props)=>{
    const { dimensions: dimensions, onClick: onClick } = props;
    const Card = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if ((0, $iDrrr.fg)('platform_media_video_captions')) return (0, $bznit.withMediaClientAndSettings)((0, $b2f5ca4bd75a8f6d$export$60332b2344f7fe41));
        return (0, $g0fSg.withMediaClient)((0, $b2f5ca4bd75a8f6d$export$60332b2344f7fe41));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $84497764a98478b6$export$2e2bcd8739ae039), {
        dimensions: dimensions,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Card, props));
};
module.exports["CardWithMediaClient"] = $769e9ad3f214a29a$export$91b1a6414631318a;

});

parcelRegister("bznit", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");


var $IY7Mb = parcelRequire("IY7Mb");

const $18f5629f38670539$export$ea8f1b8e2d843039 = (Component)=>({ mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings, ...otherProps })=>{
        const parsedSettings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
        const mediaProviderValue = (0, $cozmU.useContext)((0, $hEt1x.MediaContext));
        const mediaClientValue = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
        const mediaContext = (0, $cozmU.useMemo)(()=>({
                mediaClient: mediaProviderValue?.mediaClient ?? mediaClientValue ?? (0, $g9ZnD.getMediaClient)(mediaClientConfig),
                settings: {
                    ...mediaProviderValue?.settings,
                    ...parsedSettings
                }
            }), [
            mediaProviderValue?.settings,
            mediaProviderValue?.mediaClient,
            parsedSettings,
            mediaClientConfig,
            mediaClientValue
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEt1x.MediaContext).Provider, {
            value: mediaContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...otherProps,
            mediaClient: mediaContext.mediaClient,
            mediaSettings: mediaContext.settings
        }));
    };
module.exports["withMediaClientAndSettings"] = $18f5629f38670539$export$ea8f1b8e2d843039;

});

parcelRegister("iFjll", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $lnqxO = parcelRequire("lnqxO");

const $c84c425f2e6f2c69$export$ba0fb5f6ba6ce56c = (contextPublicAttributes)=>(WrappedComponent)=>{
        // forwardRef() allows passing React refs to the wrapped component WithMediaAnalyticsContext
        const WithMediaAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
            const $ = (0, $bDgLe.c)(10);
            const { featureFlags: featureFlags } = props;
            let t0;
            if ($[0] !== featureFlags) {
                t0 = {
                    featureFlags: featureFlags
                };
                $[0] = featureFlags;
                $[1] = t0;
            } else t0 = $[1];
            const contextPrivateAttributes = t0;
            let t1;
            if ($[2] !== contextPrivateAttributes) {
                t1 = {
                    ...contextPublicAttributes,
                    [(0, $lnqxO.MEDIA_CONTEXT)]: {
                        ...contextPrivateAttributes
                    }
                };
                $[2] = contextPrivateAttributes;
                $[3] = t1;
            } else t1 = $[3];
            const contextData = t1;
            let t2;
            if ($[4] !== props || $[5] !== ref) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...props,
                    ref: ref
                });
                $[4] = props;
                $[5] = ref;
                $[6] = t2;
            } else t2 = $[6];
            let t3;
            if ($[7] !== contextData || $[8] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: contextData
                }, t2);
                $[7] = contextData;
                $[8] = t2;
                $[9] = t3;
            } else t3 = $[9];
            return t3;
        } : (props, ref)=>{
            const { featureFlags: featureFlags } = props;
            const contextData = (0, $cozmU.useMemo)(()=>{
                const contextPrivateAttributes = {
                    featureFlags: featureFlags
                };
                return {
                    ...contextPublicAttributes,
                    [(0, $lnqxO.MEDIA_CONTEXT)]: {
                        ...contextPrivateAttributes
                    }
                };
            }, [
                featureFlags
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: contextData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                ref: ref
            }));
        });
        WithMediaAnalyticsContext.displayName = `WithMediaAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithMediaAnalyticsContext;
    };
module.exports["withMediaAnalyticsContext"] = $c84c425f2e6f2c69$export$ba0fb5f6ba6ce56c;

});

parcelRegister("lvxKi", function(module, exports) {

var $8lZ3h = parcelRequire("8lZ3h");

var $2rEyz = parcelRequire("2rEyz");

function $425fcecec0878028$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $2rEyz.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $8lZ3h.ANALYTICS_MEDIA_CHANNEL));
    }
}
module.exports["fireMediaCardEvent"] = $425fcecec0878028$export$60729f3fb03dcecc;

});

parcelRegister("8lZ3h", function(module, exports) {
const $934af7640853e7fb$export$ec1779cb96554e1 = 'media';
module.exports["ANALYTICS_MEDIA_CHANNEL"] = $934af7640853e7fb$export$ec1779cb96554e1;

});

parcelRegister("2rEyz", function(module, exports) {

var $opqdo = parcelRequire("opqdo");


var $l7Nkn = parcelRequire("l7Nkn");

const $43d0ef8377571650$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, $l7Nkn.isValidUuid)(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $43d0ef8377571650$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $43d0ef8377571650$export$e24d38cbdf73bc1a = (payload)=>$43d0ef8377571650$var$hasFileAttributesWithFileId(payload) ? (0, $opqdo.produce)(payload, $43d0ef8377571650$var$sanitiseFileId) : payload;
module.exports["sanitiseAnalyticsPayload"] = $43d0ef8377571650$export$e24d38cbdf73bc1a;

});

parcelRegister("lE37M", function(module, exports) {
class $fade39aa9c7e5469$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
module.exports["MediaCardError"] = $fade39aa9c7e5469$export$ec8d022824f41295;

});

parcelRegister("5WRnQ", function(module, exports) {

var $1NnT0 = parcelRequire("1NnT0");


var $6BPje = parcelRequire("6BPje");


var $gTT5f = parcelRequire("gTT5f");


var $gLtu4 = parcelRequire("gLtu4");

const $96a21550b1c0bfe6$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: (0, $gLtu4.getRenderErrorFailReason)(error),
        error: (0, $gTT5f.getRenderErrorErrorReason)(error),
        errorDetail: (0, $6BPje.getRenderErrorErrorDetail)(error),
        metadataTraceContext: metadataTraceContext ?? (0, $1NnT0.getErrorTraceContext)(error)
    };
};
module.exports["extractErrorInfo"] = $96a21550b1c0bfe6$export$74aaf4784c2edb2c;

});

parcelRegister("1NnT0", function(module, exports) {

var $1wzQC = parcelRequire("1wzQC");

const $8bdef540a4878bc7$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
module.exports["getErrorTraceContext"] = $8bdef540a4878bc7$export$29aa614726672b2e;

});

parcelRegister("6BPje", function(module, exports) {

var $1wzQC = parcelRequire("1wzQC");

const $581f5aededb14817$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
module.exports["getRenderErrorErrorDetail"] = $581f5aededb14817$export$9ccc5365d056da4b;

});

parcelRegister("gTT5f", function(module, exports) {

var $1wzQC = parcelRequire("1wzQC");

const $ef7ce296c31a47d4$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
module.exports["getRenderErrorErrorReason"] = $ef7ce296c31a47d4$export$88c61dcad53762da;

});

parcelRegister("gLtu4", function(module, exports) {
const $32d4722909f58f32$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
module.exports["getRenderErrorFailReason"] = $32d4722909f58f32$export$4af9d71992e89714;

});

parcelRegister("7va5E", function(module, exports) {
class $c5356b9848e62fca$export$c4ae8d1d12c193a7 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
module.exports["MediaSVGError"] = $c5356b9848e62fca$export$c4ae8d1d12c193a7;

});

parcelRegister("gZ5vW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $h7nb4 = parcelRequire("h7nb4");


var $lNvN4 = parcelRequire("lNvN4");


var $eBH0I = parcelRequire("eBH0I");


var $dnEr2 = parcelRequire("dnEr2");


var $7va5E = parcelRequire("7va5E");

// We need to convert the blob into Base64 for security reasons: https://asecurityteam.atlassian.net/browse/VULN-1495952
// Make sure to update the test helper mockFileReader if this is changed
function $1a2e41c8b0822ebe$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(// reader.readAsDataURL makes reader.result a string
            // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            reader.result);
        reader.onerror = (e)=>reject(new (0, $7va5E.MediaSVGError)('blob-to-datauri', e instanceof Error ? e : undefined));
        reader.readAsDataURL(blob);
    });
}
const $1a2e41c8b0822ebe$var$getLocalSvg = async (preview)=>{
    const { value: value } = await preview;
    if (typeof value === 'string') return value;
    return $1a2e41c8b0822ebe$var$blobToBase64(value);
};
const $1a2e41c8b0822ebe$var$getRemoteSvg = async ({ id: id, collectionName: collectionName }, mediaClient)=>{
    const blob = await mediaClient.mediaStore.getFileBinary(id, collectionName).catch((e)=>{
        throw new (0, $7va5E.MediaSVGError)('binary-fetch', e instanceof Error ? e : undefined);
    });
    return await $1a2e41c8b0822ebe$var$blobToBase64(blob);
};
const $1a2e41c8b0822ebe$export$d127d14f68c2bbcf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (identifier, onError)=>{
    const $ = (0, $bDgLe.c)(16);
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const { id: id, collectionName: collectionName } = identifier;
    const { id: prevId } = (0, $dnEr2.usePrevious)(identifier) || identifier;
    let t0;
    if ($[0] !== collectionName) {
        t0 = {
            collectionName: collectionName
        };
        $[0] = collectionName;
        $[1] = t0;
    } else t0 = $[1];
    const { fileState: fileState } = (0, $h7nb4.useFileState)(id, t0);
    const [svgUrl, setSvgUrl] = (0, $cozmU.useState)(undefined);
    const [source, setSource] = (0, $cozmU.useState)(undefined);
    const onErrorRef = (0, $eBH0I.useCurrentValueRef)(onError);
    let t1;
    let t2;
    if ($[2] !== id || $[3] !== prevId) {
        t1 = ()=>{
            if (id !== prevId) setSvgUrl(undefined);
        };
        t2 = [
            id,
            prevId
        ];
        $[2] = id;
        $[3] = prevId;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[6] !== fileState || $[7] !== identifier || $[8] !== mediaClient || $[9] !== onErrorRef || $[10] !== svgUrl) {
        t3 = ()=>{
            if (svgUrl || !fileState || fileState.status === "error" || fileState?.mimeType !== "image/svg+xml") return;
            const { preview: preview } = fileState;
            if (preview) $1a2e41c8b0822ebe$var$getLocalSvg(preview).then((content)=>{
                setSvgUrl(content);
                setSource("local");
            }).catch(onErrorRef.current);
            else $1a2e41c8b0822ebe$var$getRemoteSvg(identifier, mediaClient).then((content_0)=>{
                setSvgUrl(content_0);
                setSource("remote");
            }).catch(onErrorRef.current);
        };
        t4 = [
            identifier,
            fileState,
            mediaClient,
            onErrorRef,
            svgUrl
        ];
        $[6] = fileState;
        $[7] = identifier;
        $[8] = mediaClient;
        $[9] = onErrorRef;
        $[10] = svgUrl;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[13] !== source || $[14] !== svgUrl) {
        t5 = {
            svgUrl: svgUrl,
            source: source
        };
        $[13] = source;
        $[14] = svgUrl;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : (identifier, onError)=>{
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const { id: id, collectionName: collectionName } = identifier;
    const { id: prevId } = (0, $dnEr2.usePrevious)(identifier) || identifier;
    const { fileState: fileState } = (0, $h7nb4.useFileState)(id, {
        collectionName: collectionName
    });
    const [svgUrl, setSvgUrl] = (0, $cozmU.useState)(undefined);
    const [source, setSource] = (0, $cozmU.useState)(undefined);
    const onErrorRef = (0, $eBH0I.useCurrentValueRef)(onError);
    (0, $cozmU.useEffect)(()=>{
        if (id !== prevId) setSvgUrl(undefined);
    }, [
        id,
        prevId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (svgUrl || !fileState || fileState.status === 'error' || fileState?.mimeType !== 'image/svg+xml') return;
        const { preview: preview } = fileState;
        if (preview) $1a2e41c8b0822ebe$var$getLocalSvg(preview).then((content)=>{
            setSvgUrl(content);
            setSource('local');
        }).catch(onErrorRef.current);
        else $1a2e41c8b0822ebe$var$getRemoteSvg(identifier, mediaClient).then((content_0)=>{
            setSvgUrl(content_0);
            setSource('remote');
        }).catch(onErrorRef.current);
    }, [
        identifier,
        fileState,
        mediaClient,
        onErrorRef,
        svgUrl
    ]);
    return {
        svgUrl: svgUrl,
        source: source
    };
};
module.exports["useResolveSvg"] = $1a2e41c8b0822ebe$export$d127d14f68c2bbcf;

});

parcelRegister("eBH0I", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $e6ddb861e69b21f2$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
module.exports["useCurrentValueRef"] = $e6ddb861e69b21f2$export$b3e10e1f0fbb71db;

});

parcelRegister("dnEr2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $6897b9731d162d11$export$5cae361ad82dce8b(value) {
    const ref = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
module.exports["usePrevious"] = $6897b9731d162d11$export$5cae361ad82dce8b;

});

parcelRegister("lPFwW", function(module, exports) {
const $e5745beed3d41b7a$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
module.exports["size"] = $e5745beed3d41b7a$export$346677f925de839c;

});

parcelRegister("k5Bdp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $fyYZ5 = parcelRequire("fyYZ5");

const $51b4cd47f749a798$export$7b5a7c65f0c5d278 = (progress)=>{
    return Math.min(1, Math.max(0, progress || 0)) * 100;
};





















var $hekY6 = parcelRequire("hekY6");




const $cc740685d1704b6e$var$height = 3;
const $cc740685d1704b6e$var$padding = 1;
const $cc740685d1704b6e$var$width = 95; // %
const $cc740685d1704b6e$var$smallSizeSettings = {
    marginBottom: 4
};
const $cc740685d1704b6e$var$largeSizeSettings = {
    marginBottom: 12
};
function $cc740685d1704b6e$var$generateResponsiveStyles(breakpoint, positionBottom, showOnTop, multiplier = 1) {
    const setting = breakpoint === (0, $fyYZ5.Breakpoint).SMALL ? $cc740685d1704b6e$var$smallSizeSettings : $cc740685d1704b6e$var$largeSizeSettings;
    const marginPositionBottom = (0, $fyYZ5.responsiveSettings)[breakpoint].titleBox.verticalPadding;
    const marginBottom = setting.marginBottom * multiplier + (positionBottom ? marginPositionBottom : (0, $fyYZ5.getTitleBoxHeight)(breakpoint));
    const spacing = `${marginBottom}px`;
    return showOnTop ? {
        top: spacing
    } : {
        bottom: spacing
    };
}
const $cc740685d1704b6e$var$styledBarStyles = null;
const $cc740685d1704b6e$var$styleChild = null;
const $cc740685d1704b6e$export$cb8b5a20ccbacd09 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(17);
    const { progress: progress, breakpoint: breakpoint, positionBottom: positionBottom, showOnTop: showOnTop, ariaLabel: ariaLabel } = props;
    let t0;
    if ($[0] !== breakpoint || $[1] !== positionBottom || $[2] !== showOnTop) {
        t0 = $cc740685d1704b6e$var$generateResponsiveStyles(breakpoint, positionBottom, showOnTop);
        $[0] = breakpoint;
        $[1] = positionBottom;
        $[2] = showOnTop;
        $[3] = t0;
    } else t0 = $[3];
    let t1;
    if ($[4] !== t0) {
        t1 = {
            ...t0
        };
        $[4] = t0;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0Of8r2HZdu _1ZnuxbHZdu _1wydGWHZdu _2Zuz6QHZdu _0bjKvDzXzM _1mT5xdWVPG _39xV02wOVE _3OE6xYOiLO _0KLXruWcyp _0jFU0VyrFs _24h04i2Njc"
        ]);
        $[6] = t2;
    } else t2 = $[6];
    const t3 = `${progress}%`;
    let t4;
    if ($[7] !== t3) {
        t4 = {
            width: t3
        };
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_0bjKvDzXzM _0KLXruESB0 _3iDTPbvLZJ _0jFU0VN91d"
        ]);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t4,
            className: t5
        });
        $[10] = t4;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== ariaLabel || $[13] !== progress || $[14] !== t1 || $[15] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: "styledBar",
            role: "progressbar",
            "aria-valuenow": progress,
            "aria-label": ariaLabel,
            style: t1,
            className: t2
        }, t6);
        $[12] = ariaLabel;
        $[13] = progress;
        $[14] = t1;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : (props)=>{
    const { progress: progress, breakpoint: breakpoint, positionBottom: positionBottom, showOnTop: showOnTop, ariaLabel: ariaLabel } = props;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: "styledBar",
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": ariaLabel,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...$cc740685d1704b6e$var$generateResponsiveStyles(breakpoint, positionBottom, showOnTop)
        },
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0Of8r2HZdu _1ZnuxbHZdu _1wydGWHZdu _2Zuz6QHZdu _0bjKvDzXzM _1mT5xdWVPG _39xV02wOVE _3OE6xYOiLO _0KLXruWcyp _0jFU0VyrFs _24h04i2Njc"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            width: `${progress}%`
        },
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0KLXruESB0 _3iDTPbvLZJ _0jFU0VN91d"
        ])
    }));
};
$cc740685d1704b6e$export$cb8b5a20ccbacd09.displayName = 'StyledProgressBar';


const $c780e6895fcc139c$export$cb8b5a20ccbacd09 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cc740685d1704b6e$export$cb8b5a20ccbacd09), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cc740685d1704b6e$export$cb8b5a20ccbacd09), props);


const $4c664ebdace91d93$export$c17561cb55d4db30 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { progress: progress, breakpoint: t1, positionBottom: t2, showOnTop: t3, ariaLabel: t4 } = t0;
    const breakpoint = t1 === undefined ? (0, $fyYZ5.Breakpoint).SMALL : t1;
    const positionBottom = t2 === undefined ? false : t2;
    const showOnTop = t3 === undefined ? false : t3;
    const ariaLabel = t4 === undefined ? "Loading progress" : t4;
    let t5;
    if ($[0] !== progress) {
        t5 = (0, $51b4cd47f749a798$export$7b5a7c65f0c5d278)(progress);
        $[0] = progress;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== ariaLabel || $[3] !== breakpoint || $[4] !== positionBottom || $[5] !== showOnTop || $[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c780e6895fcc139c$export$cb8b5a20ccbacd09), {
            progress: t5,
            breakpoint: breakpoint,
            positionBottom: positionBottom,
            showOnTop: showOnTop,
            ariaLabel: ariaLabel
        });
        $[2] = ariaLabel;
        $[3] = breakpoint;
        $[4] = positionBottom;
        $[5] = showOnTop;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    return t6;
} : ({ progress: progress, breakpoint: breakpoint = (0, $fyYZ5.Breakpoint).SMALL, positionBottom: positionBottom = false, showOnTop: showOnTop = false, ariaLabel: ariaLabel = 'Loading progress' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c780e6895fcc139c$export$cb8b5a20ccbacd09), {
        progress: (0, $51b4cd47f749a798$export$7b5a7c65f0c5d278)(progress),
        breakpoint: breakpoint,
        positionBottom: positionBottom,
        showOnTop: showOnTop,
        ariaLabel: ariaLabel
    });
};
module.exports["ProgressBar"] = $4c664ebdace91d93$export$c17561cb55d4db30;

});

parcelRegister("7cjAT", function(module, exports) {

var $3vMGL = parcelRequire("3vMGL");


var $4g2zW = parcelRequire("4g2zW");

const $3b27041fa65d5f89$export$f34a3540a1aa68e4 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
};
const $3b27041fa65d5f89$export$3ae94a2503e890a1 = (timestamp, locale = 'en')=>{
    const l10n = (0, $3vMGL.createLocalizationProvider)(locale, $3b27041fa65d5f89$export$f34a3540a1aa68e4);
    return (0, $4g2zW.partsFormatter)(l10n.formatToParts(timestamp));
};
module.exports["formatDate"] = $3b27041fa65d5f89$export$3ae94a2503e890a1;

});

parcelRegister("4g2zW", function(module, exports) {
const $c1b48c4a6023d24b$export$20911720278c41 = ({ day: day, month: month, year: year, hour: hour, minute: minute, dayPeriod: dayPeriod = '' })=>{
    const formattedDayPeriod = dayPeriod.replace(/\./g, '').replace(/\s/g, '');
    return `${day} ${month} ${year}, ${hour}:${minute} ${formattedDayPeriod}`;
};
module.exports["partsFormatter"] = $c1b48c4a6023d24b$export$20911720278c41;

});

parcelRegister("4eMGH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gjPL4 = parcelRequire("gjPL4");


var $igkYX = parcelRequire("igkYX");


var $gG7ZF = parcelRequire("gG7ZF");


var $fyYZ5 = parcelRequire("fyYZ5");

const $696e7c93c46d6075$var$breakpointSizes = [
    [
        (0, $fyYZ5.Breakpoint).SMALL,
        599
    ],
    [
        (0, $fyYZ5.Breakpoint).LARGE,
        Infinity
    ]
];
const $696e7c93c46d6075$export$e1417862e51f29fd = (wrapperWidth = 0)=>{
    const [breakpoint] = $696e7c93c46d6075$var$breakpointSizes.find(([_breakpoint, limit])=>wrapperWidth <= limit) || [
        (0, $fyYZ5.Breakpoint).SMALL
    ];
    return breakpoint;
};


const $1e653d8115d9f523$export$199d6754bdf4e1e3 = (dimensionWidth = 0, divRef)=>{
    const breakpoint = (0, $cozmU.useMemo)(()=>{
        let widthToCalculate;
        if (dimensionWidth) {
            if ((0, $gG7ZF.isValidPercentageUnit)(dimensionWidth) && divRef.current) {
                const width = (0, $igkYX.getElementDimension)(divRef.current, 'width');
                widthToCalculate = width || (0, $gjPL4.defaultImageCardDimensions).width;
            } else widthToCalculate = dimensionWidth;
        } else widthToCalculate = (0, $gjPL4.defaultImageCardDimensions).width;
        return (0, $696e7c93c46d6075$export$e1417862e51f29fd)(parseInt(`${widthToCalculate}`, 10));
    }, [
        dimensionWidth,
        divRef
    ]);
    return breakpoint;
};
module.exports["useBreakpoint"] = $1e653d8115d9f523$export$199d6754bdf4e1e3;

});

parcelRegister("4W5SH", function(module, exports) {
const $1ed736c6d9477d5d$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
module.exports["isProcessedFileState"] = $1ed736c6d9477d5d$export$1d17291aafa5f231;

});

parcelRegister("laLBM", function(module, exports) {

var $8jJxt = parcelRequire("8jJxt");

/**
 * Safely coerce a value to a number, returning undefined if the value is null/undefined.
 */ const $71dbd36bf9b89f62$var$toNumber = (value)=>value == null ? undefined : Number(value);
/**
 * Convert abuse classification fields to the keyed format expected by FileState,
 * returning undefined if either classification or confidence is missing/falsy.
 */ const $71dbd36bf9b89f62$var$toAbuseClassification = (value)=>{
    if (!value || !value.classification || !value.confidence) return undefined;
    return {
        classification: value.classification,
        confidence: value.confidence
    };
};
/**
 * Convert the `artifactsList` array shape into the keyed `MediaFileArtifacts`
 * dict that `MediaItemDetails` / `FileState` consumers expect.
 *
 * Each artifact is keyed by its `name` (e.g. `'image.png'`, `'thumb_120.jpg'`).
 * Artifacts missing required fields (`name`, `url`, `processingStatus`)
 * are skipped rather than coerced — callers should treat absent artifacts as
 * "not yet available" rather than "failed".
 *
 * NOTE: This assumes AGG returns `name` values matching the canonical
 * `MediaFileArtifacts` key vocabulary. If that assumption is broken, the
 * downstream renderer will silently miss SSR thumbnails — verify with a real
 * payload before relying on SSR previews.
 */ const $71dbd36bf9b89f62$var$toArtifacts = (list)=>{
    const out = {};
    if (!list) return out;
    for (const item of list){
        if (!item.name || !item.url || !item.processingStatus) continue;
        const artifact = {
            processingStatus: item.processingStatus,
            url: item.url,
            ...item.mimeType ? {
                mimeType: item.mimeType
            } : {},
            ...item.size != null ? {
                size: Number(item.size)
            } : {},
            ...item.createdAt != null ? {
                createdAt: Number(item.createdAt)
            } : {}
        };
        out[item.name] = artifact;
    }
    return out;
};
const $71dbd36bf9b89f62$export$23e8fc2d3bd88805 = (item)=>{
    try {
        if (!item?.id || !item.details) return undefined;
        const d = item.details;
        const processingStatus = d.processingStatus;
        const mediaType = d.mediaType;
        const size = $71dbd36bf9b89f62$var$toNumber(d.size);
        if (!d.name || !d.mimeType || !mediaType || !processingStatus || size === undefined) return undefined;
        const abuseClassification = $71dbd36bf9b89f62$var$toAbuseClassification(d.abuseClassification);
        const details = {
            name: d.name,
            mimeType: d.mimeType,
            mediaType: mediaType,
            processingStatus: processingStatus,
            size: size,
            artifacts: $71dbd36bf9b89f62$var$toArtifacts(d.artifactsList),
            representations: d.representations?.image ? {
                image: {}
            } : {},
            ...d.failReason ? {
                failReason: d.failReason
            } : {},
            ...d.createdAt != null ? {
                createdAt: Number(d.createdAt)
            } : {},
            ...d.mediaMetadata?.duration != null ? {
                mediaMetadata: {
                    duration: d.mediaMetadata.duration
                }
            } : {},
            ...abuseClassification ? {
                abuseClassification: abuseClassification
            } : {},
            ...d.preview?.cdnUrl ? {
                previewCdnUrl: d.preview.cdnUrl
            } : {}
        };
        return (0, $8jJxt.mapMediaItemToFileState)(item.id, details);
    } catch  {
        // Silently catch any unexpected errors and return undefined
        return undefined;
    }
};
module.exports["mapSsrMediaItemToFileState"] = $71dbd36bf9b89f62$export$23e8fc2d3bd88805;

});

parcelRegister("aXEmz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $fA65V = parcelRequire("fA65V");

const $ca6305bb1f8147e6$export$9b832d04bd876d78 = (0, $kSwu1.injectIntl)(({ isOpen: isOpen, onConfirm: onConfirm, onClose: onClose, intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        testId: "mediaAbuseModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, formatMessage((0, $fA65V.messages).abuse_modal_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, formatMessage((0, $fA65V.messages).abuse_modal_body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $fA65V.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "warning",
        onClick: onConfirm
    }, formatMessage((0, $fA65V.messages).abuse_modal_submit)))));
});
module.exports["AbuseModal"] = $ca6305bb1f8147e6$export$9b832d04bd876d78;

});

parcelRegister("2vxwf", function(module, exports) {

let $1d387a3dcb302113$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1d387a3dcb302113$var$load("6wr18"),
    $1d387a3dcb302113$var$load("jL2Vx"),
    $1d387a3dcb302113$var$load("3N0CO"),
    $1d387a3dcb302113$var$load("hEJ6e"),
    $1d387a3dcb302113$var$load("9RnFD"),
    $1d387a3dcb302113$var$load("jgaRb"),
    $1d387a3dcb302113$var$load("lUDL9"),
    $1d387a3dcb302113$var$load("4bzNN"),
    $1d387a3dcb302113$var$load("ffEVr"),
    $1d387a3dcb302113$var$load("hhss7"),
    $1d387a3dcb302113$var$load("Wowvf"),
    $1d387a3dcb302113$var$load("lkxmG"),
    $1d387a3dcb302113$var$load("7EorR"),
    $1d387a3dcb302113$var$load("7GHHs")
]).then(()=>parcelRequire('f5n26'));

});

parcelRegister("fyYZ5", function(module, exports) {
var $da5037320f3d0815$export$114247090b0aae30 = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint["SMALL"] = "small";
    Breakpoint["LARGE"] = "large";
    return Breakpoint;
}({});
const $da5037320f3d0815$export$195ea22bb2417d03 = {
    ["small"]: {
        fontSize: 11,
        lineHeight: 14,
        titleBox: {
            verticalPadding: 4,
            horizontalPadding: 8
        }
    },
    ["large"]: {
        fontSize: 14,
        lineHeight: 22,
        titleBox: {
            verticalPadding: 8,
            horizontalPadding: 12
        }
    }
};
const $da5037320f3d0815$export$5141d851393c8198 = (breakpoint)=>($da5037320f3d0815$export$195ea22bb2417d03[breakpoint].lineHeight + $da5037320f3d0815$export$195ea22bb2417d03[breakpoint].titleBox.verticalPadding) * 2;
module.exports["Breakpoint"] = $da5037320f3d0815$export$114247090b0aae30;
module.exports["responsiveSettings"] = $da5037320f3d0815$export$195ea22bb2417d03;
module.exports["getTitleBoxHeight"] = $da5037320f3d0815$export$5141d851393c8198;

});

parcelRegister("igkYX", function(module, exports) {
const $04faa0c3f953c5c5$export$5ceade75ca11ae14 = (element, dimension)=>{
    const dimensionValue = element.getBoundingClientRect()[dimension];
    return Math.round(dimensionValue);
};
module.exports["getElementDimension"] = $04faa0c3f953c5c5$export$5ceade75ca11ae14;

});

parcelRegister("gG7ZF", function(module, exports) {
// Utility used to know if the integrator is using percentage values
const $b8b7c02d271eb22e$export$c30ed4dee1ebdfbf = (value)=>{
    const valueString = `${value}`;
    return valueString[valueString.length - 1] === '%' && !isNaN(+valueString.slice(0, -1));
};
module.exports["isValidPercentageUnit"] = $b8b7c02d271eb22e$export$c30ed4dee1ebdfbf;

});


//# sourceMappingURL=cardWithMediaClient.2a2066c3.js.map
